import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  module39wmcymxxg0fj as module_0,
  KoinScopeComponent1dts4xrlxjh8s as KoinScopeComponent,
  KoinPlatformTools_instancee23gtnw2c1jl as KoinPlatformTools_instance,
  getKoin1a1yjjyj0b4v7 as getKoin,
  KoinComponent2sujxij3104ma as KoinComponent,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  startKoin30la02u0gybvw as startKoin,
  stopKoin2aoov7ygurzl5 as stopKoin,
} from './projects-core-koin-core.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  isInterface3d6p8outrmvmk as isInterface,
  lazy1261dae0bgscp as lazy,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString30pk9tzaqopn as toString_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Result3t1vadv16kmzk as Result,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  CancellationException3b36o9qz53rgr as CancellationException,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  listOf1jh22dvmctj1r as listOf,
  listOfvhqybd2zx248 as listOf_0,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  addAll1k27qatfgp3k5 as addAll,
  toSet2orjxp16sotqu as toSet,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$_0,
  plus18eogev54fmsa as plus,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance_0,
  DurationUnit_MINUTES_getInstance3k41vx23snp2i as DurationUnit_MINUTES_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Long2qws0ah9gnpki as Long,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___get_isSuccess__impl__sndoy82z6txcyihce8z as _Result___get_isSuccess__impl__sndoy8,
  createFailure8paxfkfa5dc7 as createFailure,
  Enum3alwj03lh1n41 as Enum,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KtMap140uvy3s5zad8 as KtMap,
  contains3ue2qo8xhmpf1 as contains,
  defineProp3hxgpk2knu2px as defineProp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  toLongw1zpgk99d84b as toLong,
  copyToArray2j022khrow2yi as copyToArray,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$7ps311k1ff73 as LinkedHashMap_init_$Create$,
  to2cs3ny02qtbcb as to,
} from './kotlin-kotlin-stdlib.mjs';
import {
  IClockRepository26nxob36qlael as IClockRepository,
  AttestationRepository2urbmm1459bxp as AttestationRepository,
  HealthCheckRepository3a392dyv8u8y0 as HealthCheckRepository,
  IUserStatusAccessorqt4q4njsukyo as IUserStatusAccessor,
  get_punchModule3iwry7ctva3is as get_punchModule,
  ClockResponse147efja5yzcjq as ClockResponse,
  OnBreak2nwx24726j996 as OnBreak,
  ClockedInhud4qec4hav4 as ClockedIn,
  ClockedOut1s2pj1kq6e899 as ClockedOut,
  TimePunchUserAction_END_BREAK_getInstance3i0kp9qmqf1ov as TimePunchUserAction_END_BREAK_getInstance,
  Location_instance308x7rrsuc6y3 as Location_instance,
  Departmentzzct4e6r4fp as Department,
  Roles62ey455m3o2 as Role,
  QuestionResponse37cr3rtovd30e as QuestionResponse,
  HealthCheckQuestionnaireResponsesauwvwoqz7ax3 as HealthCheckQuestionnaireResponses,
  Status_IN_getInstance3h4ep6fwyc5xe as Status_IN_getInstance,
  Status_OUT_getInstance1d7jb2qds8bbx as Status_OUT_getInstance,
  Location5fymj972tpv5 as Location,
} from './Shared7Punches-data-punch.mjs';
import {
  ILogger102gekz4uf4a8 as ILogger,
  ILoggingProvider3qgs59b4tde8f as ILoggingProvider,
  get_loggingModulez39rttqhqwlz as get_loggingModule,
  Companion_instancebove5hxj27a1 as Companion_instance_0,
} from './Shared7Punches-infrastructure-logging.mjs';
import { IPlanFeatureAccessor1c22ybcggkrw as IPlanFeatureAccessor } from './Shared7Punches-business-domains-billing-domain.mjs';
import { IAnalyticsEventTracker3dt8wr4gltex1 as IAnalyticsEventTracker } from './Shared7Punches-domain-analytics-domain.mjs';
import {
  IAccountActivationRepository1daxwyq2bgwj3 as IAccountActivationRepository,
  IAIImporterAccessor1m62b9z97dole as IAIImporterAccessor,
  IAIImporterMutator36oqdhse10f4m as IAIImporterMutator,
  IEarnedWageAccessDiscoveryAccessor3mjlvw9qbn6qs as IEarnedWageAccessDiscoveryAccessor,
  IEarnedWageAccessDiscoveryMutator17ztrinvi7qwc as IEarnedWageAccessDiscoveryMutator,
  IKnockToJoinAccessor18lz687awqgh1 as IKnockToJoinAccessor,
  IKnockToJoinMutator2x4rhmt524y0w as IKnockToJoinMutator,
  IRefreshAIImporterExtractionStatusUseCase2zq3m42dneye8 as IRefreshAIImporterExtractionStatusUseCase,
  get_accountActivationModule34ya4ftgnq2m4 as get_accountActivationModule,
  get_knockToJoinModule1fzdt45tmzkke as get_knockToJoinModule,
} from './Shared7Punches-data-accountactivation.mjs';
import {
  IActionableRequestsAccessor2ltg3s04f0shv as IActionableRequestsAccessor,
  IGetTrainingStatus3itahdcrzro5f as IGetTrainingStatus,
  get_dashboardModule2kh62t08o3c3i as get_dashboardModule,
} from './Shared7Punches-feature-dashboard.mjs';
import {
  AuthenticationAccessor1pcbwnji0n572 as AuthenticationAccessor,
  IGetSecurityProfileUseCase16ppcw89wixlx as IGetSecurityProfileUseCase,
  IWebViewUrlProvidergdo0vdjldnb1 as IWebViewUrlProvider,
  get_authenticationModuleiq2nf4mpc7rt as get_authenticationModule,
} from './Shared7Punches-data-authentication.mjs';
import {
  IAvailabilityMutator6scppwkpzt4a as IAvailabilityMutator,
  get_availabilityModule325yej4udz930 as get_availabilityModule,
} from './Shared7Punches-data-availability.mjs';
import { ICacheCleaner2xrjdwipcre7v as ICacheCleaner } from './Shared7Punches-infrastructure-cache.mjs';
import {
  IClairSdkAppKeyProvider1y5oia2cqp2x4 as IClairSdkAppKeyProvider,
  PayAccessorv7chehvo6140 as PayAccessor,
  get_payModule2wd4vuq8zftko as get_payModule,
} from './Shared7Punches-data-pay.mjs';
import {
  ICompanyAccessor1vx4gxjmpol6a as ICompanyAccessor,
  IDepartmentAccessor2hj1il6ko3wqn as IDepartmentAccessor,
  IDepartmentInvalidator18hrqq7xwattt as IDepartmentInvalidator,
  IDepartmentMutator259k6elwb9x9i as IDepartmentMutator,
  ILocationAccessor2jiwvdkvuuw23 as ILocationAccessor,
  ILocationMutator1vk25jv8ohj4j as ILocationMutator,
  IReferralAccessor2welacrzpx071 as IReferralAccessor,
  IRoleAccessor21b6uyhytfsm9 as IRoleAccessor,
  IRoleMutator1wgry7o7me1av as IRoleMutator,
  get_coreModule65uf7gnve5b3 as get_coreModule,
} from './Shared7Punches-data-core.mjs';
import {
  ICustomShiftFlagAccessor21oxot5gxdn5a as ICustomShiftFlagAccessor,
  ICustomShiftFlagMutator1702xc1l2rf9w as ICustomShiftFlagMutator,
  IScheduleWarningAccessor3mhssfafpp187 as IScheduleWarningAccessor,
} from './Shared7Punches-domain-scheduling-domain.mjs';
import {
  IFeatureFlagEvaluatorscidb4c0cp4 as IFeatureFlagEvaluator,
  IFeatureFlagOverrider2e91dbyu864rc as IFeatureFlagOverrider,
  FeatureFlagServiceoy7s0oetsvxe as FeatureFlagService,
  get_featureFlagModule2olng1e88stui as get_featureFlagModule,
} from './Shared7Punches-infrastructure-featureflag.mjs';
import {
  IFillScheduleFromTemplateUseCase2kd5yvlstvirm as IFillScheduleFromTemplateUseCase,
  get_schedulingFeatureModule17t7swguggl5i as get_schedulingFeatureModule,
} from './Shared7Punches-feature-schedulingfeature.mjs';
import {
  IWebSocketConnection1czhlczic7d9m as IWebSocketConnection,
  IWebSocketMessenger39ixwrrlxyazo as IWebSocketMessenger,
  get_webSocketModule2juokb138b51a as get_webSocketModule,
} from './Shared7Punches-infrastructure-websocket.mjs';
import {
  ILogBookAccessor2u004tmlu0jp as ILogBookAccessor,
  get_logBookModule1nmhk3kxqtv56 as get_logBookModule,
} from './Shared7Punches-data-logbook.mjs';
import {
  IOvertimeRiskAccessorulrq4mhwwk0i as IOvertimeRiskAccessor,
  get_overtimeRiskModule1y00cf8l5x9k3 as get_overtimeRiskModule,
} from './Shared7Punches-data-overtimerisk.mjs';
import {
  IPayrollRepository3r3v326s8y6w0 as IPayrollRepository,
  get_payrollModule1batjuxuwzt4i as get_payrollModule,
} from './Shared7Punches-data-payroll.mjs';
import {
  IPollingServiceStopper2dkq3n37epmm9 as IPollingServiceStopper,
  get_pollingModule1lzsu7o6x7b4d as get_pollingModule,
} from './Shared7Punches-infrastructure-polling.mjs';
import {
  IResolveClairExperienceUseCase2nel3vlqaxlls as IResolveClairExperienceUseCase,
  get_earnedWageAccessFeatureModule2ejr6u56f80an as get_earnedWageAccessFeatureModule,
} from './Shared7Punches-feature-earnedwageaccess.mjs';
import {
  ISandboxAccessor1z1bzul8o2ia1 as ISandboxAccessor,
  get_sandboxModulerp1j55r8pufg as get_sandboxModule,
} from './Shared7Punches-data-sandbox.mjs';
import {
  ISchedulingMutator2o3geodc2adgx as ISchedulingMutator,
  ITemplateAccessor9ycvy56ntkeh as ITemplateAccessor,
  ITemplateCompositeAccessor3fjc7lkze0e6v as ITemplateCompositeAccessor,
  ITemplateMutator2hgxu9b9sapxu as ITemplateMutator,
  get_schedulingModule3koantibgbov5 as get_schedulingModule,
} from './Shared7Punches-data-scheduling.mjs';
import {
  IShiftCompositeAccessor1yspg8epnn0zc as IShiftCompositeAccessor,
  IShiftMutator12aals7g8731k as IShiftMutator,
} from './Shared7Punches-domain-shift-domain.mjs';
import {
  IShiftDropMutatoryf0dvdej6sad as IShiftDropMutator,
  IShiftTradeMutatorrs3huyo9trn7 as IShiftTradeMutator,
} from './Shared7Punches-domain-shiftpool-domain.mjs';
import { ITaskManagementAccessor3mgawdm8ty2sh as ITaskManagementAccessor } from './Shared7Punches-domain-task-management-domain.mjs';
import {
  ITimeClockingSettingsAccessor19mcc5974omlh as ITimeClockingSettingsAccessor,
  ITimeClockingSettingsMutatorquo3ktfkxadg as ITimeClockingSettingsMutator,
  get_timeClockingModule34v5wf1ghe8ph as get_timeClockingModule,
} from './Shared7Punches-data-timeclocking.mjs';
import {
  ITimeOffMutator1zilu5t06rd0m as ITimeOffMutator,
  get_timeOffModule22auvlvjqtn9g as get_timeOffModule,
} from './Shared7Punches-data-timeoff.mjs';
import {
  IApproveTrainingTaskSignOffmmrogffiho1m as IApproveTrainingTaskSignOff,
  IGetTrainingTaskSignOffReviewuy8iaddf3me0 as IGetTrainingTaskSignOffReview,
  IGetTrainingReviewRequests2z12zd5nec5rv as IGetTrainingReviewRequests,
  IIsTrainingEnabled3aj37ldfvkupo as IIsTrainingEnabled,
  get_trainingDomainModuleqtwusw5q7img as get_trainingDomainModule,
} from './Shared7Punches-business-domains-training-domain.mjs';
import {
  IAppLifecycleProvider24td8xdm5ip99 as IAppLifecycleProvider,
  IEnvironmentProvider2spq4fpbokmem as IEnvironmentProvider,
  INetworkReachabilityProvider3jgigvmyn5cvt as INetworkReachabilityProvider,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  get_baseModuleslmsxkf2lho3 as get_baseModule,
  Success12c9v3ji39tsw as Success,
  Companion_instance2llo3g7f0d1n5 as Companion_instance_1,
  Companion_instance38at02i5wbrbj as Companion_instance_2,
  Failurenhl40niycb88 as Failure,
  NotFoundzza6y93k8gbh as NotFound,
  SevenThrowable22svzb6i8gddd as SevenThrowable,
  AppLifecycleProviderzypty41ik3ni as AppLifecycleProvider,
  NetworkReachabilityProviderbbozaiyk4yhb as NetworkReachabilityProvider,
  Platform_WEB_getInstance2zw09fslhbpz8 as Platform_WEB_getInstance,
} from './Shared7Punches-common-base.mjs';
import {
  INetworkDataProvider2v0ql8qlip169 as INetworkDataProvider,
  get_networkModulele1z108kpokz as get_networkModule,
  ProjectInfo1qp9h4onrx4i2 as ProjectInfo,
  JsBearerTokenProvider2wbeaqbjwnd48 as JsBearerTokenProvider,
} from './Shared7Punches-infrastructure-network.mjs';
import { IPlatformUserProvidernolzgfyci6us as IPlatformUserProvider } from './Shared7Punches-domain-user-domain.mjs';
import { get_analyticsModule1tajkb9krkps0 as get_analyticsModule } from './Shared7Punches-data-analytics.mjs';
import { get_billingDataModule1upx3kww23zej as get_billingDataModule } from './Shared7Punches-business-domains-billing-data.mjs';
import { get_taskManagementModule3kokw492p1rd6 as get_taskManagementModule } from './Shared7Punches-data-task-management.mjs';
import { get_preferencesModule2w95kcmis4j4d as get_preferencesModule } from './Shared7Punches-infrastructure-preferences.mjs';
import { get_shiftPoolModule2g85xkjmwpqak as get_shiftPoolModule } from './Shared7Punches-data-shiftpool.mjs';
import { get_shiftModule31ix6ju6k3lmq as get_shiftModule } from './Shared7Punches-data-shift.mjs';
import { get_trainingModule2zcnhh82r0qhg as get_trainingModule } from './Shared7Punches-data-training.mjs';
import { get_userModuleqonq4jzpfas2 as get_userModule } from './Shared7Punches-data-user.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  GlobalScope_instance3rq364dcgnf9q as GlobalScope_instance,
  promise1ky6tawqaxbt4 as promise,
} from './kotlinx-coroutines-core.mjs';
import './ktor-ktor-client-ktor-client-core.mjs';
import './ktor-ktor-client-ktor-client-plugins-ktor-client-json-ktor-client-serialization.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(InternalDependencyContainer, 'InternalDependencyContainer', InternalDependencyContainer, VOID, [KoinComponent]);
initMetadataForClass(NativeDependencies, 'NativeDependencies');
initMetadataForClass(NativeDependency, 'NativeDependency');
initMetadataForClass(Eager, 'Eager', VOID, NativeDependency);
initMetadataForClass(Lazy, 'Lazy', VOID, NativeDependency);
initMetadataForCompanion(Companion);
initMetadataForObject(SharedDependencies, 'SharedDependencies');
initMetadataForInterface(Platform, 'Platform');
initMetadataForClass(PunchContext, 'PunchContext');
initMetadataForFunctionReference(PunchFlowService$handleClockResponse$ref, VOID, VOID, [2]);
initMetadataForCoroutine($startCOROUTINE$0, CoroutineImpl);
initMetadataForCoroutine($handleClockResponseCOROUTINE$1, CoroutineImpl);
initMetadataForClass(PunchFlowService, 'PunchFlowService', VOID, VOID, VOID, [1, 2]);
initMetadataForLambda(toAvailableAction$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(toAvailableAction$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForLambda(toAvailableAction$slambda_3, CoroutineImpl, VOID, [0]);
initMetadataForLambda(toAvailableAction$slambda_5, CoroutineImpl, VOID, [0]);
initMetadataForLambda(toAvailableAction$slambda_7, CoroutineImpl, VOID, [0]);
initMetadataForLambda(toAvailableAction$slambda_9, CoroutineImpl, VOID, [1]);
initMetadataForLambda(toAvailableAction$slambda_11, CoroutineImpl, VOID, [0]);
initMetadataForCoroutine($handleStartShiftCOROUTINE$2, CoroutineImpl);
initMetadataForClass(AttestationRequired, 'AttestationRequired');
initMetadataForClass(HealthCheckRequired, 'HealthCheckRequired');
initMetadataForClass(TipsNeeded, 'TipsNeeded');
initMetadataForClass(RoleSelectionRequired, 'RoleSelectionRequired');
initMetadataForClass(DepartmentSelectionRequired, 'DepartmentSelectionRequired');
initMetadataForClass(BreakStarted, 'BreakStarted');
initMetadataForClass(BreakEnded, 'BreakEnded');
initMetadataForClass(ClockedIn_0, 'ClockedIn');
initMetadataForClass(ClockedOut_0, 'ClockedOut');
initMetadataForClass(InvalidPunchId, 'InvalidPunchId');
initMetadataForClass(HealthCheckFailed, 'HealthCheckFailed');
initMetadataForClass(BreakTooShort, 'BreakTooShort');
initMetadataForClass(PreferredShift, 'PreferredShift');
initMetadataForClass(EndCriteria, 'EndCriteria', VOID, Enum);
initMetadataForClass(Regular, 'Regular');
initMetadataForClass(Custom, 'Custom');
initMetadataForClass(AvailableAction, 'AvailableAction');
initMetadataForClass(StartShift, 'StartShift', VOID, AvailableAction, VOID, [1]);
initMetadataForClass(StartUnscheduledShift, 'StartUnscheduledShift', VOID, AvailableAction, VOID, [0]);
initMetadataForClass(ClockOut, 'ClockOut', VOID, AvailableAction, VOID, [0]);
initMetadataForClass(StartPaidBreak, 'StartPaidBreak', VOID, AvailableAction, VOID, [0]);
initMetadataForClass(StartUnpaidBreak, 'StartUnpaidBreak', VOID, AvailableAction, VOID, [0]);
initMetadataForClass(StartCustomBreak, 'StartCustomBreak', VOID, AvailableAction, VOID, [1]);
initMetadataForClass(EndBreak, 'EndBreak', VOID, AvailableAction, VOID, [0]);
initMetadataForClass(ClockedOut_1, 'ClockedOut');
initMetadataForClass(ClockedIn_1, 'ClockedIn');
initMetadataForClass(OnBreak_0, 'OnBreak');
initMetadataForClass(User, 'User');
initMetadataForClass(Punch, 'Punch');
initMetadataForClass(Shift, 'Shift');
initMetadataForClass(CustomBreak, 'CustomBreak');
initMetadataForLambda(AttestationRequiredStrategy$invoke$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($invokeCOROUTINE$3, CoroutineImpl);
initMetadataForClass(AttestationRequiredStrategy, 'AttestationRequiredStrategy', VOID, VOID, VOID, [2]);
initMetadataForObject(BreakTooShortStrategy, 'BreakTooShortStrategy', VOID, VOID, VOID, [2]);
initMetadataForLambda(DepartmentSelectionStrategy$invoke$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(DepartmentSelectionStrategy, 'DepartmentSelectionStrategy', VOID, VOID, VOID, [2]);
initMetadataForObject(HealthCheckFailedStrategy, 'HealthCheckFailedStrategy', VOID, VOID, VOID, [2]);
initMetadataForLambda(HealthCheckRequiredStrategy$invoke$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($invokeCOROUTINE$4, CoroutineImpl);
initMetadataForClass(HealthCheckRequiredStrategy, 'HealthCheckRequiredStrategy', VOID, VOID, VOID, [2]);
initMetadataForObject(InvalidPunchIdStrategy, 'InvalidPunchIdStrategy', VOID, VOID, VOID, [1]);
initMetadataForObject(PunchedInStrategy, 'PunchedInStrategy', VOID, VOID, VOID, [2]);
initMetadataForObject(PunchedOutStrategy, 'PunchedOutStrategy', VOID, VOID, VOID, [2]);
initMetadataForLambda(RoleSelectionStrategy$invoke$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(RoleSelectionStrategy, 'RoleSelectionStrategy', VOID, VOID, VOID, [2]);
initMetadataForLambda(TipsNeededStrategy$invoke$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(TipsNeededStrategy, 'TipsNeededStrategy', VOID, VOID, VOID, [2]);
initMetadataForClass(JSPlatform, 'JSPlatform', JSPlatform, VOID, [Platform]);
initMetadataForLambda(PunchFlowServiceBrowserClient$punchAsPromise$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($punchCOROUTINE$5, CoroutineImpl);
initMetadataForClass(PunchFlowServiceBrowserClient, 'PunchFlowServiceBrowserClient', VOID, VOID, VOID, [1]);
initMetadataForClass(BrowserLogger, 'BrowserLogger', VOID, VOID, [ILogger]);
initMetadataForClass(webViewPunchFlowServiceFactory$sessionDataProvider$1, VOID, VOID, VOID, [ISessionDataProvider], [0]);
initMetadataForClass(webViewPunchFlowServiceFactory$networkDataProvider$1, VOID, VOID, VOID, [INetworkDataProvider, JsBearerTokenProvider], [0]);
initMetadataForClass(webViewPunchFlowServiceFactory$loggingProvider$1, VOID, VOID, VOID, [ILoggingProvider]);
initMetadataForClass(webViewPunchFlowServiceFactory$platformUserProvider$1, VOID, VOID, VOID, [IPlatformUserProvider], [1]);
initMetadataForClass(webViewPunchFlowServiceFactory$nativeDependencies$1, VOID, VOID, VOID, [IEnvironmentProvider]);
initMetadataForInterface(PunchBrowserResponse_0, 'PunchBrowserResponse');
initMetadataForInterface(IntermediateResponse, 'IntermediateResponse', VOID, VOID, [PunchBrowserResponse_0]);
initMetadataForInterface(TerminalResponse, 'TerminalResponse', VOID, VOID, [PunchBrowserResponse_0]);
initMetadataForInterface(ErrorResponse, 'ErrorResponse', VOID, VOID, [PunchBrowserResponse_0]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(APIError, 'APIError', VOID, VOID, [ErrorResponse]);
initMetadataForCompanion(Companion_1);
initMetadataForInterface(UserStatusBrowserResponse, 'UserStatusBrowserResponse', VOID, VOID, [PunchBrowserResponse_0]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(BreakEnded_0, 'BreakEnded', VOID, VOID, [TerminalResponse]);
initMetadataForCompanion(Companion_3);
initMetadataForClass(BreakStarted_0, 'BreakStarted', VOID, VOID, [TerminalResponse]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(ClockedIn_2, 'ClockedIn', VOID, VOID, [TerminalResponse]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(ClockedOut_2, 'ClockedOut', VOID, VOID, [TerminalResponse]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(BreakTooShort_0, 'BreakTooShort', VOID, VOID, [ErrorResponse]);
initMetadataForCompanion(Companion_7);
initMetadataForClass(HealthCheckFailed_0, 'HealthCheckFailed', VOID, VOID, [ErrorResponse]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(InvalidPunchId_0, 'InvalidPunchId', VOID, VOID, [ErrorResponse]);
initMetadataForLambda(BrowserAttestationRequired$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(BrowserAttestationRequired, 'BrowserAttestationRequired', VOID, VOID, [IntermediateResponse]);
initMetadataForCompanion(Companion_10);
initMetadataForClass(BrowserAttestation, 'BrowserAttestation');
initMetadataForCompanion(Companion_11);
initMetadataForClass(BrowserAttestationContent, 'BrowserAttestationContent');
initMetadataForCompanion(Companion_12);
initMetadataForClass(BrowserAttestationResponse, 'BrowserAttestationResponse');
initMetadataForCompanion(Companion_13);
initMetadataForClass(BrowserClockRole, 'BrowserClockRole');
initMetadataForCompanion(Companion_14);
initMetadataForClass(BrowserClockDepartment, 'BrowserClockDepartment');
initMetadataForLambda(BrowserDepartmentSelectionRequired$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_15);
initMetadataForClass(BrowserDepartmentSelectionRequired, 'BrowserDepartmentSelectionRequired', VOID, VOID, [IntermediateResponse]);
initMetadataForLambda(BrowserHealthCheckRequired$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_16);
initMetadataForClass(BrowserHealthCheckRequired, 'BrowserHealthCheckRequired', VOID, VOID, [IntermediateResponse]);
initMetadataForCompanion(Companion_17);
initMetadataForClass(BrowserHealthCheckQuestionnaire, 'BrowserHealthCheckQuestionnaire');
initMetadataForCompanion(Companion_18);
initMetadataForClass(BrowserHealthCheckQuestion, 'BrowserHealthCheckQuestion');
initMetadataForCompanion(Companion_19);
initMetadataForClass(BrowserHealthCheckResponse, 'BrowserHealthCheckResponse');
initMetadataForClass(BrowserHealthCheckAnswer, 'BrowserHealthCheckAnswer');
initMetadataForLambda(BrowserRoleSelectionRequired$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_20);
initMetadataForClass(BrowserRoleSelectionRequired, 'BrowserRoleSelectionRequired', VOID, VOID, [IntermediateResponse]);
initMetadataForLambda(TipsNeeded$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($sendTipsCOROUTINE$6, CoroutineImpl);
initMetadataForCompanion(Companion_21, VOID, VOID, [2]);
initMetadataForClass(TipsNeeded_0, 'TipsNeeded', VOID, VOID, [IntermediateResponse]);
initMetadataForObject(AvailableActionMapper, 'AvailableActionMapper');
initMetadataForLambda(BrowserStartShiftAction$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(BrowserStartShiftAction$Companion$from$o$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_22);
initMetadataForInterface(BrowserAvailableAction, 'BrowserAvailableAction');
initMetadataForClass(BrowserStartShiftAction, 'BrowserStartShiftAction', VOID, VOID, [BrowserAvailableAction]);
initMetadataForLambda(BrowserStartUnscheduledShiftAction$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_23);
initMetadataForClass(BrowserStartUnscheduledShiftAction, 'BrowserStartUnscheduledShiftAction', VOID, VOID, [BrowserAvailableAction]);
initMetadataForLambda(BrowserClockOutAction$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_24);
initMetadataForClass(BrowserClockOutAction, 'BrowserClockOutAction', VOID, VOID, [BrowserAvailableAction]);
initMetadataForLambda(BrowserStartPaidBreakAction$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_25);
initMetadataForClass(BrowserStartPaidBreakAction, 'BrowserStartPaidBreakAction', VOID, VOID, [BrowserAvailableAction]);
initMetadataForLambda(BrowserStartUnpaidBreakAction$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_26);
initMetadataForClass(BrowserStartUnpaidBreakAction, 'BrowserStartUnpaidBreakAction', VOID, VOID, [BrowserAvailableAction]);
initMetadataForLambda(BrowserStartCustomBreakAction$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_27);
initMetadataForClass(BrowserStartCustomBreakAction, 'BrowserStartCustomBreakAction', VOID, VOID, [BrowserAvailableAction]);
initMetadataForLambda(BrowserEndBreakAction$Companion$from$o$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_28);
initMetadataForClass(BrowserEndBreakAction, 'BrowserEndBreakAction', VOID, VOID, [BrowserAvailableAction]);
initMetadataForCompanion(Companion_29);
initMetadataForClass(BrowserBreak, 'BrowserBreak');
initMetadataForCompanion(Companion_30);
initMetadataForClass(BrowserClockedIn, 'BrowserClockedIn', VOID, VOID, [UserStatusBrowserResponse]);
initMetadataForCompanion(Companion_31);
initMetadataForClass(BrowserClockedOut, 'BrowserClockedOut', VOID, VOID, [UserStatusBrowserResponse]);
initMetadataForCompanion(Companion_32);
initMetadataForClass(BrowserCustomBreak, 'BrowserCustomBreak');
initMetadataForCompanion(Companion_33);
initMetadataForClass(BrowserOnBreak, 'BrowserOnBreak', VOID, VOID, [UserStatusBrowserResponse]);
initMetadataForCompanion(Companion_34);
initMetadataForClass(BrowserPreferredShift, 'BrowserPreferredShift');
initMetadataForClass(BrowserRole, 'BrowserRole');
initMetadataForCompanion(Companion_35);
initMetadataForClass(BrowserPunch, 'BrowserPunch');
initMetadataForCompanion(Companion_36);
initMetadataForClass(BrowserShift, 'BrowserShift');
initMetadataForCompanion(Companion_37);
initMetadataForClass(BrowserUser, 'BrowserUser');
//endregion
function get_commonModule() {
  _init_properties_CommonModule_kt__r7tk15();
  return commonModule;
}
var commonModule;
function commonModule$lambda($this$module) {
  _init_properties_CommonModule_kt__r7tk15();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = commonModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(PunchFlowService), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  return Unit_instance;
}
function commonModule$lambda$lambda($this$factory, it) {
  _init_properties_CommonModule_kt__r7tk15();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(IClockRepository), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(AttestationRepository), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$factory.q1d(getKClass(HealthCheckRepository), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_2 = $this$factory.q1d(getKClass(IUserStatusAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$4 = $this$factory.q1d(getKClass(ILogger), null, null);
  return new PunchFlowService(tmp, tmp_0, tmp_1, tmp_2, tmp$ret$4);
}
var properties_initialized_CommonModule_kt_k6die1;
function _init_properties_CommonModule_kt__r7tk15() {
  if (!properties_initialized_CommonModule_kt_k6die1) {
    properties_initialized_CommonModule_kt_k6die1 = true;
    commonModule = module_0(VOID, commonModule$lambda);
  }
}
function InternalDependencyContainer$planFeatureAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IPlanFeatureAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IPlanFeatureAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$analyticsEventTracker$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IAnalyticsEventTracker), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IAnalyticsEventTracker), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$accountActivationRepository$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IAccountActivationRepository), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IAccountActivationRepository), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$actionableRequestsAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IActionableRequestsAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IActionableRequestsAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$aiImporterAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IAIImporterAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IAIImporterAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$aiImporterMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IAIImporterMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IAIImporterMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$authenticationAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(AuthenticationAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(AuthenticationAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$availabilityMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IAvailabilityMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IAvailabilityMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$cacheCleaner$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ICacheCleaner), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ICacheCleaner), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$clairSdkAppKeyProvider$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IClairSdkAppKeyProvider), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IClairSdkAppKeyProvider), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$companyAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ICompanyAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ICompanyAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$customShiftFlagAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ICustomShiftFlagAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ICustomShiftFlagAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$customShiftFlagMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ICustomShiftFlagMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ICustomShiftFlagMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$departmentAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IDepartmentAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IDepartmentAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$departmentInvalidator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IDepartmentInvalidator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IDepartmentInvalidator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$departmentMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IDepartmentMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IDepartmentMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$earnedWageAccessDiscoveryAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IEarnedWageAccessDiscoveryAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IEarnedWageAccessDiscoveryAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$earnedWageAccessDiscoveryMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IEarnedWageAccessDiscoveryMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IEarnedWageAccessDiscoveryMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$featureFlagEvaluator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IFeatureFlagEvaluator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IFeatureFlagEvaluator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$featureFlagOverrider$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IFeatureFlagOverrider), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IFeatureFlagOverrider), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$featureFlagService$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(FeatureFlagService), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(FeatureFlagService), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$fillScheduleFromTemplateUseCase$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IFillScheduleFromTemplateUseCase), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IFillScheduleFromTemplateUseCase), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$webSocketConnection$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IWebSocketConnection), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IWebSocketConnection), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$webSocketMessenger$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IWebSocketMessenger), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IWebSocketMessenger), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$getSecurityProfileUseCase$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IGetSecurityProfileUseCase), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IGetSecurityProfileUseCase), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$knockToJoinAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IKnockToJoinAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IKnockToJoinAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$knockToJoinMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IKnockToJoinMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IKnockToJoinMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$locationAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ILocationAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ILocationAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$logBookAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ILogBookAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ILogBookAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$locationMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ILocationMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ILocationMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$overtimeRiskAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IOvertimeRiskAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IOvertimeRiskAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$payAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(PayAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(PayAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$payrollRepository$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IPayrollRepository), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IPayrollRepository), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$pollingServiceStopper$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IPollingServiceStopper), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IPollingServiceStopper), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$punchFlowService$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(PunchFlowService), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(PunchFlowService), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$referralAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IReferralAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IReferralAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$refreshAiImporterExtractionStatusUseCase$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IRefreshAIImporterExtractionStatusUseCase), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IRefreshAIImporterExtractionStatusUseCase), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$resolveClairExperienceUseCase$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IResolveClairExperienceUseCase), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IResolveClairExperienceUseCase), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$roleAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IRoleAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IRoleAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$roleMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IRoleMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IRoleMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$sandboxAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ISandboxAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ISandboxAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$schedulingMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ISchedulingMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ISchedulingMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$scheduleWarningAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IScheduleWarningAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IScheduleWarningAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$shiftCompositeAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IShiftCompositeAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IShiftCompositeAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$shiftDropMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IShiftDropMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IShiftDropMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$shiftMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IShiftMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IShiftMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$shiftTradeMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IShiftTradeMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IShiftTradeMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$taskManagementAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ITaskManagementAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ITaskManagementAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$templateAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ITemplateAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ITemplateAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$templateCompositeAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ITemplateCompositeAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ITemplateCompositeAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$templateMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ITemplateMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ITemplateMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$timeClockingSettingsAccessor$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ITimeClockingSettingsAccessor), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ITimeClockingSettingsAccessor), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$timeClockingSettingsMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ITimeClockingSettingsMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ITimeClockingSettingsMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$timeOffMutator$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(ITimeOffMutator), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(ITimeOffMutator), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$approveTrainingTaskSignOff$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IApproveTrainingTaskSignOff), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IApproveTrainingTaskSignOff), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$getTrainingTaskSignOffReview$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IGetTrainingTaskSignOffReview), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IGetTrainingTaskSignOffReview), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$getTrainingReviewRequests$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IGetTrainingReviewRequests), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IGetTrainingReviewRequests), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$getTrainingStatus$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IGetTrainingStatus), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IGetTrainingStatus), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$isTrainingEnabled$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IIsTrainingEnabled), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IIsTrainingEnabled), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer$webViewUrlProvider$delegate$lambda($this, $qualifier, $parameters) {
  return function () {
    var tmp0 = $this;
    var tmp1 = $qualifier;
    // Inline function 'org.koin.core.component.get' call
    var parameters = $parameters;
    var tmp;
    if (isInterface(tmp0, KoinScopeComponent)) {
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.g1a().q1d(getKClass(IWebViewUrlProvider), tmp1, parameters);
    } else {
      // Inline function 'org.koin.core.Koin.get' call
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp = tmp0.e1a().z18_1.h19_1.q1d(getKClass(IWebViewUrlProvider), tmp1, parameters);
    }
    return tmp;
  };
}
function InternalDependencyContainer() {
  var tmp = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode = KoinPlatformTools_instance.t1d();
  tmp.vau_1 = lazy(mode, InternalDependencyContainer$planFeatureAccessor$delegate$lambda(this, null, null));
  var tmp_0 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_0 = KoinPlatformTools_instance.t1d();
  tmp_0.wau_1 = lazy(mode_0, InternalDependencyContainer$analyticsEventTracker$delegate$lambda(this, null, null));
  var tmp_1 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_1 = KoinPlatformTools_instance.t1d();
  tmp_1.xau_1 = lazy(mode_1, InternalDependencyContainer$accountActivationRepository$delegate$lambda(this, null, null));
  var tmp_2 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_2 = KoinPlatformTools_instance.t1d();
  tmp_2.yau_1 = lazy(mode_2, InternalDependencyContainer$actionableRequestsAccessor$delegate$lambda(this, null, null));
  var tmp_3 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_3 = KoinPlatformTools_instance.t1d();
  tmp_3.zau_1 = lazy(mode_3, InternalDependencyContainer$aiImporterAccessor$delegate$lambda(this, null, null));
  var tmp_4 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_4 = KoinPlatformTools_instance.t1d();
  tmp_4.aav_1 = lazy(mode_4, InternalDependencyContainer$aiImporterMutator$delegate$lambda(this, null, null));
  var tmp_5 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_5 = KoinPlatformTools_instance.t1d();
  tmp_5.bav_1 = lazy(mode_5, InternalDependencyContainer$authenticationAccessor$delegate$lambda(this, null, null));
  var tmp_6 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_6 = KoinPlatformTools_instance.t1d();
  tmp_6.cav_1 = lazy(mode_6, InternalDependencyContainer$availabilityMutator$delegate$lambda(this, null, null));
  var tmp_7 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_7 = KoinPlatformTools_instance.t1d();
  tmp_7.dav_1 = lazy(mode_7, InternalDependencyContainer$cacheCleaner$delegate$lambda(this, null, null));
  var tmp_8 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_8 = KoinPlatformTools_instance.t1d();
  tmp_8.eav_1 = lazy(mode_8, InternalDependencyContainer$clairSdkAppKeyProvider$delegate$lambda(this, null, null));
  var tmp_9 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_9 = KoinPlatformTools_instance.t1d();
  tmp_9.fav_1 = lazy(mode_9, InternalDependencyContainer$companyAccessor$delegate$lambda(this, null, null));
  var tmp_10 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_10 = KoinPlatformTools_instance.t1d();
  tmp_10.gav_1 = lazy(mode_10, InternalDependencyContainer$customShiftFlagAccessor$delegate$lambda(this, null, null));
  var tmp_11 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_11 = KoinPlatformTools_instance.t1d();
  tmp_11.hav_1 = lazy(mode_11, InternalDependencyContainer$customShiftFlagMutator$delegate$lambda(this, null, null));
  var tmp_12 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_12 = KoinPlatformTools_instance.t1d();
  tmp_12.iav_1 = lazy(mode_12, InternalDependencyContainer$departmentAccessor$delegate$lambda(this, null, null));
  var tmp_13 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_13 = KoinPlatformTools_instance.t1d();
  tmp_13.jav_1 = lazy(mode_13, InternalDependencyContainer$departmentInvalidator$delegate$lambda(this, null, null));
  var tmp_14 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_14 = KoinPlatformTools_instance.t1d();
  tmp_14.kav_1 = lazy(mode_14, InternalDependencyContainer$departmentMutator$delegate$lambda(this, null, null));
  var tmp_15 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_15 = KoinPlatformTools_instance.t1d();
  tmp_15.lav_1 = lazy(mode_15, InternalDependencyContainer$earnedWageAccessDiscoveryAccessor$delegate$lambda(this, null, null));
  var tmp_16 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_16 = KoinPlatformTools_instance.t1d();
  tmp_16.mav_1 = lazy(mode_16, InternalDependencyContainer$earnedWageAccessDiscoveryMutator$delegate$lambda(this, null, null));
  var tmp_17 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_17 = KoinPlatformTools_instance.t1d();
  tmp_17.nav_1 = lazy(mode_17, InternalDependencyContainer$featureFlagEvaluator$delegate$lambda(this, null, null));
  var tmp_18 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_18 = KoinPlatformTools_instance.t1d();
  tmp_18.oav_1 = lazy(mode_18, InternalDependencyContainer$featureFlagOverrider$delegate$lambda(this, null, null));
  var tmp_19 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_19 = KoinPlatformTools_instance.t1d();
  tmp_19.pav_1 = lazy(mode_19, InternalDependencyContainer$featureFlagService$delegate$lambda(this, null, null));
  var tmp_20 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_20 = KoinPlatformTools_instance.t1d();
  tmp_20.qav_1 = lazy(mode_20, InternalDependencyContainer$fillScheduleFromTemplateUseCase$delegate$lambda(this, null, null));
  var tmp_21 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_21 = KoinPlatformTools_instance.t1d();
  tmp_21.rav_1 = lazy(mode_21, InternalDependencyContainer$webSocketConnection$delegate$lambda(this, null, null));
  var tmp_22 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_22 = KoinPlatformTools_instance.t1d();
  tmp_22.sav_1 = lazy(mode_22, InternalDependencyContainer$webSocketMessenger$delegate$lambda(this, null, null));
  var tmp_23 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_23 = KoinPlatformTools_instance.t1d();
  tmp_23.tav_1 = lazy(mode_23, InternalDependencyContainer$getSecurityProfileUseCase$delegate$lambda(this, null, null));
  var tmp_24 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_24 = KoinPlatformTools_instance.t1d();
  tmp_24.uav_1 = lazy(mode_24, InternalDependencyContainer$knockToJoinAccessor$delegate$lambda(this, null, null));
  var tmp_25 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_25 = KoinPlatformTools_instance.t1d();
  tmp_25.vav_1 = lazy(mode_25, InternalDependencyContainer$knockToJoinMutator$delegate$lambda(this, null, null));
  var tmp_26 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_26 = KoinPlatformTools_instance.t1d();
  tmp_26.wav_1 = lazy(mode_26, InternalDependencyContainer$locationAccessor$delegate$lambda(this, null, null));
  var tmp_27 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_27 = KoinPlatformTools_instance.t1d();
  tmp_27.xav_1 = lazy(mode_27, InternalDependencyContainer$logBookAccessor$delegate$lambda(this, null, null));
  var tmp_28 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_28 = KoinPlatformTools_instance.t1d();
  tmp_28.yav_1 = lazy(mode_28, InternalDependencyContainer$locationMutator$delegate$lambda(this, null, null));
  var tmp_29 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_29 = KoinPlatformTools_instance.t1d();
  tmp_29.zav_1 = lazy(mode_29, InternalDependencyContainer$overtimeRiskAccessor$delegate$lambda(this, null, null));
  var tmp_30 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_30 = KoinPlatformTools_instance.t1d();
  tmp_30.aaw_1 = lazy(mode_30, InternalDependencyContainer$payAccessor$delegate$lambda(this, null, null));
  var tmp_31 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_31 = KoinPlatformTools_instance.t1d();
  tmp_31.baw_1 = lazy(mode_31, InternalDependencyContainer$payrollRepository$delegate$lambda(this, null, null));
  var tmp_32 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_32 = KoinPlatformTools_instance.t1d();
  tmp_32.caw_1 = lazy(mode_32, InternalDependencyContainer$pollingServiceStopper$delegate$lambda(this, null, null));
  var tmp_33 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_33 = KoinPlatformTools_instance.t1d();
  tmp_33.daw_1 = lazy(mode_33, InternalDependencyContainer$punchFlowService$delegate$lambda(this, null, null));
  var tmp_34 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_34 = KoinPlatformTools_instance.t1d();
  tmp_34.eaw_1 = lazy(mode_34, InternalDependencyContainer$referralAccessor$delegate$lambda(this, null, null));
  var tmp_35 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_35 = KoinPlatformTools_instance.t1d();
  tmp_35.faw_1 = lazy(mode_35, InternalDependencyContainer$refreshAiImporterExtractionStatusUseCase$delegate$lambda(this, null, null));
  var tmp_36 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_36 = KoinPlatformTools_instance.t1d();
  tmp_36.gaw_1 = lazy(mode_36, InternalDependencyContainer$resolveClairExperienceUseCase$delegate$lambda(this, null, null));
  var tmp_37 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_37 = KoinPlatformTools_instance.t1d();
  tmp_37.haw_1 = lazy(mode_37, InternalDependencyContainer$roleAccessor$delegate$lambda(this, null, null));
  var tmp_38 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_38 = KoinPlatformTools_instance.t1d();
  tmp_38.iaw_1 = lazy(mode_38, InternalDependencyContainer$roleMutator$delegate$lambda(this, null, null));
  var tmp_39 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_39 = KoinPlatformTools_instance.t1d();
  tmp_39.jaw_1 = lazy(mode_39, InternalDependencyContainer$sandboxAccessor$delegate$lambda(this, null, null));
  var tmp_40 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_40 = KoinPlatformTools_instance.t1d();
  tmp_40.kaw_1 = lazy(mode_40, InternalDependencyContainer$schedulingMutator$delegate$lambda(this, null, null));
  var tmp_41 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_41 = KoinPlatformTools_instance.t1d();
  tmp_41.law_1 = lazy(mode_41, InternalDependencyContainer$scheduleWarningAccessor$delegate$lambda(this, null, null));
  var tmp_42 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_42 = KoinPlatformTools_instance.t1d();
  tmp_42.maw_1 = lazy(mode_42, InternalDependencyContainer$shiftCompositeAccessor$delegate$lambda(this, null, null));
  var tmp_43 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_43 = KoinPlatformTools_instance.t1d();
  tmp_43.naw_1 = lazy(mode_43, InternalDependencyContainer$shiftDropMutator$delegate$lambda(this, null, null));
  var tmp_44 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_44 = KoinPlatformTools_instance.t1d();
  tmp_44.oaw_1 = lazy(mode_44, InternalDependencyContainer$shiftMutator$delegate$lambda(this, null, null));
  var tmp_45 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_45 = KoinPlatformTools_instance.t1d();
  tmp_45.paw_1 = lazy(mode_45, InternalDependencyContainer$shiftTradeMutator$delegate$lambda(this, null, null));
  var tmp_46 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_46 = KoinPlatformTools_instance.t1d();
  tmp_46.qaw_1 = lazy(mode_46, InternalDependencyContainer$taskManagementAccessor$delegate$lambda(this, null, null));
  var tmp_47 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_47 = KoinPlatformTools_instance.t1d();
  tmp_47.raw_1 = lazy(mode_47, InternalDependencyContainer$templateAccessor$delegate$lambda(this, null, null));
  var tmp_48 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_48 = KoinPlatformTools_instance.t1d();
  tmp_48.saw_1 = lazy(mode_48, InternalDependencyContainer$templateCompositeAccessor$delegate$lambda(this, null, null));
  var tmp_49 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_49 = KoinPlatformTools_instance.t1d();
  tmp_49.taw_1 = lazy(mode_49, InternalDependencyContainer$templateMutator$delegate$lambda(this, null, null));
  var tmp_50 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_50 = KoinPlatformTools_instance.t1d();
  tmp_50.uaw_1 = lazy(mode_50, InternalDependencyContainer$timeClockingSettingsAccessor$delegate$lambda(this, null, null));
  var tmp_51 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_51 = KoinPlatformTools_instance.t1d();
  tmp_51.vaw_1 = lazy(mode_51, InternalDependencyContainer$timeClockingSettingsMutator$delegate$lambda(this, null, null));
  var tmp_52 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_52 = KoinPlatformTools_instance.t1d();
  tmp_52.waw_1 = lazy(mode_52, InternalDependencyContainer$timeOffMutator$delegate$lambda(this, null, null));
  var tmp_53 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_53 = KoinPlatformTools_instance.t1d();
  tmp_53.xaw_1 = lazy(mode_53, InternalDependencyContainer$approveTrainingTaskSignOff$delegate$lambda(this, null, null));
  var tmp_54 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_54 = KoinPlatformTools_instance.t1d();
  tmp_54.yaw_1 = lazy(mode_54, InternalDependencyContainer$getTrainingTaskSignOffReview$delegate$lambda(this, null, null));
  var tmp_55 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_55 = KoinPlatformTools_instance.t1d();
  tmp_55.zaw_1 = lazy(mode_55, InternalDependencyContainer$getTrainingReviewRequests$delegate$lambda(this, null, null));
  var tmp_56 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_56 = KoinPlatformTools_instance.t1d();
  tmp_56.aax_1 = lazy(mode_56, InternalDependencyContainer$getTrainingStatus$delegate$lambda(this, null, null));
  var tmp_57 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_57 = KoinPlatformTools_instance.t1d();
  tmp_57.bax_1 = lazy(mode_57, InternalDependencyContainer$isTrainingEnabled$delegate$lambda(this, null, null));
  var tmp_58 = this;
  // Inline function 'org.koin.core.component.inject' call
  var mode_58 = KoinPlatformTools_instance.t1d();
  tmp_58.cax_1 = lazy(mode_58, InternalDependencyContainer$webViewUrlProvider$delegate$lambda(this, null, null));
}
protoOf(InternalDependencyContainer).dax = function () {
  var tmp0 = this.daw_1;
  // Inline function 'kotlin.getValue' call
  punchFlowService$factory();
  return tmp0.t();
};
function punchFlowService$factory() {
  return getPropertyCallableRef('punchFlowService', 1, KProperty1, function (receiver) {
    return receiver.dax();
  }, null);
}
function NativeDependencies(sessionDataProvider, networkDataProvider, loggingProvider, platformUserProvider, appLifecycleProvider, environmentProvider, networkReachabilityProvider) {
  this.eax_1 = sessionDataProvider;
  this.fax_1 = networkDataProvider;
  this.gax_1 = loggingProvider;
  this.hax_1 = platformUserProvider;
  this.iax_1 = appLifecycleProvider;
  this.jax_1 = environmentProvider;
  this.kax_1 = networkReachabilityProvider;
}
protoOf(NativeDependencies).toString = function () {
  return 'NativeDependencies(sessionDataProvider=' + toString(this.eax_1) + ', networkDataProvider=' + toString(this.fax_1) + ', loggingProvider=' + toString(this.gax_1) + ', platformUserProvider=' + toString(this.hax_1) + ', appLifecycleProvider=' + toString(this.iax_1) + ', environmentProvider=' + toString(this.jax_1) + ', networkReachabilityProvider=' + toString(this.kax_1) + ')';
};
protoOf(NativeDependencies).hashCode = function () {
  var result = hashCode(this.eax_1);
  result = imul(result, 31) + hashCode(this.fax_1) | 0;
  result = imul(result, 31) + hashCode(this.gax_1) | 0;
  result = imul(result, 31) + hashCode(this.hax_1) | 0;
  result = imul(result, 31) + hashCode(this.iax_1) | 0;
  result = imul(result, 31) + hashCode(this.jax_1) | 0;
  result = imul(result, 31) + hashCode(this.kax_1) | 0;
  return result;
};
protoOf(NativeDependencies).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NativeDependencies))
    return false;
  var tmp0_other_with_cast = other instanceof NativeDependencies ? other : THROW_CCE();
  if (!equals(this.eax_1, tmp0_other_with_cast.eax_1))
    return false;
  if (!equals(this.fax_1, tmp0_other_with_cast.fax_1))
    return false;
  if (!equals(this.gax_1, tmp0_other_with_cast.gax_1))
    return false;
  if (!equals(this.hax_1, tmp0_other_with_cast.hax_1))
    return false;
  if (!equals(this.iax_1, tmp0_other_with_cast.iax_1))
    return false;
  if (!equals(this.jax_1, tmp0_other_with_cast.jax_1))
    return false;
  if (!equals(this.kax_1, tmp0_other_with_cast.kax_1))
    return false;
  return true;
};
function Eager(value) {
  NativeDependency.call(this);
  this.lax_1 = value;
}
function Lazy() {
}
function Companion() {
}
var Companion_instance_3;
function Companion_getInstance_1() {
  return Companion_instance_3;
}
function NativeDependency() {
}
protoOf(NativeDependency).n18 = function () {
  var tmp;
  if (this instanceof Eager) {
    tmp = this.lax_1;
  } else {
    if (this instanceof Lazy) {
      tmp = this.max_1();
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
};
function requireContainer($this) {
  var tmp0_elvis_lhs = $this.nax_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'SharedDependencies.init() must be called before accessing dependencies.';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function nativeModule($this, nativeDependencies) {
  return module_0(VOID, SharedDependencies$nativeModule$lambda(nativeDependencies));
}
function SharedDependencies$init$lambda($nativeDependencies) {
  return function ($this$startKoin) {
    $this$startKoin.a1a([get_sharedModule(), nativeModule(SharedDependencies_instance, $nativeDependencies)]);
    return Unit_instance;
  };
}
function SharedDependencies$nativeModule$lambda$lambda($nativeDependencies) {
  return function ($this$single, it) {
    return $nativeDependencies.iax_1.n18();
  };
}
function SharedDependencies$nativeModule$lambda$lambda_0($nativeDependencies) {
  return function ($this$single, it) {
    return $nativeDependencies.jax_1.n18();
  };
}
function SharedDependencies$nativeModule$lambda$lambda_1($nativeDependencies) {
  return function ($this$single, it) {
    return $nativeDependencies.gax_1.n18();
  };
}
function SharedDependencies$nativeModule$lambda$lambda_2($nativeDependencies) {
  return function ($this$single, it) {
    return $nativeDependencies.fax_1.n18();
  };
}
function SharedDependencies$nativeModule$lambda$lambda_3($nativeDependencies) {
  return function ($this$single, it) {
    return $nativeDependencies.kax_1.n18();
  };
}
function SharedDependencies$nativeModule$lambda$lambda_4($nativeDependencies) {
  return function ($this$single, it) {
    return $nativeDependencies.hax_1.n18();
  };
}
function SharedDependencies$nativeModule$lambda$lambda_5($nativeDependencies) {
  return function ($this$single, it) {
    return $nativeDependencies.eax_1.n18();
  };
}
function SharedDependencies$nativeModule$lambda($nativeDependencies) {
  return function ($this$module) {
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = SharedDependencies$nativeModule$lambda$lambda($nativeDependencies);
    var scopeQualifier = Companion_getInstance().s1a_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(IAppLifecycleProvider), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.p1c(factory);
    if (false || $this$module.i1c_1) {
      $this$module.r1c(factory);
    }
    new KoinDefinition($this$module, factory);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_0 = SharedDependencies$nativeModule$lambda$lambda_0($nativeDependencies);
    var scopeQualifier_0 = Companion_getInstance().s1a_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_0 = Kind_Singleton_getInstance();
    var secondaryTypes_0 = emptyList();
    var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IEnvironmentProvider), null, definition_0, kind_0, secondaryTypes_0);
    var factory_0 = new SingleInstanceFactory(def_0);
    $this$module.p1c(factory_0);
    if (false || $this$module.i1c_1) {
      $this$module.r1c(factory_0);
    }
    new KoinDefinition($this$module, factory_0);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_1 = SharedDependencies$nativeModule$lambda$lambda_1($nativeDependencies);
    var scopeQualifier_1 = Companion_getInstance().s1a_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_1 = Kind_Singleton_getInstance();
    var secondaryTypes_1 = emptyList();
    var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(ILoggingProvider), null, definition_1, kind_1, secondaryTypes_1);
    var factory_1 = new SingleInstanceFactory(def_1);
    $this$module.p1c(factory_1);
    if (false || $this$module.i1c_1) {
      $this$module.r1c(factory_1);
    }
    new KoinDefinition($this$module, factory_1);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_2 = SharedDependencies$nativeModule$lambda$lambda_2($nativeDependencies);
    var scopeQualifier_2 = Companion_getInstance().s1a_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_2 = Kind_Singleton_getInstance();
    var secondaryTypes_2 = emptyList();
    var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(INetworkDataProvider), null, definition_2, kind_2, secondaryTypes_2);
    var factory_2 = new SingleInstanceFactory(def_2);
    $this$module.p1c(factory_2);
    if (false || $this$module.i1c_1) {
      $this$module.r1c(factory_2);
    }
    new KoinDefinition($this$module, factory_2);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_3 = SharedDependencies$nativeModule$lambda$lambda_3($nativeDependencies);
    var scopeQualifier_3 = Companion_getInstance().s1a_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_3 = Kind_Singleton_getInstance();
    var secondaryTypes_3 = emptyList();
    var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(INetworkReachabilityProvider), null, definition_3, kind_3, secondaryTypes_3);
    var factory_3 = new SingleInstanceFactory(def_3);
    $this$module.p1c(factory_3);
    if (false || $this$module.i1c_1) {
      $this$module.r1c(factory_3);
    }
    new KoinDefinition($this$module, factory_3);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_4 = SharedDependencies$nativeModule$lambda$lambda_4($nativeDependencies);
    var scopeQualifier_4 = Companion_getInstance().s1a_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_4 = Kind_Singleton_getInstance();
    var secondaryTypes_4 = emptyList();
    var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(IPlatformUserProvider), null, definition_4, kind_4, secondaryTypes_4);
    var factory_4 = new SingleInstanceFactory(def_4);
    $this$module.p1c(factory_4);
    if (false || $this$module.i1c_1) {
      $this$module.r1c(factory_4);
    }
    new KoinDefinition($this$module, factory_4);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_5 = SharedDependencies$nativeModule$lambda$lambda_5($nativeDependencies);
    var scopeQualifier_5 = Companion_getInstance().s1a_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_5 = Kind_Singleton_getInstance();
    var secondaryTypes_5 = emptyList();
    var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(ISessionDataProvider), null, definition_5, kind_5, secondaryTypes_5);
    var factory_5 = new SingleInstanceFactory(def_5);
    $this$module.p1c(factory_5);
    if (false || $this$module.i1c_1) {
      $this$module.r1c(factory_5);
    }
    new KoinDefinition($this$module, factory_5);
    return Unit_instance;
  };
}
function SharedDependencies() {
  this.nax_1 = null;
}
protoOf(SharedDependencies).dax = function () {
  return requireContainer(this).dax();
};
protoOf(SharedDependencies).oax = function (nativeDependencies) {
  startKoin(SharedDependencies$init$lambda(nativeDependencies));
  this.nax_1 = new InternalDependencyContainer();
};
protoOf(SharedDependencies).b1m = function () {
  stopKoin();
  this.nax_1 = null;
};
var SharedDependencies_instance;
function SharedDependencies_getInstance() {
  return SharedDependencies_instance;
}
function get_sharedModule() {
  _init_properties_SharedModule_kt__f2j32p();
  return sharedModule;
}
var sharedModule;
function sharedModule$lambda($this$module) {
  _init_properties_SharedModule_kt__f2j32p();
  $this$module.o1c([get_accountActivationModule(), get_analyticsModule(), get_authenticationModule(), get_availabilityModule(), get_billingDataModule(), get_trainingDomainModule(), get_commonModule(), get_sandboxModule(), get_coreModule(), get_dashboardModule(), get_earnedWageAccessFeatureModule(), get_featureFlagModule(), get_knockToJoinModule(), get_logBookModule(), get_loggingModule(), get_networkModule(), get_overtimeRiskModule(), get_taskManagementModule(), get_payModule(), get_payrollModule(), get_pollingModule(), get_preferencesModule(), get_punchModule(), get_schedulingFeatureModule(), get_schedulingModule(), get_shiftPoolModule(), get_shiftModule(), get_timeClockingModule(), get_timeOffModule(), get_trainingModule(), get_userModule(), get_webSocketModule(), get_baseModule()]);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = sharedModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(ProjectInfo), null, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  new KoinDefinition($this$module, factory);
  return Unit_instance;
}
function sharedModule$lambda$lambda($this$single, it) {
  _init_properties_SharedModule_kt__f2j32p();
  return new ProjectInfo('Shared7Punches', '81.1.0');
}
var properties_initialized_SharedModule_kt_gis2hf;
function _init_properties_SharedModule_kt__f2j32p() {
  if (!properties_initialized_SharedModule_kt_gis2hf) {
    properties_initialized_SharedModule_kt_gis2hf = true;
    sharedModule = module_0(VOID, sharedModule$lambda);
  }
}
function Platform() {
}
function PunchContext(employeePunchId, clockResponseHandler, roleId, departmentId, confirmedRoleId, healthCheckQuestionnaireResponseId) {
  roleId = roleId === VOID ? null : roleId;
  departmentId = departmentId === VOID ? null : departmentId;
  confirmedRoleId = confirmedRoleId === VOID ? null : confirmedRoleId;
  healthCheckQuestionnaireResponseId = healthCheckQuestionnaireResponseId === VOID ? null : healthCheckQuestionnaireResponseId;
  this.pax_1 = employeePunchId;
  this.qax_1 = clockResponseHandler;
  this.rax_1 = roleId;
  this.sax_1 = departmentId;
  this.tax_1 = confirmedRoleId;
  this.uax_1 = healthCheckQuestionnaireResponseId;
}
protoOf(PunchContext).vax = function (employeePunchId, clockResponseHandler, roleId, departmentId, confirmedRoleId, healthCheckQuestionnaireResponseId) {
  return new PunchContext(employeePunchId, clockResponseHandler, roleId, departmentId, confirmedRoleId, healthCheckQuestionnaireResponseId);
};
protoOf(PunchContext).wax = function (employeePunchId, clockResponseHandler, roleId, departmentId, confirmedRoleId, healthCheckQuestionnaireResponseId, $super) {
  employeePunchId = employeePunchId === VOID ? this.pax_1 : employeePunchId;
  clockResponseHandler = clockResponseHandler === VOID ? this.qax_1 : clockResponseHandler;
  roleId = roleId === VOID ? this.rax_1 : roleId;
  departmentId = departmentId === VOID ? this.sax_1 : departmentId;
  confirmedRoleId = confirmedRoleId === VOID ? this.tax_1 : confirmedRoleId;
  healthCheckQuestionnaireResponseId = healthCheckQuestionnaireResponseId === VOID ? this.uax_1 : healthCheckQuestionnaireResponseId;
  return $super === VOID ? this.vax(employeePunchId, clockResponseHandler, roleId, departmentId, confirmedRoleId, healthCheckQuestionnaireResponseId) : $super.vax.call(this, employeePunchId, clockResponseHandler, roleId, departmentId, confirmedRoleId, healthCheckQuestionnaireResponseId);
};
protoOf(PunchContext).toString = function () {
  return 'PunchContext(employeePunchId=' + this.pax_1 + ', clockResponseHandler=' + toString(this.qax_1) + ', roleId=' + toString_0(this.rax_1) + ', departmentId=' + toString_0(this.sax_1) + ', confirmedRoleId=' + toString_0(this.tax_1) + ', healthCheckQuestionnaireResponseId=' + this.uax_1 + ')';
};
protoOf(PunchContext).hashCode = function () {
  var result = getStringHashCode(this.pax_1);
  result = imul(result, 31) + hashCode(this.qax_1) | 0;
  result = imul(result, 31) + (this.rax_1 == null ? 0 : this.rax_1.hashCode()) | 0;
  result = imul(result, 31) + (this.sax_1 == null ? 0 : this.sax_1.hashCode()) | 0;
  result = imul(result, 31) + (this.tax_1 == null ? 0 : this.tax_1.hashCode()) | 0;
  result = imul(result, 31) + (this.uax_1 == null ? 0 : getStringHashCode(this.uax_1)) | 0;
  return result;
};
protoOf(PunchContext).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PunchContext))
    return false;
  var tmp0_other_with_cast = other instanceof PunchContext ? other : THROW_CCE();
  if (!(this.pax_1 === tmp0_other_with_cast.pax_1))
    return false;
  if (!equals(this.qax_1, tmp0_other_with_cast.qax_1))
    return false;
  if (!equals(this.rax_1, tmp0_other_with_cast.rax_1))
    return false;
  if (!equals(this.sax_1, tmp0_other_with_cast.sax_1))
    return false;
  if (!equals(this.tax_1, tmp0_other_with_cast.tax_1))
    return false;
  if (!(this.uax_1 == tmp0_other_with_cast.uax_1))
    return false;
  return true;
};
function handleClockResponse($this, response, punchContext, $completion) {
  var tmp = new $handleClockResponseCOROUTINE$1($this, response, punchContext, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function PunchFlowService$handleClockResponse$ref($boundThis) {
  this.pay_1 = $boundThis;
}
protoOf(PunchFlowService$handleClockResponse$ref).qay = function (p0, p1, $completion) {
  return handleClockResponse(this.pay_1, p0, p1, $completion);
};
protoOf(PunchFlowService$handleClockResponse$ref).i9 = function (p1, p2, $completion) {
  var tmp = p1 instanceof ClockResponse ? p1 : THROW_CCE();
  return this.qay(tmp, p2 instanceof PunchContext ? p2 : THROW_CCE(), $completion);
};
function PunchFlowService$handleClockResponse$ref_0($boundThis) {
  var i = new PunchFlowService$handleClockResponse$ref($boundThis);
  var l = function (p0, p1, $completion) {
    return i.qay(p0, p1, $completion);
  };
  l.callableName = 'handleClockResponse';
  l.$arity = 2;
  return l;
}
function $startCOROUTINE$0(_this__u8e3s4, employeePunchId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.zay_1 = _this__u8e3s4;
  this.aaz_1 = employeePunchId;
}
protoOf($startCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.zay_1.saz_1.n9q(this.aaz_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.caz_1 = suspendResult.ul_1;
          suspendResult = new Result(this.caz_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.daz_1 = suspendResult.ul_1;
          var tmp_0 = this;
          var this_0 = this.daz_1;
          throwOnFailure(this_0);
          var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
          tmp_0.eaz_1 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
          var tmp_2 = this;
          tmp_2.faz_1 = new PunchContext(this.aaz_1, PunchFlowService$handleClockResponse$ref_0(this.zay_1));
          this.baz_1 = new Success(toUserStatusResponse(this.eaz_1, this.zay_1.paz_1, this.faz_1, this.zay_1.taz_1));
          this.o8_1 = 7;
          this.n8_1 = 8;
          continue $sm;
        case 3:
          this.o8_1 = 7;
          var tmp_3 = this.q8_1;
          if (tmp_3 instanceof CancellationException) {
            this.gaz_1 = this.q8_1;
            var tmp_4 = this;
            throw this.gaz_1;
          } else {
            var tmp_5 = this.q8_1;
            if (tmp_5 instanceof Error) {
              this.haz_1 = this.q8_1;
              var tmp_6 = this;
              var tmp1 = this.zay_1.ab0_1;
              var tmp$ret$0;
              l$ret$1: do {
                var _iterator__ex2g4s = tmp1.j();
                while (_iterator__ex2g4s.k()) {
                  var element = _iterator__ex2g4s.l();
                  if (element.bb0(this.haz_1)) {
                    tmp$ret$0 = element;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = null;
              }
               while (false);
              tmp_6.iaz_1 = tmp$ret$0;
              if (this.iaz_1 == null) {
                this.jaz_1 = null;
                this.n8_1 = 6;
                continue $sm;
              } else {
                var tmp_7 = this;
                tmp_7.kaz_1 = this.iaz_1;
                this.laz_1 = this.kaz_1;
                var tmp_8 = this;
                tmp_8.maz_1 = this.laz_1;
                this.naz_1 = this.maz_1;
                this.oaz_1 = Companion_instance_1;
                this.n8_1 = 4;
                suspendResult = this.naz_1.cb0(this.haz_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                this.n8_1 = 5;
                continue $sm;
              }
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 5;
          continue $sm;
        case 5:
          var ARGUMENT = suspendResult.ul_1;
          this.jaz_1 = this.oaz_1.a2u(ARGUMENT);
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var tmp1_elvis_lhs = this.jaz_1;
          this.baz_1 = tmp1_elvis_lhs == null ? new Failure(Companion_instance_2.b2u(this.haz_1)) : tmp1_elvis_lhs;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          throw this.q8_1;
        case 8:
          this.o8_1 = 7;
          return this.baz_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $handleClockResponseCOROUTINE$1(_this__u8e3s4, response, punchContext, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.fay_1 = _this__u8e3s4;
  this.gay_1 = response;
  this.hay_1 = punchContext;
}
protoOf($handleClockResponseCOROUTINE$1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 6;
          var tmp_0 = this;
          tmp_0.iay_1 = this.fay_1.zaz_1;
          this.jay_1 = this.iay_1;
          this.kay_1 = this.jay_1.j();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!this.kay_1.k()) {
            this.n8_1 = 5;
            continue $sm;
          }

          this.lay_1 = this.kay_1.l();
          var tmp_1 = this;
          tmp_1.may_1 = this.lay_1;
          this.nay_1 = this.may_1;
          if (this.nay_1.eb0(this.gay_1, this.hay_1)) {
            this.oay_1 = Companion_instance_1;
            this.n8_1 = 3;
            suspendResult = this.nay_1.db0(this.gay_1, this.hay_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            this.n8_1 = 4;
            continue $sm;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 2:
          this.n8_1 = 1;
          continue $sm;
        case 3:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          var ARGUMENT = suspendResult.ul_1;
          return this.oay_1.a2u(ARGUMENT);
        case 5:
          return new Failure(Companion_instance_2.b2u(IllegalStateException_init_$Create$('No strategy matched the response')));
        case 6:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 6) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function PunchFlowService(clockRepository, attestationRepository, healthCheckRepository, userStatusAccessor, logger) {
  this.paz_1 = clockRepository;
  this.qaz_1 = attestationRepository;
  this.raz_1 = healthCheckRepository;
  this.saz_1 = userStatusAccessor;
  this.taz_1 = logger;
  this.uaz_1 = new HealthCheckRequiredStrategy(this.paz_1, this.raz_1);
  var tmp = this;
  var tmp0_clockRepository = this.paz_1;
  var tmp1_attestationRepository = this.qaz_1;
  tmp.vaz_1 = new AttestationRequiredStrategy(tmp1_attestationRepository, tmp0_clockRepository);
  this.waz_1 = new TipsNeededStrategy(this.paz_1);
  this.xaz_1 = new RoleSelectionStrategy(this.paz_1);
  this.yaz_1 = new DepartmentSelectionStrategy(this.paz_1);
  this.zaz_1 = listOf([PunchedInStrategy_instance, PunchedOutStrategy_instance, this.vaz_1, this.uaz_1, HealthCheckFailedStrategy_instance, this.waz_1, this.xaz_1, this.yaz_1, BreakTooShortStrategy_instance]);
  this.ab0_1 = listOf_0(InvalidPunchIdStrategy_instance);
}
protoOf(PunchFlowService).fb0 = function (employeePunchId, $completion) {
  var tmp = new $startCOROUTINE$0(this, employeePunchId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function toUserStatusResponse(_this__u8e3s4, clockRepository, punchContext, logger) {
  var user = toUser(_this__u8e3s4.n9t_1);
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.o9t_1;
  var tmp;
  if ($this$with instanceof ClockedOut) {
    var tmp2_availableActions = _this__u8e3s4.p9t_1;
    var tmp3_serverTime = _this__u8e3s4.q9t_1;
    tmp = toClockedOutUserStatusResponse($this$with, user, tmp3_serverTime, tmp2_availableActions, clockRepository, punchContext, logger);
  } else {
    if ($this$with instanceof ClockedIn) {
      tmp = toClockedInUserStatusResponse($this$with, user, _this__u8e3s4.p9t_1, _this__u8e3s4.q9t_1, clockRepository, punchContext, logger);
    } else {
      if ($this$with instanceof OnBreak) {
        tmp = toOnBreakUserStatusResponse($this$with, user, _this__u8e3s4.p9t_1, _this__u8e3s4.q9t_1, clockRepository, punchContext, logger);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return tmp;
}
function toClockedOutUserStatusResponse(_this__u8e3s4, user, serverTime, availableActions, clockRepository, punchContext, logger) {
  var tmp0_safe_receiver = _this__u8e3s4.u9s_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toShift(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new PreferredShift(tmp1_safe_receiver, _this__u8e3s4.v9s_1);
  }
  var preferredShift = tmp;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var _iterator__ex2g4s = availableActions.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var list = toAvailableAction(element, clockRepository, punchContext, preferredShift, null, logger);
    addAll(destination, list);
  }
  return new ClockedOut_1(user, toSet(destination), preferredShift, serverTime);
}
function toClockedInUserStatusResponse(_this__u8e3s4, user, availableActions, serverTime, clockRepository, punchContext, logger) {
  var tmp0_safe_receiver = _this__u8e3s4.x9s_1;
  var currentShift = tmp0_safe_receiver == null ? null : toShift(tmp0_safe_receiver);
  var punch = toPunch(_this__u8e3s4.w9s_1, currentShift);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var _iterator__ex2g4s = availableActions.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_safe_receiver_0 = _this__u8e3s4.y9s_1;
    var tmp;
    if (tmp0_safe_receiver_0 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_safe_receiver_0, 10));
      var _iterator__ex2g4s_0 = tmp0_safe_receiver_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var item = _iterator__ex2g4s_0.l();
        var tmp$ret$0 = new CustomBreak(item.g9t_1, item.h9t_1, item.i9t_1);
        destination_0.e(tmp$ret$0);
      }
      tmp = destination_0;
    }
    var list = toAvailableAction(element, clockRepository, punchContext, null, tmp, logger);
    addAll(destination, list);
  }
  return new ClockedIn_1(user, toSet(destination), punch, currentShift, serverTime);
}
function toOnBreakUserStatusResponse(_this__u8e3s4, user, availableActions, serverTime, clockRepository, punchContext, logger) {
  var tmp0_safe_receiver = _this__u8e3s4.a9t_1;
  var currentShift = tmp0_safe_receiver == null ? null : toShift(tmp0_safe_receiver);
  var punch = toPunch(_this__u8e3s4.z9s_1, currentShift);
  var currentBreak = toBreak(_this__u8e3s4.b9t_1);
  var availableActions_0 = plus(availableActions, TimePunchUserAction_END_BREAK_getInstance());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var _iterator__ex2g4s = availableActions_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var list = toAvailableAction(element, clockRepository, punchContext, null, null, logger);
    addAll(destination, list);
  }
  return new OnBreak_0(user, toSet(destination), punch, currentShift, currentBreak, serverTime);
}
function toUser(_this__u8e3s4) {
  return new User(_this__u8e3s4.j9t_1, _this__u8e3s4.k9t_1, _this__u8e3s4.l9t_1, _this__u8e3s4.m9t_1);
}
function toPunch(_this__u8e3s4, currentShift) {
  var tmp;
  if (currentShift == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = !equals(currentShift.hb0_1, _this__u8e3s4.d9t_1);
  }
  var tmp1_elvis_lhs = tmp;
  return new Punch(_this__u8e3s4.c9t_1, _this__u8e3s4.d9t_1, tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
}
function toShift(_this__u8e3s4) {
  var tmp0_subject = _this__u8e3s4.p9o_1;
  var tmp;
  switch (tmp0_subject == null ? -1 : tmp0_subject.l2_1) {
    case 0:
      tmp = EndCriteria_CLOSE_getInstance();
      break;
    case 1:
      tmp = EndCriteria_BUSINESS_DECLINE_getInstance();
      break;
    case -1:
      tmp = null;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return new Shift(_this__u8e3s4.l9o_1, _this__u8e3s4.m9o_1, _this__u8e3s4.n9o_1, _this__u8e3s4.o9o_1, tmp);
}
function toBreak(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.f9t_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new CustomBreak(tmp0_safe_receiver.g9t_1, tmp0_safe_receiver.h9t_1, tmp0_safe_receiver.i9t_1);
  }
  var customBreak = tmp;
  var tmp_0;
  if (customBreak == null) {
    tmp_0 = new Regular(_this__u8e3s4.e9t_1);
  } else {
    Companion_getInstance_0();
    // Inline function 'kotlin.time.Companion.minutes' call
    var this_0 = customBreak.nb0_1;
    var tmp$ret$2 = toDuration(this_0, DurationUnit_MINUTES_getInstance());
    tmp_0 = new Custom(_this__u8e3s4.e9t_1, _this__u8e3s4.e9t_1.j2t(tmp$ret$2), customBreak);
  }
  return tmp_0;
}
function getRoleId(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Role) {
    tmp = _this__u8e3s4.a90_1.e90_1;
  } else {
    if (_this__u8e3s4 instanceof Department) {
      tmp = null;
    } else {
      if (equals(_this__u8e3s4, Location_instance)) {
        tmp = null;
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return tmp;
}
function getDepartmentId(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Department) {
    tmp = _this__u8e3s4.b90_1.c90_1;
  } else {
    if (_this__u8e3s4 instanceof Role) {
      var tmp1_safe_receiver = _this__u8e3s4.a90_1.h90_1;
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c90_1;
    } else {
      if (equals(_this__u8e3s4, Location_instance)) {
        tmp = null;
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return tmp;
}
function toAvailableAction(_this__u8e3s4, clockRepository, punchContext, preferredShift, availableCustomBreaks, logger) {
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList_init_$Create$();
  switch (_this__u8e3s4.l2_1) {
    case 0:
      if (!(preferredShift == null)) {
        this_0.e(new StartShift(toAvailableAction$slambda_0(preferredShift, clockRepository, punchContext, null)));
      } else {
        this_0.e(new StartUnscheduledShift(toAvailableAction$slambda_2(clockRepository, punchContext, null)));
      }

      break;
    case 1:
      this_0.e(new ClockOut(toAvailableAction$slambda_4(clockRepository, punchContext, null)));
      break;
    case 2:
      this_0.e(new StartPaidBreak(toAvailableAction$slambda_6(clockRepository, punchContext, null)));
      break;
    case 3:
      this_0.e(new StartUnpaidBreak(toAvailableAction$slambda_8(clockRepository, punchContext, null)));
      break;
    case 4:
      // Inline function 'kotlin.collections.isNullOrEmpty' call

      if (availableCustomBreaks == null || availableCustomBreaks.p()) {
        logger.i6e(Companion_instance_0.s6e('UserStatusMapper | Unable to build StartCustomBreak action. No custom breaks available with action START_CUSTOM_BREAK'));
      } else {
        this_0.e(new StartCustomBreak(availableCustomBreaks, toAvailableAction$slambda_10(clockRepository, punchContext, null)));
      }

      break;
    case 5:
      this_0.e(new EndBreak(toAvailableAction$slambda_12(clockRepository, punchContext, null)));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return this_0.i5();
}
function handleStartShift(switchToRoleId, preferredShift, clockRepository, punchContext, $completion) {
  var tmp = new $handleStartShiftCOROUTINE$2(switchToRoleId, preferredShift, clockRepository, punchContext, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function toAvailableAction$slambda($preferredShift, $clockRepository, $punchContext, resultContinuation) {
  this.rb2_1 = $preferredShift;
  this.sb2_1 = $clockRepository;
  this.tb2_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(toAvailableAction$slambda).vb2 = function (switchToRoleId, $completion) {
  var tmp = this.wb2(switchToRoleId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(toAvailableAction$slambda).h9 = function (p1, $completion) {
  return this.vb2((p1 == null ? true : p1 instanceof Long) ? p1 : THROW_CCE(), $completion);
};
protoOf(toAvailableAction$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = handleStartShift(this.ub2_1, this.rb2_1, this.sb2_1, this.tb2_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(toAvailableAction$slambda).wb2 = function (switchToRoleId, completion) {
  var i = new toAvailableAction$slambda(this.rb2_1, this.sb2_1, this.tb2_1, completion);
  i.ub2_1 = switchToRoleId;
  return i;
};
function toAvailableAction$slambda_0($preferredShift, $clockRepository, $punchContext, resultContinuation) {
  var i = new toAvailableAction$slambda($preferredShift, $clockRepository, $punchContext, resultContinuation);
  var l = function (switchToRoleId, $completion) {
    return i.vb2(switchToRoleId, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAvailableAction$slambda_1($clockRepository, $punchContext, resultContinuation) {
  this.fb3_1 = $clockRepository;
  this.gb3_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(toAvailableAction$slambda_1).ub3 = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(toAvailableAction$slambda_1).ma = function ($completion) {
  return this.ub3($completion);
};
protoOf(toAvailableAction$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.hb3_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.fb3_1.l9c(this.gb3_1.pax_1, null, null, null, null, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.ib3_1 = suspendResult.ul_1;
          suspendResult = new Result(this.ib3_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.jb3_1 = suspendResult.ul_1;
          this.kb3_1 = this.jb3_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.kb3_1)) {
            var tmp_0 = this;
            tmp_0.mb3_1 = new Result(this.kb3_1);
            this.nb3_1 = this.mb3_1;
            this.o8_1 = 4;
            var tmp_1 = this;
            tmp_1.pb3_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.qb3_1 = this.nb3_1.ul_1;
            this.rb3_1 = this.qb3_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.rb3_1);
            tmp_3.sb3_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.tb3_1 = this.sb3_1;
            this.n8_1 = 3;
            suspendResult = this.gb3_1.qax_1(this.tb3_1, this.gb3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.lb3_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.kb3_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_5 = this;
          this.pb3_1;
          tmp_5.ob3_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            tmp_7.ob3_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 7;
          this.lb3_1 = this.ob3_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var ARGUMENT_0 = this.lb3_1;
          return this.hb3_1.a2u(ARGUMENT_0);
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 7) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(toAvailableAction$slambda_1).m32 = function (completion) {
  return new toAvailableAction$slambda_1(this.fb3_1, this.gb3_1, completion);
};
function toAvailableAction$slambda_2($clockRepository, $punchContext, resultContinuation) {
  var i = new toAvailableAction$slambda_1($clockRepository, $punchContext, resultContinuation);
  var l = function ($completion) {
    return i.ub3($completion);
  };
  l.$arity = 0;
  return l;
}
function toAvailableAction$slambda_3($clockRepository, $punchContext, resultContinuation) {
  this.db4_1 = $clockRepository;
  this.eb4_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(toAvailableAction$slambda_3).ub3 = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(toAvailableAction$slambda_3).ma = function ($completion) {
  return this.ub3($completion);
};
protoOf(toAvailableAction$slambda_3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.fb4_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.db4_1.n9c(this.eb4_1.pax_1, VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.gb4_1 = suspendResult.ul_1;
          suspendResult = new Result(this.gb4_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.hb4_1 = suspendResult.ul_1;
          this.ib4_1 = this.hb4_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.ib4_1)) {
            var tmp_0 = this;
            tmp_0.kb4_1 = new Result(this.ib4_1);
            this.lb4_1 = this.kb4_1;
            this.o8_1 = 4;
            var tmp_1 = this;
            tmp_1.nb4_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.ob4_1 = this.lb4_1.ul_1;
            this.pb4_1 = this.ob4_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.pb4_1);
            tmp_3.qb4_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.rb4_1 = this.qb4_1;
            this.n8_1 = 3;
            suspendResult = this.eb4_1.qax_1(this.rb4_1, this.eb4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.jb4_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.ib4_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_5 = this;
          this.nb4_1;
          tmp_5.mb4_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            tmp_7.mb4_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 7;
          this.jb4_1 = this.mb4_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var ARGUMENT_0 = this.jb4_1;
          return this.fb4_1.a2u(ARGUMENT_0);
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 7) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(toAvailableAction$slambda_3).m32 = function (completion) {
  return new toAvailableAction$slambda_3(this.db4_1, this.eb4_1, completion);
};
function toAvailableAction$slambda_4($clockRepository, $punchContext, resultContinuation) {
  var i = new toAvailableAction$slambda_3($clockRepository, $punchContext, resultContinuation);
  var l = function ($completion) {
    return i.ub3($completion);
  };
  l.$arity = 0;
  return l;
}
function toAvailableAction$slambda_5($clockRepository, $punchContext, resultContinuation) {
  this.ab5_1 = $clockRepository;
  this.bb5_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(toAvailableAction$slambda_5).ub3 = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(toAvailableAction$slambda_5).ma = function ($completion) {
  return this.ub3($completion);
};
protoOf(toAvailableAction$slambda_5).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.cb5_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.ab5_1.o9c(this.bb5_1.pax_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.db5_1 = suspendResult.ul_1;
          suspendResult = new Result(this.db5_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.eb5_1 = suspendResult.ul_1;
          this.fb5_1 = this.eb5_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.fb5_1)) {
            var tmp_0 = this;
            tmp_0.hb5_1 = new Result(this.fb5_1);
            this.ib5_1 = this.hb5_1;
            this.o8_1 = 4;
            var tmp_1 = this;
            tmp_1.kb5_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.lb5_1 = this.ib5_1.ul_1;
            this.mb5_1 = this.lb5_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.mb5_1);
            tmp_3.nb5_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.ob5_1 = this.nb5_1;
            this.n8_1 = 3;
            suspendResult = this.bb5_1.qax_1(this.ob5_1, this.bb5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.gb5_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.fb5_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_5 = this;
          this.kb5_1;
          tmp_5.jb5_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            tmp_7.jb5_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 7;
          this.gb5_1 = this.jb5_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var ARGUMENT_0 = this.gb5_1;
          return this.cb5_1.a2u(ARGUMENT_0);
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 7) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(toAvailableAction$slambda_5).m32 = function (completion) {
  return new toAvailableAction$slambda_5(this.ab5_1, this.bb5_1, completion);
};
function toAvailableAction$slambda_6($clockRepository, $punchContext, resultContinuation) {
  var i = new toAvailableAction$slambda_5($clockRepository, $punchContext, resultContinuation);
  var l = function ($completion) {
    return i.ub3($completion);
  };
  l.$arity = 0;
  return l;
}
function toAvailableAction$slambda_7($clockRepository, $punchContext, resultContinuation) {
  this.xb5_1 = $clockRepository;
  this.yb5_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(toAvailableAction$slambda_7).ub3 = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(toAvailableAction$slambda_7).ma = function ($completion) {
  return this.ub3($completion);
};
protoOf(toAvailableAction$slambda_7).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.zb5_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.xb5_1.p9c(this.yb5_1.pax_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.ab6_1 = suspendResult.ul_1;
          suspendResult = new Result(this.ab6_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.bb6_1 = suspendResult.ul_1;
          this.cb6_1 = this.bb6_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.cb6_1)) {
            var tmp_0 = this;
            tmp_0.eb6_1 = new Result(this.cb6_1);
            this.fb6_1 = this.eb6_1;
            this.o8_1 = 4;
            var tmp_1 = this;
            tmp_1.hb6_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.ib6_1 = this.fb6_1.ul_1;
            this.jb6_1 = this.ib6_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.jb6_1);
            tmp_3.kb6_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.lb6_1 = this.kb6_1;
            this.n8_1 = 3;
            suspendResult = this.yb5_1.qax_1(this.lb6_1, this.yb5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.db6_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.cb6_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_5 = this;
          this.hb6_1;
          tmp_5.gb6_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            tmp_7.gb6_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 7;
          this.db6_1 = this.gb6_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var ARGUMENT_0 = this.db6_1;
          return this.zb5_1.a2u(ARGUMENT_0);
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 7) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(toAvailableAction$slambda_7).m32 = function (completion) {
  return new toAvailableAction$slambda_7(this.xb5_1, this.yb5_1, completion);
};
function toAvailableAction$slambda_8($clockRepository, $punchContext, resultContinuation) {
  var i = new toAvailableAction$slambda_7($clockRepository, $punchContext, resultContinuation);
  var l = function ($completion) {
    return i.ub3($completion);
  };
  l.$arity = 0;
  return l;
}
function toAvailableAction$slambda_9($clockRepository, $punchContext, resultContinuation) {
  this.ub6_1 = $clockRepository;
  this.vb6_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(toAvailableAction$slambda_9).kb7 = function (customBreakId, $completion) {
  var tmp = this.u7d(customBreakId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(toAvailableAction$slambda_9).h9 = function (p1, $completion) {
  return this.kb7(p1 instanceof Long ? p1 : THROW_CCE(), $completion);
};
protoOf(toAvailableAction$slambda_9).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.xb6_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.ub6_1.q9c(this.vb6_1.pax_1, this.wb6_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.yb6_1 = suspendResult.ul_1;
          suspendResult = new Result(this.yb6_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.zb6_1 = suspendResult.ul_1;
          this.ab7_1 = this.zb6_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.ab7_1)) {
            var tmp_0 = this;
            tmp_0.cb7_1 = new Result(this.ab7_1);
            this.db7_1 = this.cb7_1;
            this.o8_1 = 4;
            var tmp_1 = this;
            tmp_1.fb7_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.gb7_1 = this.db7_1.ul_1;
            this.hb7_1 = this.gb7_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.hb7_1);
            tmp_3.ib7_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.jb7_1 = this.ib7_1;
            this.n8_1 = 3;
            suspendResult = this.vb6_1.qax_1(this.jb7_1, this.vb6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.bb7_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.ab7_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_5 = this;
          this.fb7_1;
          tmp_5.eb7_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            tmp_7.eb7_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 7;
          this.bb7_1 = this.eb7_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var ARGUMENT_0 = this.bb7_1;
          return this.xb6_1.a2u(ARGUMENT_0);
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 7) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(toAvailableAction$slambda_9).u7d = function (customBreakId, completion) {
  var i = new toAvailableAction$slambda_9(this.ub6_1, this.vb6_1, completion);
  i.wb6_1 = customBreakId;
  return i;
};
function toAvailableAction$slambda_10($clockRepository, $punchContext, resultContinuation) {
  var i = new toAvailableAction$slambda_9($clockRepository, $punchContext, resultContinuation);
  var l = function (customBreakId, $completion) {
    return i.kb7(customBreakId, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAvailableAction$slambda_11($clockRepository, $punchContext, resultContinuation) {
  this.tb7_1 = $clockRepository;
  this.ub7_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(toAvailableAction$slambda_11).ub3 = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(toAvailableAction$slambda_11).ma = function ($completion) {
  return this.ub3($completion);
};
protoOf(toAvailableAction$slambda_11).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.vb7_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.tb7_1.r9c(this.ub7_1.pax_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.wb7_1 = suspendResult.ul_1;
          suspendResult = new Result(this.wb7_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.xb7_1 = suspendResult.ul_1;
          this.yb7_1 = this.xb7_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.yb7_1)) {
            var tmp_0 = this;
            tmp_0.ab8_1 = new Result(this.yb7_1);
            this.bb8_1 = this.ab8_1;
            this.o8_1 = 4;
            var tmp_1 = this;
            tmp_1.db8_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.eb8_1 = this.bb8_1.ul_1;
            this.fb8_1 = this.eb8_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.fb8_1);
            tmp_3.gb8_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.hb8_1 = this.gb8_1;
            this.n8_1 = 3;
            suspendResult = this.ub7_1.qax_1(this.hb8_1, this.ub7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.zb7_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.yb7_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_5 = this;
          this.db8_1;
          tmp_5.cb8_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            tmp_7.cb8_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 7;
          this.zb7_1 = this.cb8_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var ARGUMENT_0 = this.zb7_1;
          return this.vb7_1.a2u(ARGUMENT_0);
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 7) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(toAvailableAction$slambda_11).m32 = function (completion) {
  return new toAvailableAction$slambda_11(this.tb7_1, this.ub7_1, completion);
};
function toAvailableAction$slambda_12($clockRepository, $punchContext, resultContinuation) {
  var i = new toAvailableAction$slambda_11($clockRepository, $punchContext, resultContinuation);
  var l = function ($completion) {
    return i.ub3($completion);
  };
  l.$arity = 0;
  return l;
}
function $handleStartShiftCOROUTINE$2(switchToRoleId, preferredShift, clockRepository, punchContext, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.wb0_1 = switchToRoleId;
  this.xb0_1 = preferredShift;
  this.yb0_1 = clockRepository;
  this.zb0_1 = punchContext;
}
protoOf($handleStartShiftCOROUTINE$2).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 14;
          var tmp_0 = this;
          tmp_0.ab1_1 = this.xb0_1;
          this.bb1_1 = this.ab1_1;
          var tmp_1 = this;
          tmp_1.cb1_1 = this.bb1_1;
          this.db1_1 = this.cb1_1;
          if (this.wb0_1 == null || equals(getRoleId(this.xb0_1.ib8_1.hb0_1), this.wb0_1)) {
            this.fb1_1 = Companion_instance_1;
            this.n8_1 = 7;
            suspendResult = this.yb0_1.l9c(this.zb0_1.pax_1, getRoleId(this.xb0_1.ib8_1.hb0_1), getDepartmentId(this.xb0_1.ib8_1.hb0_1), null, null, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            this.n8_1 = 8;
            continue $sm;
          } else {
            this.gb1_1 = Companion_instance_1;
            this.n8_1 = 1;
            suspendResult = this.yb0_1.l9c(this.zb0_1.pax_1, null, null, this.wb0_1, null, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            this.n8_1 = 2;
            continue $sm;
          }

        case 1:
          this.hb1_1 = suspendResult.ul_1;
          suspendResult = new Result(this.hb1_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.ib1_1 = suspendResult.ul_1;
          this.jb1_1 = this.ib1_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.jb1_1)) {
            var tmp_2 = this;
            tmp_2.lb1_1 = new Result(this.jb1_1);
            this.mb1_1 = this.lb1_1;
            this.o8_1 = 4;
            var tmp_3 = this;
            tmp_3.ob1_1 = Companion_instance;
            var tmp_4 = this;
            tmp_4.pb1_1 = this.mb1_1.ul_1;
            this.qb1_1 = this.pb1_1;
            var tmp_5 = this;
            var tmp_6 = _Result___get_value__impl__bjfvqg(this.qb1_1);
            tmp_5.rb1_1 = (tmp_6 == null ? true : !(tmp_6 == null)) ? tmp_6 : THROW_CCE();
            this.sb1_1 = this.rb1_1;
            this.n8_1 = 3;
            suspendResult = this.zb0_1.qax_1(this.sb1_1, this.zb0_1.wax(VOID, VOID, VOID, VOID, this.wb0_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.kb1_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.jb1_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          this.tb1_1 = suspendResult;
          this.ub1_1 = this.tb1_1.y2t();
          var tmp_7 = this;
          this.ob1_1;
          var value = this.ub1_1;
          tmp_7.nb1_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 14;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 14;
          var tmp_8 = this.q8_1;
          if (tmp_8 instanceof Error) {
            this.vb1_1 = this.q8_1;
            var tmp_9 = this;
            var exception = this.vb1_1;
            tmp_9.nb1_1 = _Result___init__impl__xyqfz8(createFailure(exception));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 14;
          this.kb1_1 = this.nb1_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          this.wb1_1 = this.kb1_1;
          this.eb1_1 = this.gb1_1.a2u(this.wb1_1);
          this.n8_1 = 13;
          continue $sm;
        case 7:
          this.xb1_1 = suspendResult.ul_1;
          suspendResult = new Result(this.xb1_1);
          this.n8_1 = 8;
          continue $sm;
        case 8:
          this.yb1_1 = suspendResult.ul_1;
          this.zb1_1 = this.yb1_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.zb1_1)) {
            var tmp_10 = this;
            tmp_10.bb2_1 = new Result(this.zb1_1);
            this.cb2_1 = this.bb2_1;
            this.o8_1 = 10;
            var tmp_11 = this;
            tmp_11.eb2_1 = Companion_instance;
            var tmp_12 = this;
            tmp_12.fb2_1 = this.cb2_1.ul_1;
            this.gb2_1 = this.fb2_1;
            var tmp_13 = this;
            var tmp_14 = _Result___get_value__impl__bjfvqg(this.gb2_1);
            tmp_13.hb2_1 = (tmp_14 == null ? true : !(tmp_14 == null)) ? tmp_14 : THROW_CCE();
            this.ib2_1 = this.hb2_1;
            this.n8_1 = 9;
            suspendResult = this.zb0_1.qax_1(this.ib2_1, this.zb0_1.wax(VOID, VOID, getRoleId(this.xb0_1.ib8_1.hb0_1), getDepartmentId(this.xb0_1.ib8_1.hb0_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.ab2_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.zb1_1));
            this.n8_1 = 12;
            continue $sm;
          }

        case 9:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_15 = this;
          this.eb2_1;
          tmp_15.db2_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 14;
          this.n8_1 = 11;
          continue $sm;
        case 10:
          this.o8_1 = 14;
          var tmp_16 = this.q8_1;
          if (tmp_16 instanceof Error) {
            var e = this.q8_1;
            var tmp_17 = this;
            tmp_17.db2_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 11;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 11:
          this.o8_1 = 14;
          this.ab2_1 = this.db2_1;
          this.n8_1 = 12;
          continue $sm;
        case 12:
          var ARGUMENT_0 = this.ab2_1;
          this.eb1_1 = this.fb1_1.a2u(ARGUMENT_0);
          this.n8_1 = 13;
          continue $sm;
        case 13:
          return this.eb1_1;
        case 14:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 14) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function AttestationRequired(attestation, sendAttestationResponse) {
  this.kb8_1 = attestation;
  this.lb8_1 = sendAttestationResponse;
}
protoOf(AttestationRequired).toString = function () {
  return 'AttestationRequired(attestation=' + this.kb8_1.toString() + ', sendAttestationResponse=' + toString(this.lb8_1) + ')';
};
protoOf(AttestationRequired).hashCode = function () {
  var result = this.kb8_1.hashCode();
  result = imul(result, 31) + hashCode(this.lb8_1) | 0;
  return result;
};
protoOf(AttestationRequired).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AttestationRequired))
    return false;
  var tmp0_other_with_cast = other instanceof AttestationRequired ? other : THROW_CCE();
  if (!this.kb8_1.equals(tmp0_other_with_cast.kb8_1))
    return false;
  if (!equals(this.lb8_1, tmp0_other_with_cast.lb8_1))
    return false;
  return true;
};
function HealthCheckRequired(questionnaires, submitResponses) {
  this.mb8_1 = questionnaires;
  this.nb8_1 = submitResponses;
}
protoOf(HealthCheckRequired).toString = function () {
  return 'HealthCheckRequired(questionnaires=' + toString(this.mb8_1) + ', submitResponses=' + toString(this.nb8_1) + ')';
};
protoOf(HealthCheckRequired).hashCode = function () {
  var result = hashCode(this.mb8_1);
  result = imul(result, 31) + hashCode(this.nb8_1) | 0;
  return result;
};
protoOf(HealthCheckRequired).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HealthCheckRequired))
    return false;
  var tmp0_other_with_cast = other instanceof HealthCheckRequired ? other : THROW_CCE();
  if (!equals(this.mb8_1, tmp0_other_with_cast.mb8_1))
    return false;
  if (!equals(this.nb8_1, tmp0_other_with_cast.nb8_1))
    return false;
  return true;
};
function TipsNeeded(sendTips) {
  this.ob8_1 = sendTips;
}
protoOf(TipsNeeded).toString = function () {
  return 'TipsNeeded(sendTips=' + toString(this.ob8_1) + ')';
};
protoOf(TipsNeeded).hashCode = function () {
  return hashCode(this.ob8_1);
};
protoOf(TipsNeeded).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TipsNeeded))
    return false;
  var tmp0_other_with_cast = other instanceof TipsNeeded ? other : THROW_CCE();
  if (!equals(this.ob8_1, tmp0_other_with_cast.ob8_1))
    return false;
  return true;
};
function RoleSelectionRequired(roles, selectRole) {
  this.pb8_1 = roles;
  this.qb8_1 = selectRole;
}
protoOf(RoleSelectionRequired).toString = function () {
  return 'RoleSelectionRequired(roles=' + toString(this.pb8_1) + ', selectRole=' + toString(this.qb8_1) + ')';
};
protoOf(RoleSelectionRequired).hashCode = function () {
  var result = hashCode(this.pb8_1);
  result = imul(result, 31) + hashCode(this.qb8_1) | 0;
  return result;
};
protoOf(RoleSelectionRequired).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RoleSelectionRequired))
    return false;
  var tmp0_other_with_cast = other instanceof RoleSelectionRequired ? other : THROW_CCE();
  if (!equals(this.pb8_1, tmp0_other_with_cast.pb8_1))
    return false;
  if (!equals(this.qb8_1, tmp0_other_with_cast.qb8_1))
    return false;
  return true;
};
function DepartmentSelectionRequired(departments, selectDepartment) {
  this.rb8_1 = departments;
  this.sb8_1 = selectDepartment;
}
protoOf(DepartmentSelectionRequired).toString = function () {
  return 'DepartmentSelectionRequired(departments=' + toString(this.rb8_1) + ', selectDepartment=' + toString(this.sb8_1) + ')';
};
protoOf(DepartmentSelectionRequired).hashCode = function () {
  var result = hashCode(this.rb8_1);
  result = imul(result, 31) + hashCode(this.sb8_1) | 0;
  return result;
};
protoOf(DepartmentSelectionRequired).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DepartmentSelectionRequired))
    return false;
  var tmp0_other_with_cast = other instanceof DepartmentSelectionRequired ? other : THROW_CCE();
  if (!equals(this.rb8_1, tmp0_other_with_cast.rb8_1))
    return false;
  if (!equals(this.sb8_1, tmp0_other_with_cast.sb8_1))
    return false;
  return true;
};
function BreakStarted(timePunchId, breakId, userPhotoUrl, message) {
  this.tb8_1 = timePunchId;
  this.ub8_1 = breakId;
  this.vb8_1 = userPhotoUrl;
  this.wb8_1 = message;
}
protoOf(BreakStarted).toString = function () {
  return 'BreakStarted(timePunchId=' + this.tb8_1.toString() + ', breakId=' + this.ub8_1.toString() + ', userPhotoUrl=' + this.vb8_1 + ', message=' + this.wb8_1 + ')';
};
protoOf(BreakStarted).hashCode = function () {
  var result = this.tb8_1.hashCode();
  result = imul(result, 31) + this.ub8_1.hashCode() | 0;
  result = imul(result, 31) + (this.vb8_1 == null ? 0 : getStringHashCode(this.vb8_1)) | 0;
  result = imul(result, 31) + (this.wb8_1 == null ? 0 : getStringHashCode(this.wb8_1)) | 0;
  return result;
};
protoOf(BreakStarted).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BreakStarted))
    return false;
  var tmp0_other_with_cast = other instanceof BreakStarted ? other : THROW_CCE();
  if (!this.tb8_1.equals(tmp0_other_with_cast.tb8_1))
    return false;
  if (!this.ub8_1.equals(tmp0_other_with_cast.ub8_1))
    return false;
  if (!(this.vb8_1 == tmp0_other_with_cast.vb8_1))
    return false;
  if (!(this.wb8_1 == tmp0_other_with_cast.wb8_1))
    return false;
  return true;
};
function BreakEnded(timePunchId, breakId, breakDurationInMinutes, userPhotoUrl) {
  this.xb8_1 = timePunchId;
  this.yb8_1 = breakId;
  this.zb8_1 = breakDurationInMinutes;
  this.ab9_1 = userPhotoUrl;
  this.bb9_1 = null;
}
protoOf(BreakEnded).toString = function () {
  return 'BreakEnded(timePunchId=' + this.xb8_1.toString() + ', breakId=' + this.yb8_1.toString() + ', breakDurationInMinutes=' + this.zb8_1 + ', userPhotoUrl=' + this.ab9_1 + ')';
};
protoOf(BreakEnded).hashCode = function () {
  var result = this.xb8_1.hashCode();
  result = imul(result, 31) + this.yb8_1.hashCode() | 0;
  result = imul(result, 31) + this.zb8_1 | 0;
  result = imul(result, 31) + (this.ab9_1 == null ? 0 : getStringHashCode(this.ab9_1)) | 0;
  return result;
};
protoOf(BreakEnded).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BreakEnded))
    return false;
  var tmp0_other_with_cast = other instanceof BreakEnded ? other : THROW_CCE();
  if (!this.xb8_1.equals(tmp0_other_with_cast.xb8_1))
    return false;
  if (!this.yb8_1.equals(tmp0_other_with_cast.yb8_1))
    return false;
  if (!(this.zb8_1 === tmp0_other_with_cast.zb8_1))
    return false;
  if (!(this.ab9_1 == tmp0_other_with_cast.ab9_1))
    return false;
  return true;
};
function ClockedIn_0(timePunchId, message, userPhotoUrl) {
  this.cb9_1 = timePunchId;
  this.db9_1 = message;
  this.eb9_1 = userPhotoUrl;
}
protoOf(ClockedIn_0).toString = function () {
  return 'ClockedIn(timePunchId=' + this.cb9_1.toString() + ', message=' + this.db9_1 + ', userPhotoUrl=' + this.eb9_1 + ')';
};
protoOf(ClockedIn_0).hashCode = function () {
  var result = this.cb9_1.hashCode();
  result = imul(result, 31) + (this.db9_1 == null ? 0 : getStringHashCode(this.db9_1)) | 0;
  result = imul(result, 31) + (this.eb9_1 == null ? 0 : getStringHashCode(this.eb9_1)) | 0;
  return result;
};
protoOf(ClockedIn_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedIn_0))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedIn_0 ? other : THROW_CCE();
  if (!this.cb9_1.equals(tmp0_other_with_cast.cb9_1))
    return false;
  if (!(this.db9_1 == tmp0_other_with_cast.db9_1))
    return false;
  if (!(this.eb9_1 == tmp0_other_with_cast.eb9_1))
    return false;
  return true;
};
function ClockedOut_0(timePunchId, message, userPhotoUrl) {
  this.fb9_1 = timePunchId;
  this.gb9_1 = message;
  this.hb9_1 = userPhotoUrl;
}
protoOf(ClockedOut_0).toString = function () {
  return 'ClockedOut(timePunchId=' + this.fb9_1.toString() + ', message=' + this.gb9_1 + ', userPhotoUrl=' + this.hb9_1 + ')';
};
protoOf(ClockedOut_0).hashCode = function () {
  var result = this.fb9_1.hashCode();
  result = imul(result, 31) + (this.gb9_1 == null ? 0 : getStringHashCode(this.gb9_1)) | 0;
  result = imul(result, 31) + (this.hb9_1 == null ? 0 : getStringHashCode(this.hb9_1)) | 0;
  return result;
};
protoOf(ClockedOut_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedOut_0))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedOut_0 ? other : THROW_CCE();
  if (!this.fb9_1.equals(tmp0_other_with_cast.fb9_1))
    return false;
  if (!(this.gb9_1 == tmp0_other_with_cast.gb9_1))
    return false;
  if (!(this.hb9_1 == tmp0_other_with_cast.hb9_1))
    return false;
  return true;
};
function InvalidPunchId(message) {
  this.ib9_1 = message;
}
protoOf(InvalidPunchId).toString = function () {
  return 'InvalidPunchId(message=' + this.ib9_1 + ')';
};
protoOf(InvalidPunchId).hashCode = function () {
  return this.ib9_1 == null ? 0 : getStringHashCode(this.ib9_1);
};
protoOf(InvalidPunchId).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof InvalidPunchId))
    return false;
  var tmp0_other_with_cast = other instanceof InvalidPunchId ? other : THROW_CCE();
  if (!(this.ib9_1 == tmp0_other_with_cast.ib9_1))
    return false;
  return true;
};
function HealthCheckFailed(message, userPhotoUrl) {
  this.jb9_1 = message;
  this.kb9_1 = userPhotoUrl;
}
protoOf(HealthCheckFailed).toString = function () {
  return 'HealthCheckFailed(message=' + this.jb9_1 + ', userPhotoUrl=' + this.kb9_1 + ')';
};
protoOf(HealthCheckFailed).hashCode = function () {
  var result = this.jb9_1 == null ? 0 : getStringHashCode(this.jb9_1);
  result = imul(result, 31) + (this.kb9_1 == null ? 0 : getStringHashCode(this.kb9_1)) | 0;
  return result;
};
protoOf(HealthCheckFailed).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HealthCheckFailed))
    return false;
  var tmp0_other_with_cast = other instanceof HealthCheckFailed ? other : THROW_CCE();
  if (!(this.jb9_1 == tmp0_other_with_cast.jb9_1))
    return false;
  if (!(this.kb9_1 == tmp0_other_with_cast.kb9_1))
    return false;
  return true;
};
function BreakTooShort(message) {
  this.lb9_1 = message;
}
protoOf(BreakTooShort).toString = function () {
  return 'BreakTooShort(message=' + this.lb9_1 + ')';
};
protoOf(BreakTooShort).hashCode = function () {
  return this.lb9_1 == null ? 0 : getStringHashCode(this.lb9_1);
};
protoOf(BreakTooShort).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BreakTooShort))
    return false;
  var tmp0_other_with_cast = other instanceof BreakTooShort ? other : THROW_CCE();
  if (!(this.lb9_1 == tmp0_other_with_cast.lb9_1))
    return false;
  return true;
};
function PreferredShift(shift, otherAssignedRoles) {
  this.ib8_1 = shift;
  this.jb8_1 = otherAssignedRoles;
}
protoOf(PreferredShift).toString = function () {
  return 'PreferredShift(shift=' + this.ib8_1.toString() + ', otherAssignedRoles=' + toString_0(this.jb8_1) + ')';
};
protoOf(PreferredShift).hashCode = function () {
  var result = this.ib8_1.hashCode();
  result = imul(result, 31) + (this.jb8_1 == null ? 0 : hashCode(this.jb8_1)) | 0;
  return result;
};
protoOf(PreferredShift).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PreferredShift))
    return false;
  var tmp0_other_with_cast = other instanceof PreferredShift ? other : THROW_CCE();
  if (!this.ib8_1.equals(tmp0_other_with_cast.ib8_1))
    return false;
  if (!equals(this.jb8_1, tmp0_other_with_cast.jb8_1))
    return false;
  return true;
};
var EndCriteria_CLOSE_instance;
var EndCriteria_BUSINESS_DECLINE_instance;
var EndCriteria_entriesInitialized;
function EndCriteria_initEntries() {
  if (EndCriteria_entriesInitialized)
    return Unit_instance;
  EndCriteria_entriesInitialized = true;
  EndCriteria_CLOSE_instance = new EndCriteria('CLOSE', 0);
  EndCriteria_BUSINESS_DECLINE_instance = new EndCriteria('BUSINESS_DECLINE', 1);
}
function EndCriteria(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function EndCriteria_CLOSE_getInstance() {
  EndCriteria_initEntries();
  return EndCriteria_CLOSE_instance;
}
function EndCriteria_BUSINESS_DECLINE_getInstance() {
  EndCriteria_initEntries();
  return EndCriteria_BUSINESS_DECLINE_instance;
}
function Regular(startTime) {
  this.mb9_1 = startTime;
}
protoOf(Regular).toString = function () {
  return 'Regular(startTime=' + this.mb9_1.toString() + ')';
};
protoOf(Regular).hashCode = function () {
  return this.mb9_1.hashCode();
};
protoOf(Regular).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Regular))
    return false;
  var tmp0_other_with_cast = other instanceof Regular ? other : THROW_CCE();
  if (!this.mb9_1.equals(tmp0_other_with_cast.mb9_1))
    return false;
  return true;
};
function Custom(startTime, expectedEndBreakTime, customBreak) {
  this.nb9_1 = startTime;
  this.ob9_1 = expectedEndBreakTime;
  this.pb9_1 = customBreak;
}
protoOf(Custom).toString = function () {
  return 'Custom(startTime=' + this.nb9_1.toString() + ', expectedEndBreakTime=' + this.ob9_1.toString() + ', customBreak=' + this.pb9_1.toString() + ')';
};
protoOf(Custom).hashCode = function () {
  var result = this.nb9_1.hashCode();
  result = imul(result, 31) + this.ob9_1.hashCode() | 0;
  result = imul(result, 31) + this.pb9_1.hashCode() | 0;
  return result;
};
protoOf(Custom).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Custom))
    return false;
  var tmp0_other_with_cast = other instanceof Custom ? other : THROW_CCE();
  if (!this.nb9_1.equals(tmp0_other_with_cast.nb9_1))
    return false;
  if (!this.ob9_1.equals(tmp0_other_with_cast.ob9_1))
    return false;
  if (!this.pb9_1.equals(tmp0_other_with_cast.pb9_1))
    return false;
  return true;
};
function StartShift(action) {
  AvailableAction.call(this);
  this.qb9_1 = action;
}
protoOf(StartShift).vb2 = function (switchToRoleId, $completion) {
  return this.qb9_1(switchToRoleId, $completion);
};
function StartUnscheduledShift(action) {
  AvailableAction.call(this);
  this.rb9_1 = action;
}
protoOf(StartUnscheduledShift).ub3 = function ($completion) {
  return this.rb9_1($completion);
};
function ClockOut(action) {
  AvailableAction.call(this);
  this.sb9_1 = action;
}
protoOf(ClockOut).ub3 = function ($completion) {
  return this.sb9_1($completion);
};
function StartPaidBreak(action) {
  AvailableAction.call(this);
  this.tb9_1 = action;
}
protoOf(StartPaidBreak).ub3 = function ($completion) {
  return this.tb9_1($completion);
};
function StartUnpaidBreak(action) {
  AvailableAction.call(this);
  this.ub9_1 = action;
}
protoOf(StartUnpaidBreak).ub3 = function ($completion) {
  return this.ub9_1($completion);
};
function StartCustomBreak(availableCustomBreaks, action) {
  AvailableAction.call(this);
  this.vb9_1 = availableCustomBreaks;
  this.wb9_1 = action;
}
protoOf(StartCustomBreak).kb7 = function (customBreakId, $completion) {
  return this.wb9_1(customBreakId, $completion);
};
function EndBreak(action) {
  AvailableAction.call(this);
  this.xb9_1 = action;
}
protoOf(EndBreak).ub3 = function ($completion) {
  return this.xb9_1($completion);
};
function ClockedOut_1(user, availableActions, preferredShift, serverTime) {
  this.yb9_1 = user;
  this.zb9_1 = availableActions;
  this.aba_1 = preferredShift;
  this.bba_1 = serverTime;
}
protoOf(ClockedOut_1).toString = function () {
  return 'ClockedOut(user=' + this.yb9_1.toString() + ', availableActions=' + toString(this.zb9_1) + ', preferredShift=' + toString_0(this.aba_1) + ', serverTime=' + this.bba_1.toString() + ')';
};
protoOf(ClockedOut_1).hashCode = function () {
  var result = this.yb9_1.hashCode();
  result = imul(result, 31) + hashCode(this.zb9_1) | 0;
  result = imul(result, 31) + (this.aba_1 == null ? 0 : this.aba_1.hashCode()) | 0;
  result = imul(result, 31) + this.bba_1.hashCode() | 0;
  return result;
};
protoOf(ClockedOut_1).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedOut_1))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedOut_1 ? other : THROW_CCE();
  if (!this.yb9_1.equals(tmp0_other_with_cast.yb9_1))
    return false;
  if (!equals(this.zb9_1, tmp0_other_with_cast.zb9_1))
    return false;
  if (!equals(this.aba_1, tmp0_other_with_cast.aba_1))
    return false;
  if (!this.bba_1.equals(tmp0_other_with_cast.bba_1))
    return false;
  return true;
};
function ClockedIn_1(user, availableActions, punch, currentShift, serverTime) {
  this.cba_1 = user;
  this.dba_1 = availableActions;
  this.eba_1 = punch;
  this.fba_1 = currentShift;
  this.gba_1 = serverTime;
}
protoOf(ClockedIn_1).toString = function () {
  return 'ClockedIn(user=' + this.cba_1.toString() + ', availableActions=' + toString(this.dba_1) + ', punch=' + this.eba_1.toString() + ', currentShift=' + toString_0(this.fba_1) + ', serverTime=' + this.gba_1.toString() + ')';
};
protoOf(ClockedIn_1).hashCode = function () {
  var result = this.cba_1.hashCode();
  result = imul(result, 31) + hashCode(this.dba_1) | 0;
  result = imul(result, 31) + this.eba_1.hashCode() | 0;
  result = imul(result, 31) + (this.fba_1 == null ? 0 : this.fba_1.hashCode()) | 0;
  result = imul(result, 31) + this.gba_1.hashCode() | 0;
  return result;
};
protoOf(ClockedIn_1).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedIn_1))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedIn_1 ? other : THROW_CCE();
  if (!this.cba_1.equals(tmp0_other_with_cast.cba_1))
    return false;
  if (!equals(this.dba_1, tmp0_other_with_cast.dba_1))
    return false;
  if (!this.eba_1.equals(tmp0_other_with_cast.eba_1))
    return false;
  if (!equals(this.fba_1, tmp0_other_with_cast.fba_1))
    return false;
  if (!this.gba_1.equals(tmp0_other_with_cast.gba_1))
    return false;
  return true;
};
function OnBreak_0(user, availableActions, punch, currentShift, currentBreak, serverTime) {
  this.hba_1 = user;
  this.iba_1 = availableActions;
  this.jba_1 = punch;
  this.kba_1 = currentShift;
  this.lba_1 = currentBreak;
  this.mba_1 = serverTime;
}
protoOf(OnBreak_0).toString = function () {
  return 'OnBreak(user=' + this.hba_1.toString() + ', availableActions=' + toString(this.iba_1) + ', punch=' + this.jba_1.toString() + ', currentShift=' + toString_0(this.kba_1) + ', currentBreak=' + toString(this.lba_1) + ', serverTime=' + this.mba_1.toString() + ')';
};
protoOf(OnBreak_0).hashCode = function () {
  var result = this.hba_1.hashCode();
  result = imul(result, 31) + hashCode(this.iba_1) | 0;
  result = imul(result, 31) + this.jba_1.hashCode() | 0;
  result = imul(result, 31) + (this.kba_1 == null ? 0 : this.kba_1.hashCode()) | 0;
  result = imul(result, 31) + hashCode(this.lba_1) | 0;
  result = imul(result, 31) + this.mba_1.hashCode() | 0;
  return result;
};
protoOf(OnBreak_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof OnBreak_0))
    return false;
  var tmp0_other_with_cast = other instanceof OnBreak_0 ? other : THROW_CCE();
  if (!this.hba_1.equals(tmp0_other_with_cast.hba_1))
    return false;
  if (!equals(this.iba_1, tmp0_other_with_cast.iba_1))
    return false;
  if (!this.jba_1.equals(tmp0_other_with_cast.jba_1))
    return false;
  if (!equals(this.kba_1, tmp0_other_with_cast.kba_1))
    return false;
  if (!equals(this.lba_1, tmp0_other_with_cast.lba_1))
    return false;
  if (!this.mba_1.equals(tmp0_other_with_cast.mba_1))
    return false;
  return true;
};
function User(id, firstName, lastName, profilePictureUrl) {
  this.nba_1 = id;
  this.oba_1 = firstName;
  this.pba_1 = lastName;
  this.qba_1 = profilePictureUrl;
}
protoOf(User).toString = function () {
  return 'User(id=' + this.nba_1.toString() + ', firstName=' + this.oba_1 + ', lastName=' + this.pba_1 + ', profilePictureUrl=' + this.qba_1 + ')';
};
protoOf(User).hashCode = function () {
  var result = this.nba_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.oba_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.pba_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.qba_1) | 0;
  return result;
};
protoOf(User).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof User))
    return false;
  var tmp0_other_with_cast = other instanceof User ? other : THROW_CCE();
  if (!this.nba_1.equals(tmp0_other_with_cast.nba_1))
    return false;
  if (!(this.oba_1 === tmp0_other_with_cast.oba_1))
    return false;
  if (!(this.pba_1 === tmp0_other_with_cast.pba_1))
    return false;
  if (!(this.qba_1 === tmp0_other_with_cast.qba_1))
    return false;
  return true;
};
function Punch(clockedInAt, assignment, hasRoleChanged) {
  this.rba_1 = clockedInAt;
  this.sba_1 = assignment;
  this.tba_1 = hasRoleChanged;
}
protoOf(Punch).toString = function () {
  return 'Punch(clockedInAt=' + this.rba_1.toString() + ', assignment=' + toString(this.sba_1) + ', hasRoleChanged=' + this.tba_1 + ')';
};
protoOf(Punch).hashCode = function () {
  var result = this.rba_1.hashCode();
  result = imul(result, 31) + hashCode(this.sba_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.tba_1) | 0;
  return result;
};
protoOf(Punch).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Punch))
    return false;
  var tmp0_other_with_cast = other instanceof Punch ? other : THROW_CCE();
  if (!this.rba_1.equals(tmp0_other_with_cast.rba_1))
    return false;
  if (!equals(this.sba_1, tmp0_other_with_cast.sba_1))
    return false;
  if (!(this.tba_1 === tmp0_other_with_cast.tba_1))
    return false;
  return true;
};
function Shift(id, assignment, startTime, endTime, endCriteria) {
  this.gb0_1 = id;
  this.hb0_1 = assignment;
  this.ib0_1 = startTime;
  this.jb0_1 = endTime;
  this.kb0_1 = endCriteria;
}
protoOf(Shift).toString = function () {
  return 'Shift(id=' + this.gb0_1.toString() + ', assignment=' + toString(this.hb0_1) + ', startTime=' + this.ib0_1.toString() + ', endTime=' + this.jb0_1.toString() + ', endCriteria=' + toString_0(this.kb0_1) + ')';
};
protoOf(Shift).hashCode = function () {
  var result = this.gb0_1.hashCode();
  result = imul(result, 31) + hashCode(this.hb0_1) | 0;
  result = imul(result, 31) + this.ib0_1.hashCode() | 0;
  result = imul(result, 31) + this.jb0_1.hashCode() | 0;
  result = imul(result, 31) + (this.kb0_1 == null ? 0 : this.kb0_1.hashCode()) | 0;
  return result;
};
protoOf(Shift).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Shift))
    return false;
  var tmp0_other_with_cast = other instanceof Shift ? other : THROW_CCE();
  if (!this.gb0_1.equals(tmp0_other_with_cast.gb0_1))
    return false;
  if (!equals(this.hb0_1, tmp0_other_with_cast.hb0_1))
    return false;
  if (!this.ib0_1.equals(tmp0_other_with_cast.ib0_1))
    return false;
  if (!this.jb0_1.equals(tmp0_other_with_cast.jb0_1))
    return false;
  if (!equals(this.kb0_1, tmp0_other_with_cast.kb0_1))
    return false;
  return true;
};
function CustomBreak(id, name, minLengthInMinutes) {
  this.lb0_1 = id;
  this.mb0_1 = name;
  this.nb0_1 = minLengthInMinutes;
}
protoOf(CustomBreak).toString = function () {
  return 'CustomBreak(id=' + this.lb0_1.toString() + ', name=' + this.mb0_1 + ', minLengthInMinutes=' + this.nb0_1 + ')';
};
protoOf(CustomBreak).hashCode = function () {
  var result = this.lb0_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.mb0_1) | 0;
  result = imul(result, 31) + this.nb0_1 | 0;
  return result;
};
protoOf(CustomBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CustomBreak))
    return false;
  var tmp0_other_with_cast = other instanceof CustomBreak ? other : THROW_CCE();
  if (!this.lb0_1.equals(tmp0_other_with_cast.lb0_1))
    return false;
  if (!(this.mb0_1 === tmp0_other_with_cast.mb0_1))
    return false;
  if (!(this.nb0_1 === tmp0_other_with_cast.nb0_1))
    return false;
  return true;
};
function AvailableAction() {
}
protoOf(AvailableAction).equals = function (other) {
  if (this === other)
    return true;
  if (other == null)
    return false;
  if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  return true;
};
protoOf(AvailableAction).hashCode = function () {
  return getKClassFromExpression(this).hashCode();
};
function AttestationRequiredStrategy$invoke$slambda(this$0, $punchId, $attestation, $punchContext, resultContinuation) {
  this.cbb_1 = this$0;
  this.dbb_1 = $punchId;
  this.ebb_1 = $attestation;
  this.fbb_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(AttestationRequiredStrategy$invoke$slambda).kb7 = function (attestationResponseId, $completion) {
  var tmp = this.u7d(attestationResponseId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(AttestationRequiredStrategy$invoke$slambda).h9 = function (p1, $completion) {
  return this.kb7(p1 instanceof Long ? p1 : THROW_CCE(), $completion);
};
protoOf(AttestationRequiredStrategy$invoke$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          this.hbb_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.cbb_1.gbc_1.o92(this.dbb_1, this.ebb_1.e97_1, this.gbb_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.ibb_1 = suspendResult.ul_1;
          suspendResult = new Result(this.ibb_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.jbb_1 = suspendResult.ul_1;
          this.kbb_1 = this.jbb_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.kbb_1)) {
            var tmp_0 = this;
            tmp_0.mbb_1 = new Result(this.kbb_1);
            this.nbb_1 = this.mbb_1;
            this.o8_1 = 9;
            var tmp_1 = this;
            tmp_1.pbb_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.qbb_1 = this.nbb_1.ul_1;
            this.rbb_1 = this.qbb_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.rbb_1);
            tmp_3.sbb_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.tbb_1 = this.sbb_1;
            this.n8_1 = 3;
            suspendResult = this.cbb_1.hbc_1.n9c(this.fbb_1.pax_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            this.n8_1 = 4;
            continue $sm;
          } else {
            this.lbb_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.kbb_1));
            this.n8_1 = 11;
            continue $sm;
          }

        case 3:
          this.ubb_1 = suspendResult.ul_1;
          suspendResult = new Result(this.ubb_1);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.vbb_1 = suspendResult.ul_1;
          this.wbb_1 = this.vbb_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.wbb_1)) {
            var tmp_5 = this;
            tmp_5.ybb_1 = new Result(this.wbb_1);
            this.zbb_1 = this.ybb_1;
            this.o8_1 = 6;
            var tmp_6 = this;
            tmp_6.bbc_1 = Companion_instance;
            var tmp_7 = this;
            tmp_7.cbc_1 = this.zbb_1.ul_1;
            this.dbc_1 = this.cbc_1;
            var tmp_8 = this;
            var tmp_9 = _Result___get_value__impl__bjfvqg(this.dbc_1);
            tmp_8.ebc_1 = (tmp_9 == null ? true : !(tmp_9 == null)) ? tmp_9 : THROW_CCE();
            this.fbc_1 = this.ebc_1;
            this.n8_1 = 5;
            suspendResult = this.fbb_1.qax_1(this.fbc_1, this.fbb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.xbb_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.wbb_1));
            this.n8_1 = 8;
            continue $sm;
          }

        case 5:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_10 = this;
          this.bbc_1;
          tmp_10.abc_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 9;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          this.o8_1 = 9;
          var tmp_11 = this.q8_1;
          if (tmp_11 instanceof Error) {
            var e = this.q8_1;
            var tmp_12 = this;
            tmp_12.abc_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 7;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 7:
          this.o8_1 = 9;
          this.xbb_1 = this.abc_1;
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var this_0 = this.xbb_1;
          throwOnFailure(this_0);
          var tmp_13 = _Result___get_value__impl__bjfvqg(this_0);
          var tmp1_0 = (tmp_13 == null ? true : !(tmp_13 == null)) ? tmp_13 : THROW_CCE();
          var tmp_14 = this;
          this.pbb_1;
          tmp_14.obb_1 = _Result___init__impl__xyqfz8(tmp1_0);
          this.o8_1 = 12;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 12;
          var tmp_15 = this.q8_1;
          if (tmp_15 instanceof Error) {
            var e_0 = this.q8_1;
            var tmp_16 = this;
            tmp_16.obb_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
            this.n8_1 = 10;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 10:
          this.o8_1 = 12;
          this.lbb_1 = this.obb_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          var ARGUMENT_0 = this.lbb_1;
          return this.hbb_1.a2u(ARGUMENT_0);
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.o8_1 === 12) {
        throw e_1;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_1;
      }
    }
   while (true);
};
protoOf(AttestationRequiredStrategy$invoke$slambda).u7d = function (attestationResponseId, completion) {
  var i = new AttestationRequiredStrategy$invoke$slambda(this.cbb_1, this.dbb_1, this.ebb_1, this.fbb_1, completion);
  i.gbb_1 = attestationResponseId;
  return i;
};
function AttestationRequiredStrategy$invoke$slambda_0(this$0, $punchId, $attestation, $punchContext, resultContinuation) {
  var i = new AttestationRequiredStrategy$invoke$slambda(this$0, $punchId, $attestation, $punchContext, resultContinuation);
  var l = function (attestationResponseId, $completion) {
    return i.kb7(attestationResponseId, $completion);
  };
  l.$arity = 1;
  return l;
}
function $invokeCOROUTINE$3(_this__u8e3s4, response, punchContext, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.qbc_1 = _this__u8e3s4;
  this.rbc_1 = response;
  this.sbc_1 = punchContext;
}
protoOf($invokeCOROUTINE$3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          var tmp_0 = this;
          var tmp0_elvis_lhs = this.rbc_1.p9f_1;
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            var exception = IllegalStateException_init_$Create$('Punch id is required for attestation required strategy');
            return new Result(_Result___init__impl__xyqfz8(createFailure(exception)));
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }

          tmp_0.tbc_1 = tmp_1;
          this.n8_1 = 1;
          suspendResult = this.qbc_1.gbc_1.n92(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          var this_0 = suspendResult.ul_1;
          var tmp_2;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var this_1 = new Result(this_0);
            var tmp_3;
            try {
              var $this$runCatching = this_1.ul_1;
              var tmp_4 = _Result___get_value__impl__bjfvqg($this$runCatching);
              var attestation = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
              var value = new AttestationRequired(attestation, AttestationRequiredStrategy$invoke$slambda_0(this.qbc_1, this.tbc_1, attestation, this.sbc_1, null));
              tmp_3 = _Result___init__impl__xyqfz8(value);
            } catch ($p) {
              var tmp_5;
              if ($p instanceof Error) {
                var e = $p;
                tmp_5 = _Result___init__impl__xyqfz8(createFailure(e));
              } else {
                throw $p;
              }
              tmp_3 = tmp_5;
            }
            tmp_2 = tmp_3;
          } else {
            tmp_2 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_2);
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 3) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function AttestationRequiredStrategy(attestationRepository, clockRepository) {
  this.gbc_1 = attestationRepository;
  this.hbc_1 = clockRepository;
}
protoOf(AttestationRequiredStrategy).eb0 = function (response, punchContext) {
  return response.c9f_1 === true;
};
protoOf(AttestationRequiredStrategy).db0 = function (response, punchContext, $completion) {
  var tmp = new $invokeCOROUTINE$3(this, response, punchContext, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function BreakTooShortStrategy() {
}
protoOf(BreakTooShortStrategy).eb0 = function (response, punchContext) {
  return response.k9f_1 === true;
};
protoOf(BreakTooShortStrategy).db0 = function (response, punchContext, $completion) {
  // Inline function 'kotlin.Companion.success' call
  var value = new BreakTooShort(response.j9f_1);
  var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
  return new Result(tmp$ret$0);
};
var BreakTooShortStrategy_instance;
function BreakTooShortStrategy_getInstance() {
  return BreakTooShortStrategy_instance;
}
function DepartmentSelectionStrategy$invoke$slambda(this$0, $punchContext, resultContinuation) {
  this.cbd_1 = this$0;
  this.dbd_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DepartmentSelectionStrategy$invoke$slambda).kb7 = function (departmentId, $completion) {
  var tmp = this.u7d(departmentId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(DepartmentSelectionStrategy$invoke$slambda).h9 = function (p1, $completion) {
  return this.kb7(p1 instanceof Long ? p1 : THROW_CCE(), $completion);
};
protoOf(DepartmentSelectionStrategy$invoke$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.fbd_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.cbd_1.sbd_1.l9c(this.dbd_1.pax_1, this.dbd_1.rax_1, this.ebd_1, this.dbd_1.tax_1, this.dbd_1.uax_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.gbd_1 = suspendResult.ul_1;
          suspendResult = new Result(this.gbd_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.hbd_1 = suspendResult.ul_1;
          this.ibd_1 = this.hbd_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.ibd_1)) {
            var tmp_0 = this;
            tmp_0.kbd_1 = new Result(this.ibd_1);
            this.lbd_1 = this.kbd_1;
            this.o8_1 = 4;
            var tmp_1 = this;
            tmp_1.nbd_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.obd_1 = this.lbd_1.ul_1;
            this.pbd_1 = this.obd_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.pbd_1);
            tmp_3.qbd_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.rbd_1 = this.qbd_1;
            this.n8_1 = 3;
            suspendResult = this.dbd_1.qax_1(this.rbd_1, this.dbd_1.wax(VOID, VOID, VOID, this.ebd_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.jbd_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.ibd_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_5 = this;
          this.nbd_1;
          tmp_5.mbd_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            tmp_7.mbd_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 7;
          this.jbd_1 = this.mbd_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var ARGUMENT_0 = this.jbd_1;
          return this.fbd_1.a2u(ARGUMENT_0);
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 7) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(DepartmentSelectionStrategy$invoke$slambda).u7d = function (departmentId, completion) {
  var i = new DepartmentSelectionStrategy$invoke$slambda(this.cbd_1, this.dbd_1, completion);
  i.ebd_1 = departmentId;
  return i;
};
function DepartmentSelectionStrategy$invoke$slambda_0(this$0, $punchContext, resultContinuation) {
  var i = new DepartmentSelectionStrategy$invoke$slambda(this$0, $punchContext, resultContinuation);
  var l = function (departmentId, $completion) {
    return i.kb7(departmentId, $completion);
  };
  l.$arity = 1;
  return l;
}
function DepartmentSelectionStrategy(clockRepository) {
  this.sbd_1 = clockRepository;
}
protoOf(DepartmentSelectionStrategy).eb0 = function (response, punchContext) {
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  var this_0 = response.f9f_1;
  return !(this_0 == null || this_0.p());
};
protoOf(DepartmentSelectionStrategy).db0 = function (response, punchContext, $completion) {
  var departments = response.f9f_1;
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  if (departments == null || departments.p()) {
    // Inline function 'kotlin.Companion.failure' call
    var exception = IllegalStateException_init_$Create$('Departments should not be empty');
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    return new Result(tmp$ret$1);
  }
  // Inline function 'kotlin.Companion.success' call
  var value = new DepartmentSelectionRequired(departments, DepartmentSelectionStrategy$invoke$slambda_0(this, punchContext, null));
  var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
  return new Result(tmp$ret$2);
};
function HealthCheckFailedStrategy() {
}
protoOf(HealthCheckFailedStrategy).eb0 = function (response, punchContext) {
  return response.h9f_1 === true;
};
protoOf(HealthCheckFailedStrategy).db0 = function (response, punchContext, $completion) {
  var tmp0_safe_receiver = response.r9f_1;
  // Inline function 'kotlin.Companion.success' call
  var value = new HealthCheckFailed(response.j9f_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u9e_1);
  var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
  return new Result(tmp$ret$0);
};
var HealthCheckFailedStrategy_instance;
function HealthCheckFailedStrategy_getInstance() {
  return HealthCheckFailedStrategy_instance;
}
function HealthCheckRequiredStrategy$invoke$slambda(this$0, $punchContext, resultContinuation) {
  this.bbe_1 = this$0;
  this.cbe_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HealthCheckRequiredStrategy$invoke$slambda).ibf = function (responses, $completion) {
  var tmp = this.jbf(responses, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(HealthCheckRequiredStrategy$invoke$slambda).h9 = function (p1, $completion) {
  return this.ibf((!(p1 == null) ? isInterface(p1, KtMap) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(HealthCheckRequiredStrategy$invoke$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          this.ebe_1 = Companion_instance_1;
          this.n8_1 = 1;
          var this_0 = this.dbe_1;
          var destination = ArrayList_init_$Create$_0(this_0.m());
          var _iterator__ex2g4s = this_0.r().j();
          while (_iterator__ex2g4s.k()) {
            var item = _iterator__ex2g4s.l();
            var questionId = item.s();
            var responseId = item.t();
            destination.e(new QuestionResponse(questionId, responseId));
          }

          suspendResult = this.bbe_1.lbf_1.f9i(new HealthCheckQuestionnaireResponses(this.cbe_1.pax_1, destination), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.fbe_1 = suspendResult.ul_1;
          suspendResult = new Result(this.fbe_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.gbe_1 = suspendResult.ul_1;
          this.hbe_1 = this.gbe_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.hbe_1)) {
            var tmp_0 = this;
            tmp_0.jbe_1 = new Result(this.hbe_1);
            this.kbe_1 = this.jbe_1;
            this.o8_1 = 9;
            var tmp_1 = this;
            tmp_1.mbe_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.nbe_1 = this.kbe_1.ul_1;
            this.obe_1 = this.nbe_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.obe_1);
            tmp_3.pbe_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.qbe_1 = this.pbe_1;
            this.rbe_1 = this.bbe_1.kbf_1;
            this.sbe_1 = this.cbe_1.pax_1;
            this.tbe_1 = this.cbe_1.rax_1;
            this.ube_1 = this.cbe_1.sax_1;
            this.vbe_1 = this.cbe_1.tax_1;
            this.n8_1 = 3;
            suspendResult = this.rbe_1.l9c(this.sbe_1, this.tbe_1, this.ube_1, this.vbe_1, this.qbe_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            this.n8_1 = 4;
            continue $sm;
          } else {
            this.ibe_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.hbe_1));
            this.n8_1 = 11;
            continue $sm;
          }

        case 3:
          this.wbe_1 = suspendResult.ul_1;
          suspendResult = new Result(this.wbe_1);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.xbe_1 = suspendResult.ul_1;
          this.ybe_1 = this.xbe_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.ybe_1)) {
            var tmp_5 = this;
            tmp_5.abf_1 = new Result(this.ybe_1);
            this.bbf_1 = this.abf_1;
            this.o8_1 = 6;
            var tmp_6 = this;
            tmp_6.dbf_1 = Companion_instance;
            var tmp_7 = this;
            tmp_7.ebf_1 = this.bbf_1.ul_1;
            this.fbf_1 = this.ebf_1;
            var tmp_8 = this;
            var tmp_9 = _Result___get_value__impl__bjfvqg(this.fbf_1);
            tmp_8.gbf_1 = (tmp_9 == null ? true : !(tmp_9 == null)) ? tmp_9 : THROW_CCE();
            this.hbf_1 = this.gbf_1;
            this.n8_1 = 5;
            suspendResult = this.cbe_1.qax_1(this.hbf_1, this.cbe_1.wax(VOID, VOID, VOID, VOID, VOID, this.qbe_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.zbe_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.ybe_1));
            this.n8_1 = 8;
            continue $sm;
          }

        case 5:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_10 = this;
          this.dbf_1;
          tmp_10.cbf_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 9;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          this.o8_1 = 9;
          var tmp_11 = this.q8_1;
          if (tmp_11 instanceof Error) {
            var e = this.q8_1;
            var tmp_12 = this;
            tmp_12.cbf_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 7;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 7:
          this.o8_1 = 9;
          this.zbe_1 = this.cbf_1;
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var this_1 = this.zbe_1;
          throwOnFailure(this_1);
          var tmp_13 = _Result___get_value__impl__bjfvqg(this_1);
          var tmp1_0 = (tmp_13 == null ? true : !(tmp_13 == null)) ? tmp_13 : THROW_CCE();
          var tmp_14 = this;
          this.mbe_1;
          tmp_14.lbe_1 = _Result___init__impl__xyqfz8(tmp1_0);
          this.o8_1 = 12;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 12;
          var tmp_15 = this.q8_1;
          if (tmp_15 instanceof Error) {
            var e_0 = this.q8_1;
            var tmp_16 = this;
            tmp_16.lbe_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
            this.n8_1 = 10;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 10:
          this.o8_1 = 12;
          this.ibe_1 = this.lbe_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          var ARGUMENT_0 = this.ibe_1;
          return this.ebe_1.a2u(ARGUMENT_0);
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.o8_1 === 12) {
        throw e_1;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_1;
      }
    }
   while (true);
};
protoOf(HealthCheckRequiredStrategy$invoke$slambda).jbf = function (responses, completion) {
  var i = new HealthCheckRequiredStrategy$invoke$slambda(this.bbe_1, this.cbe_1, completion);
  i.dbe_1 = responses;
  return i;
};
function HealthCheckRequiredStrategy$invoke$slambda_0(this$0, $punchContext, resultContinuation) {
  var i = new HealthCheckRequiredStrategy$invoke$slambda(this$0, $punchContext, resultContinuation);
  var l = function (responses, $completion) {
    return i.ibf(responses, $completion);
  };
  l.$arity = 1;
  return l;
}
function $invokeCOROUTINE$4(_this__u8e3s4, response, punchContext, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.ubf_1 = _this__u8e3s4;
  this.vbf_1 = response;
  this.wbf_1 = punchContext;
}
protoOf($invokeCOROUTINE$4).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.ubf_1.lbf_1.e9i(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var this_1 = new Result(this_0);
            var tmp_1;
            try {
              var $this$runCatching = this_1.ul_1;
              var tmp_2 = _Result___get_value__impl__bjfvqg($this$runCatching);
              var questionnaires = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
              var value = new HealthCheckRequired(questionnaires, HealthCheckRequiredStrategy$invoke$slambda_0(this.ubf_1, this.wbf_1, null));
              tmp_1 = _Result___init__impl__xyqfz8(value);
            } catch ($p) {
              var tmp_3;
              if ($p instanceof Error) {
                var e = $p;
                tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
              } else {
                throw $p;
              }
              tmp_1 = tmp_3;
            }
            tmp_0 = tmp_1;
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 3) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function HealthCheckRequiredStrategy(clockRepository, healthCheckRepository) {
  this.kbf_1 = clockRepository;
  this.lbf_1 = healthCheckRepository;
}
protoOf(HealthCheckRequiredStrategy).eb0 = function (response, punchContext) {
  return response.i9f_1 === true;
};
protoOf(HealthCheckRequiredStrategy).db0 = function (response, punchContext, $completion) {
  var tmp = new $invokeCOROUTINE$4(this, response, punchContext, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function InvalidPunchIdStrategy() {
}
protoOf(InvalidPunchIdStrategy).bb0 = function (throwable) {
  return throwable instanceof NotFound;
};
protoOf(InvalidPunchIdStrategy).cb0 = function (throwable, $completion) {
  var tmp0_elvis_lhs = throwable.message;
  // Inline function 'kotlin.Companion.success' call
  var value = new InvalidPunchId(tmp0_elvis_lhs == null ? 'Invalid punch ID' : tmp0_elvis_lhs);
  var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
  return new Result(tmp$ret$0);
};
var InvalidPunchIdStrategy_instance;
function InvalidPunchIdStrategy_getInstance() {
  return InvalidPunchIdStrategy_instance;
}
function PunchedInStrategy() {
}
protoOf(PunchedInStrategy).eb0 = function (response, punchContext) {
  return response.m9f_1.equals(Status_IN_getInstance());
};
protoOf(PunchedInStrategy).db0 = function (response, punchContext, $completion) {
  var tmp0_elvis_lhs = response.p9f_1;
  var timePunchId = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
  var tmp1_safe_receiver = response.r9f_1;
  var userPhotoUrl = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u9e_1;
  // Inline function 'com.sevenshifts.shared.common.base.runCatchingCancellable' call
  var tmp;
  try {
    var tmp_0;
    if (!(response.e9f_1 == null)) {
      var tmp0_elvis_lhs_0 = response.o9f_1;
      var tmp_1;
      if (tmp0_elvis_lhs_0 == null) {
        throw IllegalStateException_init_$Create$('Break started but timePunchBreakId is null');
      } else {
        tmp_1 = tmp0_elvis_lhs_0;
      }
      tmp_0 = new BreakStarted(timePunchId, tmp_1, userPhotoUrl, response.j9f_1);
    } else if (!(response.s9f_1 == null)) {
      var tmp1_elvis_lhs = response.o9f_1;
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        throw IllegalStateException_init_$Create$('Break ended but timePunchBreakId is null');
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      var tmp_3 = tmp_2;
      var tmp2_elvis_lhs = response.d9f_1;
      tmp_0 = new BreakEnded(timePunchId, tmp_3, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs, userPhotoUrl);
    } else {
      // Inline function 'kotlin.text.orEmpty' call
      var tmp0_elvis_lhs_1 = response.j9f_1;
      var tmp$ret$0 = tmp0_elvis_lhs_1 == null ? '' : tmp0_elvis_lhs_1;
      tmp_0 = new ClockedIn_0(timePunchId, tmp$ret$0, userPhotoUrl);
    }
    // Inline function 'kotlin.Companion.success' call
    var value = tmp_0;
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_4;
    if ($p instanceof CancellationException) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_4 = _Result___init__impl__xyqfz8(createFailure(e_0));
      } else {
        throw $p;
      }
    }
    tmp = tmp_4;
  }
  var tmp$ret$4 = tmp;
  return new Result(tmp$ret$4);
};
var PunchedInStrategy_instance;
function PunchedInStrategy_getInstance() {
  return PunchedInStrategy_instance;
}
function PunchedOutStrategy() {
}
protoOf(PunchedOutStrategy).eb0 = function (response, punchContext) {
  return response.m9f_1.equals(Status_OUT_getInstance());
};
protoOf(PunchedOutStrategy).db0 = function (response, punchContext, $completion) {
  var tmp0_elvis_lhs = response.p9f_1;
  var tmp = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs_0 = response.j9f_1;
  var tmp_0 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
  var tmp1_safe_receiver = response.r9f_1;
  // Inline function 'kotlin.Companion.success' call
  var value = new ClockedOut_0(tmp, tmp_0, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u9e_1);
  var tmp$ret$1 = _Result___init__impl__xyqfz8(value);
  return new Result(tmp$ret$1);
};
var PunchedOutStrategy_instance;
function PunchedOutStrategy_getInstance() {
  return PunchedOutStrategy_instance;
}
function RoleSelectionStrategy$invoke$slambda(this$0, $punchContext, resultContinuation) {
  this.fbg_1 = this$0;
  this.gbg_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(RoleSelectionStrategy$invoke$slambda).kb7 = function (roleId, $completion) {
  var tmp = this.u7d(roleId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(RoleSelectionStrategy$invoke$slambda).h9 = function (p1, $completion) {
  return this.kb7(p1 instanceof Long ? p1 : THROW_CCE(), $completion);
};
protoOf(RoleSelectionStrategy$invoke$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.ibg_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.fbg_1.vbg_1.l9c(this.gbg_1.pax_1, this.hbg_1, this.gbg_1.sax_1, this.gbg_1.tax_1, this.gbg_1.uax_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.jbg_1 = suspendResult.ul_1;
          suspendResult = new Result(this.jbg_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.kbg_1 = suspendResult.ul_1;
          this.lbg_1 = this.kbg_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.lbg_1)) {
            var tmp_0 = this;
            tmp_0.nbg_1 = new Result(this.lbg_1);
            this.obg_1 = this.nbg_1;
            this.o8_1 = 4;
            var tmp_1 = this;
            tmp_1.qbg_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.rbg_1 = this.obg_1.ul_1;
            this.sbg_1 = this.rbg_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.sbg_1);
            tmp_3.tbg_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.ubg_1 = this.tbg_1;
            this.n8_1 = 3;
            suspendResult = this.gbg_1.qax_1(this.ubg_1, this.gbg_1.wax(VOID, VOID, this.hbg_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.mbg_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.lbg_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_5 = this;
          this.qbg_1;
          tmp_5.pbg_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            tmp_7.pbg_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 7;
          this.mbg_1 = this.pbg_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var ARGUMENT_0 = this.mbg_1;
          return this.ibg_1.a2u(ARGUMENT_0);
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 7) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(RoleSelectionStrategy$invoke$slambda).u7d = function (roleId, completion) {
  var i = new RoleSelectionStrategy$invoke$slambda(this.fbg_1, this.gbg_1, completion);
  i.hbg_1 = roleId;
  return i;
};
function RoleSelectionStrategy$invoke$slambda_0(this$0, $punchContext, resultContinuation) {
  var i = new RoleSelectionStrategy$invoke$slambda(this$0, $punchContext, resultContinuation);
  var l = function (roleId, $completion) {
    return i.kb7(roleId, $completion);
  };
  l.$arity = 1;
  return l;
}
function RoleSelectionStrategy(clockRepository) {
  this.vbg_1 = clockRepository;
}
protoOf(RoleSelectionStrategy).eb0 = function (response, punchContext) {
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  var this_0 = response.n9f_1;
  return !(this_0 == null || this_0.p());
};
protoOf(RoleSelectionStrategy).db0 = function (response, punchContext, $completion) {
  var roles = response.n9f_1;
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  if (roles == null || roles.p()) {
    // Inline function 'kotlin.Companion.failure' call
    var exception = IllegalStateException_init_$Create$('Roles should not be empty');
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    return new Result(tmp$ret$1);
  }
  // Inline function 'kotlin.Companion.success' call
  var value = new RoleSelectionRequired(roles, RoleSelectionStrategy$invoke$slambda_0(this, punchContext, null));
  var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
  return new Result(tmp$ret$2);
};
function TipsNeededStrategy$invoke$slambda(this$0, $punchContext, resultContinuation) {
  this.ebh_1 = this$0;
  this.fbh_1 = $punchContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(TipsNeededStrategy$invoke$slambda).ubh = function (tips, $completion) {
  var tmp = this.vbh(tips, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(TipsNeededStrategy$invoke$slambda).h9 = function (p1, $completion) {
  return this.ubh((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(TipsNeededStrategy$invoke$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.hbh_1 = Companion_instance_1;
          this.n8_1 = 1;
          suspendResult = this.ebh_1.wbh_1.m9c(this.fbh_1.pax_1, this.gbh_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.ibh_1 = suspendResult.ul_1;
          suspendResult = new Result(this.ibh_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.jbh_1 = suspendResult.ul_1;
          this.kbh_1 = this.jbh_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.kbh_1)) {
            var tmp_0 = this;
            tmp_0.mbh_1 = new Result(this.kbh_1);
            this.nbh_1 = this.mbh_1;
            this.o8_1 = 4;
            var tmp_1 = this;
            tmp_1.pbh_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.qbh_1 = this.nbh_1.ul_1;
            this.rbh_1 = this.qbh_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.rbh_1);
            tmp_3.sbh_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.tbh_1 = this.sbh_1;
            this.n8_1 = 3;
            suspendResult = this.fbh_1.qax_1(this.tbh_1, this.fbh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.lbh_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.kbh_1));
            this.n8_1 = 6;
            continue $sm;
          }

        case 3:
          var ARGUMENT = suspendResult;
          var tmp1 = ARGUMENT.y2t();
          var tmp_5 = this;
          this.pbh_1;
          tmp_5.obh_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 7;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            tmp_7.obh_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 5:
          this.o8_1 = 7;
          this.lbh_1 = this.obh_1;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          var ARGUMENT_0 = this.lbh_1;
          return this.hbh_1.a2u(ARGUMENT_0);
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 7) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(TipsNeededStrategy$invoke$slambda).vbh = function (tips, completion) {
  var i = new TipsNeededStrategy$invoke$slambda(this.ebh_1, this.fbh_1, completion);
  i.gbh_1 = tips;
  return i;
};
function TipsNeededStrategy$invoke$slambda_0(this$0, $punchContext, resultContinuation) {
  var i = new TipsNeededStrategy$invoke$slambda(this$0, $punchContext, resultContinuation);
  var l = function (tips, $completion) {
    return i.ubh(tips, $completion);
  };
  l.$arity = 1;
  return l;
}
function TipsNeededStrategy(clockRepository) {
  this.wbh_1 = clockRepository;
}
protoOf(TipsNeededStrategy).eb0 = function (response, punchContext) {
  return response.q9f_1 === true;
};
protoOf(TipsNeededStrategy).db0 = function (response, punchContext, $completion) {
  // Inline function 'kotlin.Companion.success' call
  var value = new TipsNeeded(TipsNeededStrategy$invoke$slambda_0(this, punchContext, null));
  var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
  return new Result(tmp$ret$0);
};
function getOS($this) {
  return contains(window.navigator.appVersion, 'Win', true) ? 'Windows' : contains(window.navigator.appVersion, 'Mac', true) ? 'MacOS' : contains(window.navigator.appVersion, 'X11', true) ? 'UNIX' : contains(window.navigator.appVersion, 'Linux', true) ? 'Linux' : 'Unknown OS';
}
function getBrowser($this) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var userAgent = window.navigator.userAgent.toLowerCase();
  return contains(userAgent, 'chrome') ? 'Chrome' : contains(userAgent, 'safari') ? 'Safari' : contains(userAgent, 'firefox') ? 'Firefox' : contains(userAgent, 'edge') ? 'Edge' : contains(userAgent, 'opera') || contains(userAgent, 'opr') ? 'Opera' : contains(userAgent, 'msie') || contains(userAgent, 'trident') ? 'Internet Explorer' : 'Unknown Browser';
}
function JSPlatform() {
  this.xbh_1 = 'April 28 ' + getOS(this) + ' ' + getBrowser(this);
}
protoOf(JSPlatform).m1d = function () {
  return this.xbh_1;
};
function getPlatform() {
  return new JSPlatform();
}
function punch($this, employeePunchId, $completion) {
  var tmp = new $punchCOROUTINE$5($this, employeePunchId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function PunchFlowServiceBrowserClient$punchAsPromise$slambda(this$0, $employeePunchId, resultContinuation) {
  this.qbi_1 = this$0;
  this.rbi_1 = $employeePunchId;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(PunchFlowServiceBrowserClient$punchAsPromise$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(PunchFlowServiceBrowserClient$punchAsPromise$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(PunchFlowServiceBrowserClient$punchAsPromise$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = punch(this.qbi_1, this.rbi_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(PunchFlowServiceBrowserClient$punchAsPromise$slambda).s3m = function ($this$promise, completion) {
  var i = new PunchFlowServiceBrowserClient$punchAsPromise$slambda(this.qbi_1, this.rbi_1, completion);
  i.sbi_1 = $this$promise;
  return i;
};
function PunchFlowServiceBrowserClient$punchAsPromise$slambda_0(this$0, $employeePunchId, resultContinuation) {
  var i = new PunchFlowServiceBrowserClient$punchAsPromise$slambda(this$0, $employeePunchId, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function $punchCOROUTINE$5(_this__u8e3s4, employeePunchId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.gbi_1 = _this__u8e3s4;
  this.hbi_1 = employeePunchId;
}
protoOf($punchCOROUTINE$5).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.gbi_1.ubi_1.fb0(this.hbi_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          this.o8_1 = 2;
          var response = result.y2t();
          return Companion_getInstance_3().wbi(response);
        case 2:
          this.o8_1 = 3;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            return Companion_getInstance_3().xbi(exception);
          } else {
            throw this.q8_1;
          }

        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function PunchFlowServiceBrowserClient(punchFlowService) {
  this.ubi_1 = punchFlowService;
}
protoOf(PunchFlowServiceBrowserClient).punchAsPromise = function (employeePunchId) {
  var tmp = GlobalScope_instance;
  return promise(tmp, VOID, VOID, PunchFlowServiceBrowserClient$punchAsPromise$slambda_0(this, employeePunchId, null));
};
function webViewPunchFlowServiceFactory(userId, companyId, locationHash, locationId, baseUrl, osVersion, appBuildVersion, debug, logException, tokenProvider) {
  var tmp;
  if (tokenProvider === VOID) {
    tmp = webViewPunchFlowServiceFactory$lambda;
  } else {
    tmp = tokenProvider;
  }
  tokenProvider = tmp;
  var sessionDataProvider = new webViewPunchFlowServiceFactory$sessionDataProvider$1(userId, companyId, locationHash, locationId);
  var networkDataProvider = new webViewPunchFlowServiceFactory$networkDataProvider$1(baseUrl, tokenProvider);
  var loggingProvider = new webViewPunchFlowServiceFactory$loggingProvider$1(debug);
  var platformUserProvider = new webViewPunchFlowServiceFactory$platformUserProvider$1();
  var tmp0_appLifecycleProvider = new Eager(new AppLifecycleProvider());
  var tmp1_environmentProvider = new Eager(new webViewPunchFlowServiceFactory$nativeDependencies$1(osVersion, appBuildVersion));
  var tmp2_loggingProvider = new Eager(loggingProvider);
  var tmp3_networkDataProvider = new Eager(networkDataProvider);
  var tmp4_networkReachabilityProvider = new Eager(new NetworkReachabilityProvider());
  var tmp5_platformUserProvider = new Eager(platformUserProvider);
  var tmp6_sessionDataProvider = new Eager(sessionDataProvider);
  var nativeDependencies = new NativeDependencies(tmp6_sessionDataProvider, tmp3_networkDataProvider, tmp2_loggingProvider, tmp5_platformUserProvider, tmp0_appLifecycleProvider, tmp1_environmentProvider, tmp4_networkReachabilityProvider);
  SharedDependencies_instance.b1m();
  SharedDependencies_instance.oax(nativeDependencies);
  return new PunchFlowServiceBrowserClient(SharedDependencies_instance.dax());
}
function shutdownPunchFlowService() {
  return SharedDependencies_instance.b1m();
}
function BrowserLogger(debug) {
  this.ybi_1 = debug;
}
protoOf(BrowserLogger).i6e = function (breadcrumb) {
  if (!breadcrumb.v6e_1 && !this.ybi_1)
    return Unit_instance;
  console.log('[7punches] ' + breadcrumb.u6e_1);
};
protoOf(BrowserLogger).j6e = function (issue) {
  var tmp0_safe_receiver = issue.l6e_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = issue.k6e_1.toString() + '/' + tmp0_safe_receiver.toString();
  }
  var tmp1_elvis_lhs = tmp;
  var location = tmp1_elvis_lhs == null ? issue.k6e_1.toString() : tmp1_elvis_lhs;
  var message = '[7punches] ' + location + ': ' + issue.n6e_1;
  var throwable = issue.p6e_1;
  switch (issue.m6e_1.l2_1) {
    case 0:
    case 1:
      if (!(throwable == null)) {
        console.warn(message, throwable);
      } else {
        console.warn(message);
      }

      break;
    case 2:
    case 3:
      if (!(throwable == null)) {
        console.error(message, throwable);
      } else {
        console.error(message);
      }

      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
};
function webViewPunchFlowServiceFactory$lambda() {
  return '';
}
function webViewPunchFlowServiceFactory$sessionDataProvider$1($userId, $companyId, $locationHash, $locationId) {
  this.zbi_1 = $userId;
  this.abj_1 = $companyId;
  this.bbj_1 = $locationHash;
  this.cbj_1 = $locationId;
}
protoOf(webViewPunchFlowServiceFactory$sessionDataProvider$1).f2w = function ($completion) {
  return this.zbi_1;
};
protoOf(webViewPunchFlowServiceFactory$sessionDataProvider$1).e2w = function ($completion) {
  return this.abj_1;
};
protoOf(webViewPunchFlowServiceFactory$sessionDataProvider$1).p37 = function ($completion) {
  return this.bbj_1;
};
protoOf(webViewPunchFlowServiceFactory$sessionDataProvider$1).q37 = function ($completion) {
  return this.cbj_1;
};
function webViewPunchFlowServiceFactory$networkDataProvider$1($baseUrl, $tokenProvider) {
  this.dbj_1 = $baseUrl;
  this.ebj_1 = $tokenProvider;
}
protoOf(webViewPunchFlowServiceFactory$networkDataProvider$1).f6k = function () {
  return this.dbj_1;
};
protoOf(webViewPunchFlowServiceFactory$networkDataProvider$1).y6l = function () {
  throw new NotImplementedError('WebSocket not supported in browser client');
};
protoOf(webViewPunchFlowServiceFactory$networkDataProvider$1).o6q = function () {
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.ebj_1();
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(this_0) > 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
};
function webViewPunchFlowServiceFactory$loggingProvider$1($debug) {
  this.fbj_1 = $debug;
}
protoOf(webViewPunchFlowServiceFactory$loggingProvider$1).r6e = function () {
  return new BrowserLogger(this.fbj_1);
};
protoOf(webViewPunchFlowServiceFactory$loggingProvider$1).b6f = function () {
  return this.fbj_1;
};
function webViewPunchFlowServiceFactory$platformUserProvider$1() {
}
function webViewPunchFlowServiceFactory$nativeDependencies$1($osVersion, $appBuildVersion) {
  this.gbj_1 = $osVersion;
  this.hbj_1 = $appBuildVersion;
}
protoOf(webViewPunchFlowServiceFactory$nativeDependencies$1).k37 = function () {
  return this.gbj_1;
};
protoOf(webViewPunchFlowServiceFactory$nativeDependencies$1).l37 = function () {
  return this.hbj_1;
};
protoOf(webViewPunchFlowServiceFactory$nativeDependencies$1).m37 = function () {
  return '2025-01-01';
};
protoOf(webViewPunchFlowServiceFactory$nativeDependencies$1).n37 = function () {
  return 'Embedded 7punches';
};
protoOf(webViewPunchFlowServiceFactory$nativeDependencies$1).o37 = function () {
  return Platform_WEB_getInstance();
};
function IntermediateResponse() {
}
function TerminalResponse() {
}
function ErrorResponse() {
}
function Companion_0() {
}
protoOf(Companion_0).xbi = function (exception) {
  return new APIError(exception.message);
};
var Companion_instance_4;
function Companion_getInstance_2() {
  return Companion_instance_4;
}
function APIError(message) {
  this.kbj_1 = message;
}
protoOf(APIError).g1 = function () {
  return this.kbj_1;
};
protoOf(APIError).mf = function () {
  return this.kbj_1;
};
protoOf(APIError).lbj = function (message) {
  return new APIError(message);
};
protoOf(APIError).copy = function (message, $super) {
  message = message === VOID ? this.kbj_1 : message;
  return $super === VOID ? this.lbj(message) : $super.lbj.call(this, message);
};
protoOf(APIError).toString = function () {
  return 'APIError(message=' + this.kbj_1 + ')';
};
protoOf(APIError).hashCode = function () {
  return this.kbj_1 == null ? 0 : getStringHashCode(this.kbj_1);
};
protoOf(APIError).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof APIError))
    return false;
  var tmp0_other_with_cast = other instanceof APIError ? other : THROW_CCE();
  if (!(this.kbj_1 == tmp0_other_with_cast.kbj_1))
    return false;
  return true;
};
function Companion_1() {
  Companion_instance_5 = this;
  this.vbi_1 = listOf([getKClass(ClockedIn_0), getKClass(ClockedOut_0), getKClass(BreakStarted), getKClass(BreakEnded), getKClass(TipsNeeded), getKClass(AttestationRequired), getKClass(HealthCheckRequired), getKClass(RoleSelectionRequired), getKClass(DepartmentSelectionRequired), getKClass(InvalidPunchId), getKClass(BreakTooShort), getKClass(HealthCheckFailed), getKClass(ClockedOut_1), getKClass(ClockedIn_1), getKClass(OnBreak_0)]);
}
protoOf(Companion_1).wbi = function (punchFlowServiceResponse) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = this.vbi_1.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.equals(getKClassFromExpression(punchFlowServiceResponse))) {
      if (punchFlowServiceResponse instanceof ClockedIn_0) {
        return Companion_instance_8.abk(punchFlowServiceResponse);
      } else {
        if (punchFlowServiceResponse instanceof TipsNeeded) {
          return Companion_instance_25.zbj(punchFlowServiceResponse);
        } else {
          if (punchFlowServiceResponse instanceof BreakEnded) {
            return Companion_instance_6.ybj(punchFlowServiceResponse);
          } else {
            if (punchFlowServiceResponse instanceof BreakStarted) {
              return Companion_instance_7.xbj(punchFlowServiceResponse);
            } else {
              if (punchFlowServiceResponse instanceof ClockedOut_0) {
                return Companion_instance_9.wbj(punchFlowServiceResponse);
              } else {
                if (punchFlowServiceResponse instanceof InvalidPunchId) {
                  return Companion_instance_12.vbj(punchFlowServiceResponse);
                } else {
                  if (punchFlowServiceResponse instanceof BreakTooShort) {
                    return Companion_instance_10.ubj(punchFlowServiceResponse);
                  } else {
                    if (punchFlowServiceResponse instanceof HealthCheckFailed) {
                      return Companion_instance_11.tbj(punchFlowServiceResponse);
                    } else {
                      if (punchFlowServiceResponse instanceof AttestationRequired) {
                        return Companion_instance_13.sbj(punchFlowServiceResponse);
                      } else {
                        if (punchFlowServiceResponse instanceof HealthCheckRequired) {
                          return Companion_instance_20.rbj(punchFlowServiceResponse);
                        } else {
                          if (punchFlowServiceResponse instanceof RoleSelectionRequired) {
                            return Companion_instance_24.qbj(punchFlowServiceResponse);
                          } else {
                            if (punchFlowServiceResponse instanceof DepartmentSelectionRequired) {
                              return Companion_instance_19.pbj(punchFlowServiceResponse);
                            } else {
                              if (punchFlowServiceResponse instanceof ClockedOut_1) {
                                return Companion_instance_35.obj(punchFlowServiceResponse);
                              } else {
                                if (punchFlowServiceResponse instanceof ClockedIn_1) {
                                  return Companion_instance_34.nbj(punchFlowServiceResponse);
                                } else {
                                  if (punchFlowServiceResponse instanceof OnBreak_0) {
                                    return Companion_instance_37.mbj(punchFlowServiceResponse);
                                  } else {
                                    noWhenBranchMatchedException();
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return null;
};
protoOf(Companion_1).xbi = function (exception) {
  return Companion_instance_4.xbi(exception);
};
var Companion_instance_5;
function Companion_getInstance_3() {
  if (Companion_instance_5 == null)
    new Companion_1();
  return Companion_instance_5;
}
function PunchBrowserResponse_0() {
}
function UserStatusBrowserResponse() {
}
function Companion_2() {
}
protoOf(Companion_2).ybj = function (punchFlowServiceResponse) {
  return new BreakEnded_0(punchFlowServiceResponse.xb8_1.d1(), punchFlowServiceResponse.yb8_1.d1(), punchFlowServiceResponse.zb8_1, punchFlowServiceResponse.ab9_1, punchFlowServiceResponse.bb9_1);
};
var Companion_instance_6;
function Companion_getInstance_4() {
  return Companion_instance_6;
}
function BreakEnded_0(timePunchId, breakId, breakDurationInMinutes, userPhotoUrl, message) {
  this.dbk_1 = timePunchId;
  this.breakId = breakId;
  this.breakDurationInMinutes = breakDurationInMinutes;
  this.ebk_1 = userPhotoUrl;
  this.fbk_1 = message;
}
protoOf(BreakEnded_0).ibj = function () {
  return this.dbk_1;
};
protoOf(BreakEnded_0).gbk = function () {
  return this.breakId;
};
protoOf(BreakEnded_0).hbk = function () {
  return this.breakDurationInMinutes;
};
protoOf(BreakEnded_0).jbj = function () {
  return this.ebk_1;
};
protoOf(BreakEnded_0).g1 = function () {
  return this.fbk_1;
};
protoOf(BreakEnded_0).mf = function () {
  return this.dbk_1;
};
protoOf(BreakEnded_0).nf = function () {
  return this.breakId;
};
protoOf(BreakEnded_0).ibk = function () {
  return this.breakDurationInMinutes;
};
protoOf(BreakEnded_0).jbk = function () {
  return this.ebk_1;
};
protoOf(BreakEnded_0).kbk = function () {
  return this.fbk_1;
};
protoOf(BreakEnded_0).lbk = function (timePunchId, breakId, breakDurationInMinutes, userPhotoUrl, message) {
  return new BreakEnded_0(timePunchId, breakId, breakDurationInMinutes, userPhotoUrl, message);
};
protoOf(BreakEnded_0).copy = function (timePunchId, breakId, breakDurationInMinutes, userPhotoUrl, message, $super) {
  timePunchId = timePunchId === VOID ? this.dbk_1 : timePunchId;
  breakId = breakId === VOID ? this.breakId : breakId;
  breakDurationInMinutes = breakDurationInMinutes === VOID ? this.breakDurationInMinutes : breakDurationInMinutes;
  userPhotoUrl = userPhotoUrl === VOID ? this.ebk_1 : userPhotoUrl;
  message = message === VOID ? this.fbk_1 : message;
  return $super === VOID ? this.lbk(timePunchId, breakId, breakDurationInMinutes, userPhotoUrl, message) : $super.lbk.call(this, timePunchId, breakId, breakDurationInMinutes, userPhotoUrl, message);
};
protoOf(BreakEnded_0).toString = function () {
  return 'BreakEnded(timePunchId=' + this.dbk_1 + ', breakId=' + this.breakId + ', breakDurationInMinutes=' + this.breakDurationInMinutes + ', userPhotoUrl=' + this.ebk_1 + ', message=' + this.fbk_1 + ')';
};
protoOf(BreakEnded_0).hashCode = function () {
  var result = this.dbk_1;
  result = imul(result, 31) + this.breakId | 0;
  result = imul(result, 31) + this.breakDurationInMinutes | 0;
  result = imul(result, 31) + (this.ebk_1 == null ? 0 : getStringHashCode(this.ebk_1)) | 0;
  result = imul(result, 31) + (this.fbk_1 == null ? 0 : getStringHashCode(this.fbk_1)) | 0;
  return result;
};
protoOf(BreakEnded_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BreakEnded_0))
    return false;
  var tmp0_other_with_cast = other instanceof BreakEnded_0 ? other : THROW_CCE();
  if (!(this.dbk_1 === tmp0_other_with_cast.dbk_1))
    return false;
  if (!(this.breakId === tmp0_other_with_cast.breakId))
    return false;
  if (!(this.breakDurationInMinutes === tmp0_other_with_cast.breakDurationInMinutes))
    return false;
  if (!(this.ebk_1 == tmp0_other_with_cast.ebk_1))
    return false;
  if (!(this.fbk_1 == tmp0_other_with_cast.fbk_1))
    return false;
  return true;
};
function Companion_3() {
}
protoOf(Companion_3).xbj = function (punchFlowServiceResponse) {
  return new BreakStarted_0(punchFlowServiceResponse.tb8_1.d1(), punchFlowServiceResponse.ub8_1.d1(), punchFlowServiceResponse.vb8_1, punchFlowServiceResponse.wb8_1);
};
var Companion_instance_7;
function Companion_getInstance_5() {
  return Companion_instance_7;
}
function BreakStarted_0(timePunchId, breakId, userPhotoUrl, message) {
  this.mbk_1 = timePunchId;
  this.breakId = breakId;
  this.nbk_1 = userPhotoUrl;
  this.obk_1 = message;
}
protoOf(BreakStarted_0).ibj = function () {
  return this.mbk_1;
};
protoOf(BreakStarted_0).gbk = function () {
  return this.breakId;
};
protoOf(BreakStarted_0).jbj = function () {
  return this.nbk_1;
};
protoOf(BreakStarted_0).g1 = function () {
  return this.obk_1;
};
protoOf(BreakStarted_0).mf = function () {
  return this.mbk_1;
};
protoOf(BreakStarted_0).nf = function () {
  return this.breakId;
};
protoOf(BreakStarted_0).ibk = function () {
  return this.nbk_1;
};
protoOf(BreakStarted_0).jbk = function () {
  return this.obk_1;
};
protoOf(BreakStarted_0).pbk = function (timePunchId, breakId, userPhotoUrl, message) {
  return new BreakStarted_0(timePunchId, breakId, userPhotoUrl, message);
};
protoOf(BreakStarted_0).copy = function (timePunchId, breakId, userPhotoUrl, message, $super) {
  timePunchId = timePunchId === VOID ? this.mbk_1 : timePunchId;
  breakId = breakId === VOID ? this.breakId : breakId;
  userPhotoUrl = userPhotoUrl === VOID ? this.nbk_1 : userPhotoUrl;
  message = message === VOID ? this.obk_1 : message;
  return $super === VOID ? this.pbk(timePunchId, breakId, userPhotoUrl, message) : $super.pbk.call(this, timePunchId, breakId, userPhotoUrl, message);
};
protoOf(BreakStarted_0).toString = function () {
  return 'BreakStarted(timePunchId=' + this.mbk_1 + ', breakId=' + this.breakId + ', userPhotoUrl=' + this.nbk_1 + ', message=' + this.obk_1 + ')';
};
protoOf(BreakStarted_0).hashCode = function () {
  var result = this.mbk_1;
  result = imul(result, 31) + this.breakId | 0;
  result = imul(result, 31) + (this.nbk_1 == null ? 0 : getStringHashCode(this.nbk_1)) | 0;
  result = imul(result, 31) + (this.obk_1 == null ? 0 : getStringHashCode(this.obk_1)) | 0;
  return result;
};
protoOf(BreakStarted_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BreakStarted_0))
    return false;
  var tmp0_other_with_cast = other instanceof BreakStarted_0 ? other : THROW_CCE();
  if (!(this.mbk_1 === tmp0_other_with_cast.mbk_1))
    return false;
  if (!(this.breakId === tmp0_other_with_cast.breakId))
    return false;
  if (!(this.nbk_1 == tmp0_other_with_cast.nbk_1))
    return false;
  if (!(this.obk_1 == tmp0_other_with_cast.obk_1))
    return false;
  return true;
};
function Companion_4() {
}
protoOf(Companion_4).abk = function (punchFlowServiceResponse) {
  return new ClockedIn_2(punchFlowServiceResponse.cb9_1.d1(), punchFlowServiceResponse.db9_1, punchFlowServiceResponse.eb9_1);
};
var Companion_instance_8;
function Companion_getInstance_6() {
  return Companion_instance_8;
}
function ClockedIn_2(timePunchId, message, userPhotoUrl) {
  this.qbk_1 = timePunchId;
  this.rbk_1 = message;
  this.sbk_1 = userPhotoUrl;
}
protoOf(ClockedIn_2).ibj = function () {
  return this.qbk_1;
};
protoOf(ClockedIn_2).g1 = function () {
  return this.rbk_1;
};
protoOf(ClockedIn_2).jbj = function () {
  return this.sbk_1;
};
protoOf(ClockedIn_2).mf = function () {
  return this.qbk_1;
};
protoOf(ClockedIn_2).nf = function () {
  return this.rbk_1;
};
protoOf(ClockedIn_2).ibk = function () {
  return this.sbk_1;
};
protoOf(ClockedIn_2).tbk = function (timePunchId, message, userPhotoUrl) {
  return new ClockedIn_2(timePunchId, message, userPhotoUrl);
};
protoOf(ClockedIn_2).copy = function (timePunchId, message, userPhotoUrl, $super) {
  timePunchId = timePunchId === VOID ? this.qbk_1 : timePunchId;
  message = message === VOID ? this.rbk_1 : message;
  userPhotoUrl = userPhotoUrl === VOID ? this.sbk_1 : userPhotoUrl;
  return $super === VOID ? this.tbk(timePunchId, message, userPhotoUrl) : $super.tbk.call(this, timePunchId, message, userPhotoUrl);
};
protoOf(ClockedIn_2).toString = function () {
  return 'ClockedIn(timePunchId=' + this.qbk_1 + ', message=' + this.rbk_1 + ', userPhotoUrl=' + this.sbk_1 + ')';
};
protoOf(ClockedIn_2).hashCode = function () {
  var result = this.qbk_1;
  result = imul(result, 31) + (this.rbk_1 == null ? 0 : getStringHashCode(this.rbk_1)) | 0;
  result = imul(result, 31) + (this.sbk_1 == null ? 0 : getStringHashCode(this.sbk_1)) | 0;
  return result;
};
protoOf(ClockedIn_2).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedIn_2))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedIn_2 ? other : THROW_CCE();
  if (!(this.qbk_1 === tmp0_other_with_cast.qbk_1))
    return false;
  if (!(this.rbk_1 == tmp0_other_with_cast.rbk_1))
    return false;
  if (!(this.sbk_1 == tmp0_other_with_cast.sbk_1))
    return false;
  return true;
};
function Companion_5() {
}
protoOf(Companion_5).wbj = function (punchFlowServiceResponse) {
  return new ClockedOut_2(punchFlowServiceResponse.fb9_1.d1(), punchFlowServiceResponse.gb9_1, punchFlowServiceResponse.hb9_1);
};
var Companion_instance_9;
function Companion_getInstance_7() {
  return Companion_instance_9;
}
function ClockedOut_2(timePunchId, message, userPhotoUrl) {
  this.ubk_1 = timePunchId;
  this.vbk_1 = message;
  this.wbk_1 = userPhotoUrl;
}
protoOf(ClockedOut_2).ibj = function () {
  return this.ubk_1;
};
protoOf(ClockedOut_2).g1 = function () {
  return this.vbk_1;
};
protoOf(ClockedOut_2).jbj = function () {
  return this.wbk_1;
};
protoOf(ClockedOut_2).mf = function () {
  return this.ubk_1;
};
protoOf(ClockedOut_2).nf = function () {
  return this.vbk_1;
};
protoOf(ClockedOut_2).ibk = function () {
  return this.wbk_1;
};
protoOf(ClockedOut_2).tbk = function (timePunchId, message, userPhotoUrl) {
  return new ClockedOut_2(timePunchId, message, userPhotoUrl);
};
protoOf(ClockedOut_2).copy = function (timePunchId, message, userPhotoUrl, $super) {
  timePunchId = timePunchId === VOID ? this.ubk_1 : timePunchId;
  message = message === VOID ? this.vbk_1 : message;
  userPhotoUrl = userPhotoUrl === VOID ? this.wbk_1 : userPhotoUrl;
  return $super === VOID ? this.tbk(timePunchId, message, userPhotoUrl) : $super.tbk.call(this, timePunchId, message, userPhotoUrl);
};
protoOf(ClockedOut_2).toString = function () {
  return 'ClockedOut(timePunchId=' + this.ubk_1 + ', message=' + this.vbk_1 + ', userPhotoUrl=' + this.wbk_1 + ')';
};
protoOf(ClockedOut_2).hashCode = function () {
  var result = this.ubk_1;
  result = imul(result, 31) + (this.vbk_1 == null ? 0 : getStringHashCode(this.vbk_1)) | 0;
  result = imul(result, 31) + (this.wbk_1 == null ? 0 : getStringHashCode(this.wbk_1)) | 0;
  return result;
};
protoOf(ClockedOut_2).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedOut_2))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedOut_2 ? other : THROW_CCE();
  if (!(this.ubk_1 === tmp0_other_with_cast.ubk_1))
    return false;
  if (!(this.vbk_1 == tmp0_other_with_cast.vbk_1))
    return false;
  if (!(this.wbk_1 == tmp0_other_with_cast.wbk_1))
    return false;
  return true;
};
function Companion_6() {
}
protoOf(Companion_6).ubj = function (punchFlowServiceResponse) {
  return new BreakTooShort_0(punchFlowServiceResponse.lb9_1);
};
var Companion_instance_10;
function Companion_getInstance_8() {
  return Companion_instance_10;
}
function BreakTooShort_0(message) {
  this.xbk_1 = message;
}
protoOf(BreakTooShort_0).g1 = function () {
  return this.xbk_1;
};
protoOf(BreakTooShort_0).mf = function () {
  return this.xbk_1;
};
protoOf(BreakTooShort_0).lbj = function (message) {
  return new BreakTooShort_0(message);
};
protoOf(BreakTooShort_0).copy = function (message, $super) {
  message = message === VOID ? this.xbk_1 : message;
  return $super === VOID ? this.lbj(message) : $super.lbj.call(this, message);
};
protoOf(BreakTooShort_0).toString = function () {
  return 'BreakTooShort(message=' + this.xbk_1 + ')';
};
protoOf(BreakTooShort_0).hashCode = function () {
  return this.xbk_1 == null ? 0 : getStringHashCode(this.xbk_1);
};
protoOf(BreakTooShort_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BreakTooShort_0))
    return false;
  var tmp0_other_with_cast = other instanceof BreakTooShort_0 ? other : THROW_CCE();
  if (!(this.xbk_1 == tmp0_other_with_cast.xbk_1))
    return false;
  return true;
};
function Companion_7() {
}
protoOf(Companion_7).tbj = function (punchFlowServiceResponse) {
  return new HealthCheckFailed_0(punchFlowServiceResponse.jb9_1, punchFlowServiceResponse.kb9_1);
};
var Companion_instance_11;
function Companion_getInstance_9() {
  return Companion_instance_11;
}
function HealthCheckFailed_0(message, userPhotoUrl) {
  this.ybk_1 = message;
  this.userPhotoUrl = userPhotoUrl;
}
protoOf(HealthCheckFailed_0).g1 = function () {
  return this.ybk_1;
};
protoOf(HealthCheckFailed_0).jbj = function () {
  return this.userPhotoUrl;
};
protoOf(HealthCheckFailed_0).mf = function () {
  return this.ybk_1;
};
protoOf(HealthCheckFailed_0).nf = function () {
  return this.userPhotoUrl;
};
protoOf(HealthCheckFailed_0).zbk = function (message, userPhotoUrl) {
  return new HealthCheckFailed_0(message, userPhotoUrl);
};
protoOf(HealthCheckFailed_0).copy = function (message, userPhotoUrl, $super) {
  message = message === VOID ? this.ybk_1 : message;
  userPhotoUrl = userPhotoUrl === VOID ? this.userPhotoUrl : userPhotoUrl;
  return $super === VOID ? this.zbk(message, userPhotoUrl) : $super.zbk.call(this, message, userPhotoUrl);
};
protoOf(HealthCheckFailed_0).toString = function () {
  return 'HealthCheckFailed(message=' + this.ybk_1 + ', userPhotoUrl=' + this.userPhotoUrl + ')';
};
protoOf(HealthCheckFailed_0).hashCode = function () {
  var result = this.ybk_1 == null ? 0 : getStringHashCode(this.ybk_1);
  result = imul(result, 31) + (this.userPhotoUrl == null ? 0 : getStringHashCode(this.userPhotoUrl)) | 0;
  return result;
};
protoOf(HealthCheckFailed_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HealthCheckFailed_0))
    return false;
  var tmp0_other_with_cast = other instanceof HealthCheckFailed_0 ? other : THROW_CCE();
  if (!(this.ybk_1 == tmp0_other_with_cast.ybk_1))
    return false;
  if (!(this.userPhotoUrl == tmp0_other_with_cast.userPhotoUrl))
    return false;
  return true;
};
function Companion_8() {
}
protoOf(Companion_8).vbj = function (punchFlowServiceResponse) {
  return new InvalidPunchId_0(punchFlowServiceResponse.ib9_1);
};
var Companion_instance_12;
function Companion_getInstance_10() {
  return Companion_instance_12;
}
function InvalidPunchId_0(message) {
  this.abl_1 = message;
}
protoOf(InvalidPunchId_0).g1 = function () {
  return this.abl_1;
};
protoOf(InvalidPunchId_0).mf = function () {
  return this.abl_1;
};
protoOf(InvalidPunchId_0).lbj = function (message) {
  return new InvalidPunchId_0(message);
};
protoOf(InvalidPunchId_0).copy = function (message, $super) {
  message = message === VOID ? this.abl_1 : message;
  return $super === VOID ? this.lbj(message) : $super.lbj.call(this, message);
};
protoOf(InvalidPunchId_0).toString = function () {
  return 'InvalidPunchId(message=' + this.abl_1 + ')';
};
protoOf(InvalidPunchId_0).hashCode = function () {
  return this.abl_1 == null ? 0 : getStringHashCode(this.abl_1);
};
protoOf(InvalidPunchId_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof InvalidPunchId_0))
    return false;
  var tmp0_other_with_cast = other instanceof InvalidPunchId_0 ? other : THROW_CCE();
  if (!(this.abl_1 == tmp0_other_with_cast.abl_1))
    return false;
  return true;
};
function BrowserAttestationRequired$Companion$from$o$slambda($punchFlowServiceResponse, $attestationResponseId, resultContinuation) {
  this.jbl_1 = $punchFlowServiceResponse;
  this.kbl_1 = $attestationResponseId;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserAttestationRequired$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserAttestationRequired$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserAttestationRequired$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.jbl_1.lb8_1(toLong(this.kbl_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserAttestationRequired$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserAttestationRequired$Companion$from$o$slambda(this.jbl_1, this.kbl_1, completion);
  i.lbl_1 = $this$promise;
  return i;
};
function BrowserAttestationRequired$Companion$from$o$slambda_0($punchFlowServiceResponse, $attestationResponseId, resultContinuation) {
  var i = new BrowserAttestationRequired$Companion$from$o$slambda($punchFlowServiceResponse, $attestationResponseId, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserAttestationRequired$Companion$from$o($punchFlowServiceResponse) {
  return function (attestationResponseId) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserAttestationRequired$Companion$from$o$slambda_0($punchFlowServiceResponse, attestationResponseId, null));
  };
}
function Companion_9() {
}
protoOf(Companion_9).sbj = function (punchFlowServiceResponse) {
  var sendResponse = BrowserAttestationRequired$Companion$from$o(punchFlowServiceResponse);
  return new BrowserAttestationRequired(Companion_instance_14.mbl(punchFlowServiceResponse.kb8_1), sendResponse);
};
var Companion_instance_13;
function Companion_getInstance_11() {
  return Companion_instance_13;
}
function BrowserAttestationRequired(attestation, sendAttestationResponse) {
  this.attestation = attestation;
  this.sendAttestationResponse = sendAttestationResponse;
}
protoOf(BrowserAttestationRequired).nbl = function () {
  return this.attestation;
};
protoOf(BrowserAttestationRequired).obl = function () {
  return this.sendAttestationResponse;
};
protoOf(BrowserAttestationRequired).mf = function () {
  return this.attestation;
};
protoOf(BrowserAttestationRequired).nf = function () {
  return this.sendAttestationResponse;
};
protoOf(BrowserAttestationRequired).pbl = function (attestation, sendAttestationResponse) {
  return new BrowserAttestationRequired(attestation, sendAttestationResponse);
};
protoOf(BrowserAttestationRequired).copy = function (attestation, sendAttestationResponse, $super) {
  attestation = attestation === VOID ? this.attestation : attestation;
  sendAttestationResponse = sendAttestationResponse === VOID ? this.sendAttestationResponse : sendAttestationResponse;
  return $super === VOID ? this.pbl(attestation, sendAttestationResponse) : $super.pbl.call(this, attestation, sendAttestationResponse);
};
protoOf(BrowserAttestationRequired).toString = function () {
  return 'BrowserAttestationRequired(attestation=' + this.attestation.toString() + ', sendAttestationResponse=' + toString(this.sendAttestationResponse) + ')';
};
protoOf(BrowserAttestationRequired).hashCode = function () {
  var result = this.attestation.hashCode();
  result = imul(result, 31) + hashCode(this.sendAttestationResponse) | 0;
  return result;
};
protoOf(BrowserAttestationRequired).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserAttestationRequired))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserAttestationRequired ? other : THROW_CCE();
  if (!this.attestation.equals(tmp0_other_with_cast.attestation))
    return false;
  if (!equals(this.sendAttestationResponse, tmp0_other_with_cast.sendAttestationResponse))
    return false;
  return true;
};
function Companion_10() {
}
protoOf(Companion_10).mbl = function (attestation) {
  var tmp = attestation.e97_1.d1();
  // Inline function 'kotlin.collections.map' call
  var this_0 = attestation.f97_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = Companion_instance_15.qbl(item);
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(destination);
  return new BrowserAttestation(tmp, tmp$ret$3);
};
var Companion_instance_14;
function Companion_getInstance_12() {
  return Companion_instance_14;
}
function BrowserAttestation(id, contents) {
  this.id = id;
  this.contents = contents;
}
protoOf(BrowserAttestation).f2t = function () {
  return this.id;
};
protoOf(BrowserAttestation).rbl = function () {
  return this.contents;
};
protoOf(BrowserAttestation).mf = function () {
  return this.id;
};
protoOf(BrowserAttestation).nf = function () {
  return this.contents;
};
protoOf(BrowserAttestation).sbl = function (id, contents) {
  return new BrowserAttestation(id, contents);
};
protoOf(BrowserAttestation).copy = function (id, contents, $super) {
  id = id === VOID ? this.id : id;
  contents = contents === VOID ? this.contents : contents;
  return $super === VOID ? this.sbl(id, contents) : $super.sbl.call(this, id, contents);
};
protoOf(BrowserAttestation).toString = function () {
  return 'BrowserAttestation(id=' + this.id + ', contents=' + toString(this.contents) + ')';
};
protoOf(BrowserAttestation).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + hashCode(this.contents) | 0;
  return result;
};
protoOf(BrowserAttestation).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserAttestation))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserAttestation ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!equals(this.contents, tmp0_other_with_cast.contents))
    return false;
  return true;
};
function Companion_11() {
}
protoOf(Companion_11).qbl = function (content) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = content.b97_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = Companion_instance_16.tbl(item);
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(destination);
  return new BrowserAttestationContent(content.x96_1, content.y96_1, content.z96_1, content.a97_1, tmp$ret$3);
};
var Companion_instance_15;
function Companion_getInstance_13() {
  return Companion_instance_15;
}
function BrowserAttestationContent(language, question, policy, buttonText, responses) {
  this.language = language;
  this.question = question;
  this.policy = policy;
  this.buttonText = buttonText;
  this.responses = responses;
}
protoOf(BrowserAttestationContent).ubl = function () {
  return this.language;
};
protoOf(BrowserAttestationContent).vbl = function () {
  return this.question;
};
protoOf(BrowserAttestationContent).wbl = function () {
  return this.policy;
};
protoOf(BrowserAttestationContent).xbl = function () {
  return this.buttonText;
};
protoOf(BrowserAttestationContent).ybl = function () {
  return this.responses;
};
protoOf(BrowserAttestationContent).mf = function () {
  return this.language;
};
protoOf(BrowserAttestationContent).nf = function () {
  return this.question;
};
protoOf(BrowserAttestationContent).ibk = function () {
  return this.policy;
};
protoOf(BrowserAttestationContent).jbk = function () {
  return this.buttonText;
};
protoOf(BrowserAttestationContent).kbk = function () {
  return this.responses;
};
protoOf(BrowserAttestationContent).zbl = function (language, question, policy, buttonText, responses) {
  return new BrowserAttestationContent(language, question, policy, buttonText, responses);
};
protoOf(BrowserAttestationContent).copy = function (language, question, policy, buttonText, responses, $super) {
  language = language === VOID ? this.language : language;
  question = question === VOID ? this.question : question;
  policy = policy === VOID ? this.policy : policy;
  buttonText = buttonText === VOID ? this.buttonText : buttonText;
  responses = responses === VOID ? this.responses : responses;
  return $super === VOID ? this.zbl(language, question, policy, buttonText, responses) : $super.zbl.call(this, language, question, policy, buttonText, responses);
};
protoOf(BrowserAttestationContent).toString = function () {
  return 'BrowserAttestationContent(language=' + this.language + ', question=' + this.question + ', policy=' + this.policy + ', buttonText=' + this.buttonText + ', responses=' + toString(this.responses) + ')';
};
protoOf(BrowserAttestationContent).hashCode = function () {
  var result = getStringHashCode(this.language);
  result = imul(result, 31) + getStringHashCode(this.question) | 0;
  result = imul(result, 31) + getStringHashCode(this.policy) | 0;
  result = imul(result, 31) + getStringHashCode(this.buttonText) | 0;
  result = imul(result, 31) + hashCode(this.responses) | 0;
  return result;
};
protoOf(BrowserAttestationContent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserAttestationContent))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserAttestationContent ? other : THROW_CCE();
  if (!(this.language === tmp0_other_with_cast.language))
    return false;
  if (!(this.question === tmp0_other_with_cast.question))
    return false;
  if (!(this.policy === tmp0_other_with_cast.policy))
    return false;
  if (!(this.buttonText === tmp0_other_with_cast.buttonText))
    return false;
  if (!equals(this.responses, tmp0_other_with_cast.responses))
    return false;
  return true;
};
function Companion_12() {
}
protoOf(Companion_12).tbl = function (response) {
  return new BrowserAttestationResponse(response.c97_1.d1(), response.d97_1);
};
var Companion_instance_16;
function Companion_getInstance_14() {
  return Companion_instance_16;
}
function BrowserAttestationResponse(id, text) {
  this.id = id;
  this.text = text;
}
protoOf(BrowserAttestationResponse).f2t = function () {
  return this.id;
};
protoOf(BrowserAttestationResponse).abm = function () {
  return this.text;
};
protoOf(BrowserAttestationResponse).mf = function () {
  return this.id;
};
protoOf(BrowserAttestationResponse).nf = function () {
  return this.text;
};
protoOf(BrowserAttestationResponse).bbm = function (id, text) {
  return new BrowserAttestationResponse(id, text);
};
protoOf(BrowserAttestationResponse).copy = function (id, text, $super) {
  id = id === VOID ? this.id : id;
  text = text === VOID ? this.text : text;
  return $super === VOID ? this.bbm(id, text) : $super.bbm.call(this, id, text);
};
protoOf(BrowserAttestationResponse).toString = function () {
  return 'BrowserAttestationResponse(id=' + this.id + ', text=' + this.text + ')';
};
protoOf(BrowserAttestationResponse).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + getStringHashCode(this.text) | 0;
  return result;
};
protoOf(BrowserAttestationResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserAttestationResponse))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserAttestationResponse ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.text === tmp0_other_with_cast.text))
    return false;
  return true;
};
function Companion_13() {
}
protoOf(Companion_13).cbm = function (role) {
  var tmp = role.v9e_1.d1();
  var tmp0_safe_receiver = role.x9e_1;
  return new BrowserClockRole(tmp, role.w9e_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d1(), role.y9e_1, role.z9e_1);
};
var Companion_instance_17;
function Companion_getInstance_15() {
  return Companion_instance_17;
}
function BrowserClockRole(id, name, departmentId, departmentName, color) {
  this.id = id;
  this.name = name;
  this.departmentId = departmentId;
  this.departmentName = departmentName;
  this.color = color;
}
protoOf(BrowserClockRole).f2t = function () {
  return this.id;
};
protoOf(BrowserClockRole).m1d = function () {
  return this.name;
};
protoOf(BrowserClockRole).dbm = function () {
  return this.departmentId;
};
protoOf(BrowserClockRole).ebm = function () {
  return this.departmentName;
};
protoOf(BrowserClockRole).fbm = function () {
  return this.color;
};
protoOf(BrowserClockRole).mf = function () {
  return this.id;
};
protoOf(BrowserClockRole).nf = function () {
  return this.name;
};
protoOf(BrowserClockRole).ibk = function () {
  return this.departmentId;
};
protoOf(BrowserClockRole).jbk = function () {
  return this.departmentName;
};
protoOf(BrowserClockRole).kbk = function () {
  return this.color;
};
protoOf(BrowserClockRole).gbm = function (id, name, departmentId, departmentName, color) {
  return new BrowserClockRole(id, name, departmentId, departmentName, color);
};
protoOf(BrowserClockRole).copy = function (id, name, departmentId, departmentName, color, $super) {
  id = id === VOID ? this.id : id;
  name = name === VOID ? this.name : name;
  departmentId = departmentId === VOID ? this.departmentId : departmentId;
  departmentName = departmentName === VOID ? this.departmentName : departmentName;
  color = color === VOID ? this.color : color;
  return $super === VOID ? this.gbm(id, name, departmentId, departmentName, color) : $super.gbm.call(this, id, name, departmentId, departmentName, color);
};
protoOf(BrowserClockRole).toString = function () {
  return 'BrowserClockRole(id=' + this.id + ', name=' + this.name + ', departmentId=' + this.departmentId + ', departmentName=' + this.departmentName + ', color=' + this.color + ')';
};
protoOf(BrowserClockRole).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + getStringHashCode(this.name) | 0;
  result = imul(result, 31) + (this.departmentId == null ? 0 : this.departmentId) | 0;
  result = imul(result, 31) + (this.departmentName == null ? 0 : getStringHashCode(this.departmentName)) | 0;
  result = imul(result, 31) + (this.color == null ? 0 : getStringHashCode(this.color)) | 0;
  return result;
};
protoOf(BrowserClockRole).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserClockRole))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserClockRole ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.name === tmp0_other_with_cast.name))
    return false;
  if (!(this.departmentId == tmp0_other_with_cast.departmentId))
    return false;
  if (!(this.departmentName == tmp0_other_with_cast.departmentName))
    return false;
  if (!(this.color == tmp0_other_with_cast.color))
    return false;
  return true;
};
function Companion_14() {
}
protoOf(Companion_14).hbm = function (department) {
  return new BrowserClockDepartment(department.a9f_1.d1(), department.b9f_1);
};
var Companion_instance_18;
function Companion_getInstance_16() {
  return Companion_instance_18;
}
function BrowserClockDepartment(id, name) {
  this.id = id;
  this.name = name;
}
protoOf(BrowserClockDepartment).f2t = function () {
  return this.id;
};
protoOf(BrowserClockDepartment).m1d = function () {
  return this.name;
};
protoOf(BrowserClockDepartment).mf = function () {
  return this.id;
};
protoOf(BrowserClockDepartment).nf = function () {
  return this.name;
};
protoOf(BrowserClockDepartment).bbm = function (id, name) {
  return new BrowserClockDepartment(id, name);
};
protoOf(BrowserClockDepartment).copy = function (id, name, $super) {
  id = id === VOID ? this.id : id;
  name = name === VOID ? this.name : name;
  return $super === VOID ? this.bbm(id, name) : $super.bbm.call(this, id, name);
};
protoOf(BrowserClockDepartment).toString = function () {
  return 'BrowserClockDepartment(id=' + this.id + ', name=' + this.name + ')';
};
protoOf(BrowserClockDepartment).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + getStringHashCode(this.name) | 0;
  return result;
};
protoOf(BrowserClockDepartment).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserClockDepartment))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserClockDepartment ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.name === tmp0_other_with_cast.name))
    return false;
  return true;
};
function BrowserDepartmentSelectionRequired$Companion$from$o$slambda($punchFlowServiceResponse, $departmentId, resultContinuation) {
  this.qbm_1 = $punchFlowServiceResponse;
  this.rbm_1 = $departmentId;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserDepartmentSelectionRequired$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserDepartmentSelectionRequired$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserDepartmentSelectionRequired$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.qbm_1.sb8_1(toLong(this.rbm_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserDepartmentSelectionRequired$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserDepartmentSelectionRequired$Companion$from$o$slambda(this.qbm_1, this.rbm_1, completion);
  i.sbm_1 = $this$promise;
  return i;
};
function BrowserDepartmentSelectionRequired$Companion$from$o$slambda_0($punchFlowServiceResponse, $departmentId, resultContinuation) {
  var i = new BrowserDepartmentSelectionRequired$Companion$from$o$slambda($punchFlowServiceResponse, $departmentId, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserDepartmentSelectionRequired$Companion$from$o($punchFlowServiceResponse) {
  return function (departmentId) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserDepartmentSelectionRequired$Companion$from$o$slambda_0($punchFlowServiceResponse, departmentId, null));
  };
}
function Companion_15() {
}
protoOf(Companion_15).pbj = function (punchFlowServiceResponse) {
  var select = BrowserDepartmentSelectionRequired$Companion$from$o(punchFlowServiceResponse);
  // Inline function 'kotlin.collections.map' call
  var this_0 = punchFlowServiceResponse.rb8_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = Companion_instance_18.hbm(item);
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(destination);
  return new BrowserDepartmentSelectionRequired(tmp$ret$3, select);
};
var Companion_instance_19;
function Companion_getInstance_17() {
  return Companion_instance_19;
}
function BrowserDepartmentSelectionRequired(departments, selectDepartment) {
  this.departments = departments;
  this.selectDepartment = selectDepartment;
}
protoOf(BrowserDepartmentSelectionRequired).tbm = function () {
  return this.departments;
};
protoOf(BrowserDepartmentSelectionRequired).ubm = function () {
  return this.selectDepartment;
};
protoOf(BrowserDepartmentSelectionRequired).mf = function () {
  return this.departments;
};
protoOf(BrowserDepartmentSelectionRequired).nf = function () {
  return this.selectDepartment;
};
protoOf(BrowserDepartmentSelectionRequired).vbm = function (departments, selectDepartment) {
  return new BrowserDepartmentSelectionRequired(departments, selectDepartment);
};
protoOf(BrowserDepartmentSelectionRequired).copy = function (departments, selectDepartment, $super) {
  departments = departments === VOID ? this.departments : departments;
  selectDepartment = selectDepartment === VOID ? this.selectDepartment : selectDepartment;
  return $super === VOID ? this.vbm(departments, selectDepartment) : $super.vbm.call(this, departments, selectDepartment);
};
protoOf(BrowserDepartmentSelectionRequired).toString = function () {
  return 'BrowserDepartmentSelectionRequired(departments=' + toString(this.departments) + ', selectDepartment=' + toString(this.selectDepartment) + ')';
};
protoOf(BrowserDepartmentSelectionRequired).hashCode = function () {
  var result = hashCode(this.departments);
  result = imul(result, 31) + hashCode(this.selectDepartment) | 0;
  return result;
};
protoOf(BrowserDepartmentSelectionRequired).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserDepartmentSelectionRequired))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserDepartmentSelectionRequired ? other : THROW_CCE();
  if (!equals(this.departments, tmp0_other_with_cast.departments))
    return false;
  if (!equals(this.selectDepartment, tmp0_other_with_cast.selectDepartment))
    return false;
  return true;
};
function BrowserHealthCheckRequired$Companion$from$o$slambda($answers, $punchFlowServiceResponse, resultContinuation) {
  this.ebn_1 = $answers;
  this.fbn_1 = $punchFlowServiceResponse;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserHealthCheckRequired$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserHealthCheckRequired$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserHealthCheckRequired$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          var tmp_0 = this;
          var this_0 = this.ebn_1;
          var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
          var destination = LinkedHashMap_init_$Create$(capacity);
          var inductionVariable = 0;
          var last = this_0.length;
          while (inductionVariable < last) {
            var element = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var pair = to(toLong(element.questionId), toLong(element.responseId));
            destination.h2(pair.kf_1, pair.lf_1);
          }

          tmp_0.hbn_1 = destination;
          this.n8_1 = 1;
          suspendResult = this.fbn_1.nb8_1(this.hbn_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_1 = this.q8_1;
          if (tmp_1 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserHealthCheckRequired$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserHealthCheckRequired$Companion$from$o$slambda(this.ebn_1, this.fbn_1, completion);
  i.gbn_1 = $this$promise;
  return i;
};
function BrowserHealthCheckRequired$Companion$from$o$slambda_0($answers, $punchFlowServiceResponse, resultContinuation) {
  var i = new BrowserHealthCheckRequired$Companion$from$o$slambda($answers, $punchFlowServiceResponse, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserHealthCheckRequired$Companion$from$o($punchFlowServiceResponse) {
  return function (answers) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserHealthCheckRequired$Companion$from$o$slambda_0(answers, $punchFlowServiceResponse, null));
  };
}
function Companion_16() {
}
protoOf(Companion_16).rbj = function (punchFlowServiceResponse) {
  var submit = BrowserHealthCheckRequired$Companion$from$o(punchFlowServiceResponse);
  // Inline function 'kotlin.collections.map' call
  var this_0 = punchFlowServiceResponse.mb8_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = Companion_instance_21.ibn(item);
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(destination);
  return new BrowserHealthCheckRequired(tmp$ret$3, submit);
};
var Companion_instance_20;
function Companion_getInstance_18() {
  return Companion_instance_20;
}
function BrowserHealthCheckRequired(questionnaires, submitResponses) {
  this.questionnaires = questionnaires;
  this.submitResponses = submitResponses;
}
protoOf(BrowserHealthCheckRequired).jbn = function () {
  return this.questionnaires;
};
protoOf(BrowserHealthCheckRequired).kbn = function () {
  return this.submitResponses;
};
protoOf(BrowserHealthCheckRequired).mf = function () {
  return this.questionnaires;
};
protoOf(BrowserHealthCheckRequired).nf = function () {
  return this.submitResponses;
};
protoOf(BrowserHealthCheckRequired).lbn = function (questionnaires, submitResponses) {
  return new BrowserHealthCheckRequired(questionnaires, submitResponses);
};
protoOf(BrowserHealthCheckRequired).copy = function (questionnaires, submitResponses, $super) {
  questionnaires = questionnaires === VOID ? this.questionnaires : questionnaires;
  submitResponses = submitResponses === VOID ? this.submitResponses : submitResponses;
  return $super === VOID ? this.lbn(questionnaires, submitResponses) : $super.lbn.call(this, questionnaires, submitResponses);
};
protoOf(BrowserHealthCheckRequired).toString = function () {
  return 'BrowserHealthCheckRequired(questionnaires=' + toString(this.questionnaires) + ', submitResponses=' + toString(this.submitResponses) + ')';
};
protoOf(BrowserHealthCheckRequired).hashCode = function () {
  var result = hashCode(this.questionnaires);
  result = imul(result, 31) + hashCode(this.submitResponses) | 0;
  return result;
};
protoOf(BrowserHealthCheckRequired).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserHealthCheckRequired))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserHealthCheckRequired ? other : THROW_CCE();
  if (!equals(this.questionnaires, tmp0_other_with_cast.questionnaires))
    return false;
  if (!equals(this.submitResponses, tmp0_other_with_cast.submitResponses))
    return false;
  return true;
};
function Companion_17() {
}
protoOf(Companion_17).ibn = function (questionnaire) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = questionnaire.w9m_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = Companion_instance_22.mbn(item);
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(destination);
  return new BrowserHealthCheckQuestionnaire(questionnaire.t9m_1, questionnaire.u9m_1, questionnaire.v9m_1, tmp$ret$3);
};
var Companion_instance_21;
function Companion_getInstance_19() {
  return Companion_instance_21;
}
function BrowserHealthCheckQuestionnaire(language, title, buttonText, questions) {
  this.language = language;
  this.title = title;
  this.buttonText = buttonText;
  this.questions = questions;
}
protoOf(BrowserHealthCheckQuestionnaire).ubl = function () {
  return this.language;
};
protoOf(BrowserHealthCheckQuestionnaire).nbn = function () {
  return this.title;
};
protoOf(BrowserHealthCheckQuestionnaire).xbl = function () {
  return this.buttonText;
};
protoOf(BrowserHealthCheckQuestionnaire).obn = function () {
  return this.questions;
};
protoOf(BrowserHealthCheckQuestionnaire).mf = function () {
  return this.language;
};
protoOf(BrowserHealthCheckQuestionnaire).nf = function () {
  return this.title;
};
protoOf(BrowserHealthCheckQuestionnaire).ibk = function () {
  return this.buttonText;
};
protoOf(BrowserHealthCheckQuestionnaire).jbk = function () {
  return this.questions;
};
protoOf(BrowserHealthCheckQuestionnaire).pbn = function (language, title, buttonText, questions) {
  return new BrowserHealthCheckQuestionnaire(language, title, buttonText, questions);
};
protoOf(BrowserHealthCheckQuestionnaire).copy = function (language, title, buttonText, questions, $super) {
  language = language === VOID ? this.language : language;
  title = title === VOID ? this.title : title;
  buttonText = buttonText === VOID ? this.buttonText : buttonText;
  questions = questions === VOID ? this.questions : questions;
  return $super === VOID ? this.pbn(language, title, buttonText, questions) : $super.pbn.call(this, language, title, buttonText, questions);
};
protoOf(BrowserHealthCheckQuestionnaire).toString = function () {
  return 'BrowserHealthCheckQuestionnaire(language=' + this.language + ', title=' + this.title + ', buttonText=' + this.buttonText + ', questions=' + toString(this.questions) + ')';
};
protoOf(BrowserHealthCheckQuestionnaire).hashCode = function () {
  var result = getStringHashCode(this.language);
  result = imul(result, 31) + getStringHashCode(this.title) | 0;
  result = imul(result, 31) + getStringHashCode(this.buttonText) | 0;
  result = imul(result, 31) + hashCode(this.questions) | 0;
  return result;
};
protoOf(BrowserHealthCheckQuestionnaire).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserHealthCheckQuestionnaire))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserHealthCheckQuestionnaire ? other : THROW_CCE();
  if (!(this.language === tmp0_other_with_cast.language))
    return false;
  if (!(this.title === tmp0_other_with_cast.title))
    return false;
  if (!(this.buttonText === tmp0_other_with_cast.buttonText))
    return false;
  if (!equals(this.questions, tmp0_other_with_cast.questions))
    return false;
  return true;
};
function Companion_18() {
}
protoOf(Companion_18).mbn = function (question) {
  var tmp = question.o9m_1.d1();
  // Inline function 'kotlin.collections.map' call
  var this_0 = question.q9m_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = Companion_instance_23.qbn(item);
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(destination);
  return new BrowserHealthCheckQuestion(tmp, question.p9m_1, tmp$ret$3);
};
var Companion_instance_22;
function Companion_getInstance_20() {
  return Companion_instance_22;
}
function BrowserHealthCheckQuestion(id, text, responses) {
  this.id = id;
  this.text = text;
  this.responses = responses;
}
protoOf(BrowserHealthCheckQuestion).f2t = function () {
  return this.id;
};
protoOf(BrowserHealthCheckQuestion).abm = function () {
  return this.text;
};
protoOf(BrowserHealthCheckQuestion).ybl = function () {
  return this.responses;
};
protoOf(BrowserHealthCheckQuestion).mf = function () {
  return this.id;
};
protoOf(BrowserHealthCheckQuestion).nf = function () {
  return this.text;
};
protoOf(BrowserHealthCheckQuestion).ibk = function () {
  return this.responses;
};
protoOf(BrowserHealthCheckQuestion).rbn = function (id, text, responses) {
  return new BrowserHealthCheckQuestion(id, text, responses);
};
protoOf(BrowserHealthCheckQuestion).copy = function (id, text, responses, $super) {
  id = id === VOID ? this.id : id;
  text = text === VOID ? this.text : text;
  responses = responses === VOID ? this.responses : responses;
  return $super === VOID ? this.rbn(id, text, responses) : $super.rbn.call(this, id, text, responses);
};
protoOf(BrowserHealthCheckQuestion).toString = function () {
  return 'BrowserHealthCheckQuestion(id=' + this.id + ', text=' + this.text + ', responses=' + toString(this.responses) + ')';
};
protoOf(BrowserHealthCheckQuestion).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + getStringHashCode(this.text) | 0;
  result = imul(result, 31) + hashCode(this.responses) | 0;
  return result;
};
protoOf(BrowserHealthCheckQuestion).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserHealthCheckQuestion))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserHealthCheckQuestion ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.text === tmp0_other_with_cast.text))
    return false;
  if (!equals(this.responses, tmp0_other_with_cast.responses))
    return false;
  return true;
};
function Companion_19() {
}
protoOf(Companion_19).qbn = function (response) {
  return new BrowserHealthCheckResponse(response.r9m_1.d1(), response.s9m_1);
};
var Companion_instance_23;
function Companion_getInstance_21() {
  return Companion_instance_23;
}
function BrowserHealthCheckResponse(id, text) {
  this.id = id;
  this.text = text;
}
protoOf(BrowserHealthCheckResponse).f2t = function () {
  return this.id;
};
protoOf(BrowserHealthCheckResponse).abm = function () {
  return this.text;
};
protoOf(BrowserHealthCheckResponse).mf = function () {
  return this.id;
};
protoOf(BrowserHealthCheckResponse).nf = function () {
  return this.text;
};
protoOf(BrowserHealthCheckResponse).bbm = function (id, text) {
  return new BrowserHealthCheckResponse(id, text);
};
protoOf(BrowserHealthCheckResponse).copy = function (id, text, $super) {
  id = id === VOID ? this.id : id;
  text = text === VOID ? this.text : text;
  return $super === VOID ? this.bbm(id, text) : $super.bbm.call(this, id, text);
};
protoOf(BrowserHealthCheckResponse).toString = function () {
  return 'BrowserHealthCheckResponse(id=' + this.id + ', text=' + this.text + ')';
};
protoOf(BrowserHealthCheckResponse).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + getStringHashCode(this.text) | 0;
  return result;
};
protoOf(BrowserHealthCheckResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserHealthCheckResponse))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserHealthCheckResponse ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.text === tmp0_other_with_cast.text))
    return false;
  return true;
};
function BrowserHealthCheckAnswer(questionId, responseId) {
  this.questionId = questionId;
  this.responseId = responseId;
}
protoOf(BrowserHealthCheckAnswer).sbn = function () {
  return this.questionId;
};
protoOf(BrowserHealthCheckAnswer).tbn = function () {
  return this.responseId;
};
protoOf(BrowserHealthCheckAnswer).mf = function () {
  return this.questionId;
};
protoOf(BrowserHealthCheckAnswer).nf = function () {
  return this.responseId;
};
protoOf(BrowserHealthCheckAnswer).ubn = function (questionId, responseId) {
  return new BrowserHealthCheckAnswer(questionId, responseId);
};
protoOf(BrowserHealthCheckAnswer).copy = function (questionId, responseId, $super) {
  questionId = questionId === VOID ? this.questionId : questionId;
  responseId = responseId === VOID ? this.responseId : responseId;
  return $super === VOID ? this.ubn(questionId, responseId) : $super.ubn.call(this, questionId, responseId);
};
protoOf(BrowserHealthCheckAnswer).toString = function () {
  return 'BrowserHealthCheckAnswer(questionId=' + this.questionId + ', responseId=' + this.responseId + ')';
};
protoOf(BrowserHealthCheckAnswer).hashCode = function () {
  var result = this.questionId;
  result = imul(result, 31) + this.responseId | 0;
  return result;
};
protoOf(BrowserHealthCheckAnswer).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserHealthCheckAnswer))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserHealthCheckAnswer ? other : THROW_CCE();
  if (!(this.questionId === tmp0_other_with_cast.questionId))
    return false;
  if (!(this.responseId === tmp0_other_with_cast.responseId))
    return false;
  return true;
};
function BrowserRoleSelectionRequired$Companion$from$o$slambda($punchFlowServiceResponse, $roleId, resultContinuation) {
  this.dbo_1 = $punchFlowServiceResponse;
  this.ebo_1 = $roleId;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserRoleSelectionRequired$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserRoleSelectionRequired$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserRoleSelectionRequired$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.dbo_1.qb8_1(toLong(this.ebo_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserRoleSelectionRequired$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserRoleSelectionRequired$Companion$from$o$slambda(this.dbo_1, this.ebo_1, completion);
  i.fbo_1 = $this$promise;
  return i;
};
function BrowserRoleSelectionRequired$Companion$from$o$slambda_0($punchFlowServiceResponse, $roleId, resultContinuation) {
  var i = new BrowserRoleSelectionRequired$Companion$from$o$slambda($punchFlowServiceResponse, $roleId, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserRoleSelectionRequired$Companion$from$o($punchFlowServiceResponse) {
  return function (roleId) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserRoleSelectionRequired$Companion$from$o$slambda_0($punchFlowServiceResponse, roleId, null));
  };
}
function Companion_20() {
}
protoOf(Companion_20).qbj = function (punchFlowServiceResponse) {
  var select = BrowserRoleSelectionRequired$Companion$from$o(punchFlowServiceResponse);
  // Inline function 'kotlin.collections.map' call
  var this_0 = punchFlowServiceResponse.pb8_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = Companion_instance_17.cbm(item);
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(destination);
  return new BrowserRoleSelectionRequired(tmp$ret$3, select);
};
var Companion_instance_24;
function Companion_getInstance_22() {
  return Companion_instance_24;
}
function BrowserRoleSelectionRequired(roles, selectRole) {
  this.roles = roles;
  this.selectRole = selectRole;
}
protoOf(BrowserRoleSelectionRequired).gbo = function () {
  return this.roles;
};
protoOf(BrowserRoleSelectionRequired).hbo = function () {
  return this.selectRole;
};
protoOf(BrowserRoleSelectionRequired).mf = function () {
  return this.roles;
};
protoOf(BrowserRoleSelectionRequired).nf = function () {
  return this.selectRole;
};
protoOf(BrowserRoleSelectionRequired).ibo = function (roles, selectRole) {
  return new BrowserRoleSelectionRequired(roles, selectRole);
};
protoOf(BrowserRoleSelectionRequired).copy = function (roles, selectRole, $super) {
  roles = roles === VOID ? this.roles : roles;
  selectRole = selectRole === VOID ? this.selectRole : selectRole;
  return $super === VOID ? this.ibo(roles, selectRole) : $super.ibo.call(this, roles, selectRole);
};
protoOf(BrowserRoleSelectionRequired).toString = function () {
  return 'BrowserRoleSelectionRequired(roles=' + toString(this.roles) + ', selectRole=' + toString(this.selectRole) + ')';
};
protoOf(BrowserRoleSelectionRequired).hashCode = function () {
  var result = hashCode(this.roles);
  result = imul(result, 31) + hashCode(this.selectRole) | 0;
  return result;
};
protoOf(BrowserRoleSelectionRequired).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserRoleSelectionRequired))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserRoleSelectionRequired ? other : THROW_CCE();
  if (!equals(this.roles, tmp0_other_with_cast.roles))
    return false;
  if (!equals(this.selectRole, tmp0_other_with_cast.selectRole))
    return false;
  return true;
};
function sendTips($this, tips, punchFlowServiceResponse, $completion) {
  var tmp = new $sendTipsCOROUTINE$6($this, tips, punchFlowServiceResponse, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function TipsNeeded$Companion$from$o$slambda($tips, $punchFlowServiceResponse, resultContinuation) {
  this.cbp_1 = $tips;
  this.dbp_1 = $punchFlowServiceResponse;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(TipsNeeded$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(TipsNeeded$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(TipsNeeded$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = sendTips(Companion_instance_25, this.cbp_1, this.dbp_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(TipsNeeded$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new TipsNeeded$Companion$from$o$slambda(this.cbp_1, this.dbp_1, completion);
  i.ebp_1 = $this$promise;
  return i;
};
function TipsNeeded$Companion$from$o$slambda_0($tips, $punchFlowServiceResponse, resultContinuation) {
  var i = new TipsNeeded$Companion$from$o$slambda($tips, $punchFlowServiceResponse, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function TipsNeeded$Companion$from$o($punchFlowServiceResponse) {
  return function (tips) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, TipsNeeded$Companion$from$o$slambda_0(tips, $punchFlowServiceResponse, null));
  };
}
function $sendTipsCOROUTINE$6(_this__u8e3s4, tips, punchFlowServiceResponse, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.rbo_1 = _this__u8e3s4;
  this.sbo_1 = tips;
  this.tbo_1 = punchFlowServiceResponse;
}
protoOf($sendTipsCOROUTINE$6).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.tbo_1.ob8_1(this.sbo_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          this.o8_1 = 2;
          var response = result.y2t();
          return Companion_getInstance_3().wbi(response);
        case 2:
          this.o8_1 = 3;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function Companion_21() {
}
protoOf(Companion_21).zbj = function (punchFlowServiceResponse) {
  var sendTips = TipsNeeded$Companion$from$o(punchFlowServiceResponse);
  return new TipsNeeded_0(sendTips);
};
var Companion_instance_25;
function Companion_getInstance_23() {
  return Companion_instance_25;
}
function TipsNeeded_0(sendTips) {
  this.sendTips = sendTips;
}
protoOf(TipsNeeded_0).fbp = function () {
  return this.sendTips;
};
protoOf(TipsNeeded_0).mf = function () {
  return this.sendTips;
};
protoOf(TipsNeeded_0).gbp = function (sendTips) {
  return new TipsNeeded_0(sendTips);
};
protoOf(TipsNeeded_0).copy = function (sendTips, $super) {
  sendTips = sendTips === VOID ? this.sendTips : sendTips;
  return $super === VOID ? this.gbp(sendTips) : $super.gbp.call(this, sendTips);
};
protoOf(TipsNeeded_0).toString = function () {
  return 'TipsNeeded(sendTips=' + toString(this.sendTips) + ')';
};
protoOf(TipsNeeded_0).hashCode = function () {
  return hashCode(this.sendTips);
};
protoOf(TipsNeeded_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TipsNeeded_0))
    return false;
  var tmp0_other_with_cast = other instanceof TipsNeeded_0 ? other : THROW_CCE();
  if (!equals(this.sendTips, tmp0_other_with_cast.sendTips))
    return false;
  return true;
};
function AvailableActionMapper() {
}
protoOf(AvailableActionMapper).hbp = function (actions) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(actions, 10));
  var _iterator__ex2g4s = actions.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp;
    if (item instanceof StartShift) {
      tmp = Companion_instance_26.obp(item);
    } else {
      if (item instanceof StartUnscheduledShift) {
        tmp = Companion_instance_27.nbp(item);
      } else {
        if (item instanceof ClockOut) {
          tmp = Companion_instance_28.mbp(item);
        } else {
          if (item instanceof StartPaidBreak) {
            tmp = Companion_instance_29.lbp(item);
          } else {
            if (item instanceof StartUnpaidBreak) {
              tmp = Companion_instance_30.kbp(item);
            } else {
              if (item instanceof StartCustomBreak) {
                tmp = Companion_instance_31.jbp(item);
              } else {
                if (item instanceof EndBreak) {
                  tmp = Companion_instance_32.ibp(item);
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
      }
    }
    var tmp$ret$0 = tmp;
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
};
var AvailableActionMapper_instance;
function AvailableActionMapper_getInstance() {
  return AvailableActionMapper_instance;
}
function BrowserStartShiftAction$Companion$from$o$slambda($action, resultContinuation) {
  this.xbp_1 = $action;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserStartShiftAction$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserStartShiftAction$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserStartShiftAction$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.xbp_1.vb2(null, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserStartShiftAction$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserStartShiftAction$Companion$from$o$slambda(this.xbp_1, completion);
  i.ybp_1 = $this$promise;
  return i;
};
function BrowserStartShiftAction$Companion$from$o$slambda_0($action, resultContinuation) {
  var i = new BrowserStartShiftAction$Companion$from$o$slambda($action, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserStartShiftAction$Companion$from$o($action) {
  return function () {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserStartShiftAction$Companion$from$o$slambda_0($action, null));
  };
}
function BrowserStartShiftAction$Companion$from$o$slambda_1($action, $roleId, resultContinuation) {
  this.hbq_1 = $action;
  this.ibq_1 = $roleId;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserStartShiftAction$Companion$from$o$slambda_1).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserStartShiftAction$Companion$from$o$slambda_1).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserStartShiftAction$Companion$from$o$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.hbq_1.vb2(toLong(this.ibq_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserStartShiftAction$Companion$from$o$slambda_1).s3m = function ($this$promise, completion) {
  var i = new BrowserStartShiftAction$Companion$from$o$slambda_1(this.hbq_1, this.ibq_1, completion);
  i.jbq_1 = $this$promise;
  return i;
};
function BrowserStartShiftAction$Companion$from$o$slambda_2($action, $roleId, resultContinuation) {
  var i = new BrowserStartShiftAction$Companion$from$o$slambda_1($action, $roleId, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserStartShiftAction$Companion$from$o_0($action) {
  return function (roleId) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserStartShiftAction$Companion$from$o$slambda_2($action, roleId, null));
  };
}
function Companion_22() {
}
protoOf(Companion_22).obp = function (action) {
  var invoke = BrowserStartShiftAction$Companion$from$o(action);
  var invokeWithRole = BrowserStartShiftAction$Companion$from$o_0(action);
  return new BrowserStartShiftAction(VOID, invoke, invokeWithRole);
};
var Companion_instance_26;
function Companion_getInstance_24() {
  return Companion_instance_26;
}
function BrowserStartShiftAction(type, invoke, invokeWithRole) {
  type = type === VOID ? 'start_shift' : type;
  this.kbq_1 = type;
  this.invoke = invoke;
  this.invokeWithRole = invokeWithRole;
}
protoOf(BrowserStartShiftAction).lbq = function () {
  return this.kbq_1;
};
protoOf(BrowserStartShiftAction).mbq = function () {
  return this.invoke;
};
protoOf(BrowserStartShiftAction).nbq = function () {
  return this.invokeWithRole;
};
protoOf(BrowserStartShiftAction).mf = function () {
  return this.kbq_1;
};
protoOf(BrowserStartShiftAction).nf = function () {
  return this.invoke;
};
protoOf(BrowserStartShiftAction).ibk = function () {
  return this.invokeWithRole;
};
protoOf(BrowserStartShiftAction).obq = function (type, invoke, invokeWithRole) {
  return new BrowserStartShiftAction(type, invoke, invokeWithRole);
};
protoOf(BrowserStartShiftAction).copy = function (type, invoke, invokeWithRole, $super) {
  type = type === VOID ? this.kbq_1 : type;
  invoke = invoke === VOID ? this.invoke : invoke;
  invokeWithRole = invokeWithRole === VOID ? this.invokeWithRole : invokeWithRole;
  return $super === VOID ? this.obq(type, invoke, invokeWithRole) : $super.obq.call(this, type, invoke, invokeWithRole);
};
protoOf(BrowserStartShiftAction).toString = function () {
  return 'BrowserStartShiftAction(type=' + this.kbq_1 + ', invoke=' + toString(this.invoke) + ', invokeWithRole=' + toString(this.invokeWithRole) + ')';
};
protoOf(BrowserStartShiftAction).hashCode = function () {
  var result = getStringHashCode(this.kbq_1);
  result = imul(result, 31) + hashCode(this.invoke) | 0;
  result = imul(result, 31) + hashCode(this.invokeWithRole) | 0;
  return result;
};
protoOf(BrowserStartShiftAction).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserStartShiftAction))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserStartShiftAction ? other : THROW_CCE();
  if (!(this.kbq_1 === tmp0_other_with_cast.kbq_1))
    return false;
  if (!equals(this.invoke, tmp0_other_with_cast.invoke))
    return false;
  if (!equals(this.invokeWithRole, tmp0_other_with_cast.invokeWithRole))
    return false;
  return true;
};
function BrowserStartUnscheduledShiftAction$Companion$from$o$slambda($action, resultContinuation) {
  this.xbq_1 = $action;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserStartUnscheduledShiftAction$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserStartUnscheduledShiftAction$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserStartUnscheduledShiftAction$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.xbq_1.ub3(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserStartUnscheduledShiftAction$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserStartUnscheduledShiftAction$Companion$from$o$slambda(this.xbq_1, completion);
  i.ybq_1 = $this$promise;
  return i;
};
function BrowserStartUnscheduledShiftAction$Companion$from$o$slambda_0($action, resultContinuation) {
  var i = new BrowserStartUnscheduledShiftAction$Companion$from$o$slambda($action, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserStartUnscheduledShiftAction$Companion$from$o($action) {
  return function () {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserStartUnscheduledShiftAction$Companion$from$o$slambda_0($action, null));
  };
}
function Companion_23() {
}
protoOf(Companion_23).nbp = function (action) {
  var invoke = BrowserStartUnscheduledShiftAction$Companion$from$o(action);
  return new BrowserStartUnscheduledShiftAction(VOID, invoke);
};
var Companion_instance_27;
function Companion_getInstance_25() {
  return Companion_instance_27;
}
function BrowserStartUnscheduledShiftAction(type, invoke) {
  type = type === VOID ? 'start_unscheduled_shift' : type;
  this.zbq_1 = type;
  this.invoke = invoke;
}
protoOf(BrowserStartUnscheduledShiftAction).lbq = function () {
  return this.zbq_1;
};
protoOf(BrowserStartUnscheduledShiftAction).mbq = function () {
  return this.invoke;
};
protoOf(BrowserStartUnscheduledShiftAction).mf = function () {
  return this.zbq_1;
};
protoOf(BrowserStartUnscheduledShiftAction).nf = function () {
  return this.invoke;
};
protoOf(BrowserStartUnscheduledShiftAction).abr = function (type, invoke) {
  return new BrowserStartUnscheduledShiftAction(type, invoke);
};
protoOf(BrowserStartUnscheduledShiftAction).copy = function (type, invoke, $super) {
  type = type === VOID ? this.zbq_1 : type;
  invoke = invoke === VOID ? this.invoke : invoke;
  return $super === VOID ? this.abr(type, invoke) : $super.abr.call(this, type, invoke);
};
protoOf(BrowserStartUnscheduledShiftAction).toString = function () {
  return 'BrowserStartUnscheduledShiftAction(type=' + this.zbq_1 + ', invoke=' + toString(this.invoke) + ')';
};
protoOf(BrowserStartUnscheduledShiftAction).hashCode = function () {
  var result = getStringHashCode(this.zbq_1);
  result = imul(result, 31) + hashCode(this.invoke) | 0;
  return result;
};
protoOf(BrowserStartUnscheduledShiftAction).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserStartUnscheduledShiftAction))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserStartUnscheduledShiftAction ? other : THROW_CCE();
  if (!(this.zbq_1 === tmp0_other_with_cast.zbq_1))
    return false;
  if (!equals(this.invoke, tmp0_other_with_cast.invoke))
    return false;
  return true;
};
function BrowserClockOutAction$Companion$from$o$slambda($action, resultContinuation) {
  this.jbr_1 = $action;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserClockOutAction$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserClockOutAction$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserClockOutAction$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.jbr_1.ub3(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserClockOutAction$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserClockOutAction$Companion$from$o$slambda(this.jbr_1, completion);
  i.kbr_1 = $this$promise;
  return i;
};
function BrowserClockOutAction$Companion$from$o$slambda_0($action, resultContinuation) {
  var i = new BrowserClockOutAction$Companion$from$o$slambda($action, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserClockOutAction$Companion$from$o($action) {
  return function () {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserClockOutAction$Companion$from$o$slambda_0($action, null));
  };
}
function Companion_24() {
}
protoOf(Companion_24).mbp = function (action) {
  var invoke = BrowserClockOutAction$Companion$from$o(action);
  return new BrowserClockOutAction(VOID, invoke);
};
var Companion_instance_28;
function Companion_getInstance_26() {
  return Companion_instance_28;
}
function BrowserClockOutAction(type, invoke) {
  type = type === VOID ? 'clock_out' : type;
  this.lbr_1 = type;
  this.invoke = invoke;
}
protoOf(BrowserClockOutAction).lbq = function () {
  return this.lbr_1;
};
protoOf(BrowserClockOutAction).mbq = function () {
  return this.invoke;
};
protoOf(BrowserClockOutAction).mf = function () {
  return this.lbr_1;
};
protoOf(BrowserClockOutAction).nf = function () {
  return this.invoke;
};
protoOf(BrowserClockOutAction).abr = function (type, invoke) {
  return new BrowserClockOutAction(type, invoke);
};
protoOf(BrowserClockOutAction).copy = function (type, invoke, $super) {
  type = type === VOID ? this.lbr_1 : type;
  invoke = invoke === VOID ? this.invoke : invoke;
  return $super === VOID ? this.abr(type, invoke) : $super.abr.call(this, type, invoke);
};
protoOf(BrowserClockOutAction).toString = function () {
  return 'BrowserClockOutAction(type=' + this.lbr_1 + ', invoke=' + toString(this.invoke) + ')';
};
protoOf(BrowserClockOutAction).hashCode = function () {
  var result = getStringHashCode(this.lbr_1);
  result = imul(result, 31) + hashCode(this.invoke) | 0;
  return result;
};
protoOf(BrowserClockOutAction).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserClockOutAction))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserClockOutAction ? other : THROW_CCE();
  if (!(this.lbr_1 === tmp0_other_with_cast.lbr_1))
    return false;
  if (!equals(this.invoke, tmp0_other_with_cast.invoke))
    return false;
  return true;
};
function BrowserStartPaidBreakAction$Companion$from$o$slambda($action, resultContinuation) {
  this.ubr_1 = $action;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserStartPaidBreakAction$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserStartPaidBreakAction$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserStartPaidBreakAction$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.ubr_1.ub3(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserStartPaidBreakAction$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserStartPaidBreakAction$Companion$from$o$slambda(this.ubr_1, completion);
  i.vbr_1 = $this$promise;
  return i;
};
function BrowserStartPaidBreakAction$Companion$from$o$slambda_0($action, resultContinuation) {
  var i = new BrowserStartPaidBreakAction$Companion$from$o$slambda($action, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserStartPaidBreakAction$Companion$from$o($action) {
  return function () {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserStartPaidBreakAction$Companion$from$o$slambda_0($action, null));
  };
}
function Companion_25() {
}
protoOf(Companion_25).lbp = function (action) {
  var invoke = BrowserStartPaidBreakAction$Companion$from$o(action);
  return new BrowserStartPaidBreakAction(VOID, invoke);
};
var Companion_instance_29;
function Companion_getInstance_27() {
  return Companion_instance_29;
}
function BrowserStartPaidBreakAction(type, invoke) {
  type = type === VOID ? 'start_paid_break' : type;
  this.wbr_1 = type;
  this.invoke = invoke;
}
protoOf(BrowserStartPaidBreakAction).lbq = function () {
  return this.wbr_1;
};
protoOf(BrowserStartPaidBreakAction).mbq = function () {
  return this.invoke;
};
protoOf(BrowserStartPaidBreakAction).mf = function () {
  return this.wbr_1;
};
protoOf(BrowserStartPaidBreakAction).nf = function () {
  return this.invoke;
};
protoOf(BrowserStartPaidBreakAction).abr = function (type, invoke) {
  return new BrowserStartPaidBreakAction(type, invoke);
};
protoOf(BrowserStartPaidBreakAction).copy = function (type, invoke, $super) {
  type = type === VOID ? this.wbr_1 : type;
  invoke = invoke === VOID ? this.invoke : invoke;
  return $super === VOID ? this.abr(type, invoke) : $super.abr.call(this, type, invoke);
};
protoOf(BrowserStartPaidBreakAction).toString = function () {
  return 'BrowserStartPaidBreakAction(type=' + this.wbr_1 + ', invoke=' + toString(this.invoke) + ')';
};
protoOf(BrowserStartPaidBreakAction).hashCode = function () {
  var result = getStringHashCode(this.wbr_1);
  result = imul(result, 31) + hashCode(this.invoke) | 0;
  return result;
};
protoOf(BrowserStartPaidBreakAction).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserStartPaidBreakAction))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserStartPaidBreakAction ? other : THROW_CCE();
  if (!(this.wbr_1 === tmp0_other_with_cast.wbr_1))
    return false;
  if (!equals(this.invoke, tmp0_other_with_cast.invoke))
    return false;
  return true;
};
function BrowserStartUnpaidBreakAction$Companion$from$o$slambda($action, resultContinuation) {
  this.fbs_1 = $action;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserStartUnpaidBreakAction$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserStartUnpaidBreakAction$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserStartUnpaidBreakAction$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.fbs_1.ub3(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserStartUnpaidBreakAction$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserStartUnpaidBreakAction$Companion$from$o$slambda(this.fbs_1, completion);
  i.gbs_1 = $this$promise;
  return i;
};
function BrowserStartUnpaidBreakAction$Companion$from$o$slambda_0($action, resultContinuation) {
  var i = new BrowserStartUnpaidBreakAction$Companion$from$o$slambda($action, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserStartUnpaidBreakAction$Companion$from$o($action) {
  return function () {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserStartUnpaidBreakAction$Companion$from$o$slambda_0($action, null));
  };
}
function Companion_26() {
}
protoOf(Companion_26).kbp = function (action) {
  var invoke = BrowserStartUnpaidBreakAction$Companion$from$o(action);
  return new BrowserStartUnpaidBreakAction(VOID, invoke);
};
var Companion_instance_30;
function Companion_getInstance_28() {
  return Companion_instance_30;
}
function BrowserStartUnpaidBreakAction(type, invoke) {
  type = type === VOID ? 'start_unpaid_break' : type;
  this.hbs_1 = type;
  this.invoke = invoke;
}
protoOf(BrowserStartUnpaidBreakAction).lbq = function () {
  return this.hbs_1;
};
protoOf(BrowserStartUnpaidBreakAction).mbq = function () {
  return this.invoke;
};
protoOf(BrowserStartUnpaidBreakAction).mf = function () {
  return this.hbs_1;
};
protoOf(BrowserStartUnpaidBreakAction).nf = function () {
  return this.invoke;
};
protoOf(BrowserStartUnpaidBreakAction).abr = function (type, invoke) {
  return new BrowserStartUnpaidBreakAction(type, invoke);
};
protoOf(BrowserStartUnpaidBreakAction).copy = function (type, invoke, $super) {
  type = type === VOID ? this.hbs_1 : type;
  invoke = invoke === VOID ? this.invoke : invoke;
  return $super === VOID ? this.abr(type, invoke) : $super.abr.call(this, type, invoke);
};
protoOf(BrowserStartUnpaidBreakAction).toString = function () {
  return 'BrowserStartUnpaidBreakAction(type=' + this.hbs_1 + ', invoke=' + toString(this.invoke) + ')';
};
protoOf(BrowserStartUnpaidBreakAction).hashCode = function () {
  var result = getStringHashCode(this.hbs_1);
  result = imul(result, 31) + hashCode(this.invoke) | 0;
  return result;
};
protoOf(BrowserStartUnpaidBreakAction).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserStartUnpaidBreakAction))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserStartUnpaidBreakAction ? other : THROW_CCE();
  if (!(this.hbs_1 === tmp0_other_with_cast.hbs_1))
    return false;
  if (!equals(this.invoke, tmp0_other_with_cast.invoke))
    return false;
  return true;
};
function BrowserStartCustomBreakAction$Companion$from$o$slambda($action, $customBreakId, resultContinuation) {
  this.qbs_1 = $action;
  this.rbs_1 = $customBreakId;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserStartCustomBreakAction$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserStartCustomBreakAction$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserStartCustomBreakAction$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.qbs_1.kb7(toLong(this.rbs_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserStartCustomBreakAction$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserStartCustomBreakAction$Companion$from$o$slambda(this.qbs_1, this.rbs_1, completion);
  i.sbs_1 = $this$promise;
  return i;
};
function BrowserStartCustomBreakAction$Companion$from$o$slambda_0($action, $customBreakId, resultContinuation) {
  var i = new BrowserStartCustomBreakAction$Companion$from$o$slambda($action, $customBreakId, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserStartCustomBreakAction$Companion$from$o($action) {
  return function (customBreakId) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserStartCustomBreakAction$Companion$from$o$slambda_0($action, customBreakId, null));
  };
}
function Companion_27() {
}
protoOf(Companion_27).jbp = function (action) {
  var invoke = BrowserStartCustomBreakAction$Companion$from$o(action);
  // Inline function 'kotlin.collections.map' call
  var this_0 = action.vb9_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = Companion_instance_36.tbs(item);
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(destination);
  return new BrowserStartCustomBreakAction(VOID, tmp$ret$3, invoke);
};
var Companion_instance_31;
function Companion_getInstance_29() {
  return Companion_instance_31;
}
function BrowserStartCustomBreakAction(type, customBreaks, invoke) {
  type = type === VOID ? 'start_custom_break' : type;
  this.ubs_1 = type;
  this.customBreaks = customBreaks;
  this.invoke = invoke;
}
protoOf(BrowserStartCustomBreakAction).lbq = function () {
  return this.ubs_1;
};
protoOf(BrowserStartCustomBreakAction).vbs = function () {
  return this.customBreaks;
};
protoOf(BrowserStartCustomBreakAction).mbq = function () {
  return this.invoke;
};
protoOf(BrowserStartCustomBreakAction).mf = function () {
  return this.ubs_1;
};
protoOf(BrowserStartCustomBreakAction).nf = function () {
  return this.customBreaks;
};
protoOf(BrowserStartCustomBreakAction).ibk = function () {
  return this.invoke;
};
protoOf(BrowserStartCustomBreakAction).wbs = function (type, customBreaks, invoke) {
  return new BrowserStartCustomBreakAction(type, customBreaks, invoke);
};
protoOf(BrowserStartCustomBreakAction).copy = function (type, customBreaks, invoke, $super) {
  type = type === VOID ? this.ubs_1 : type;
  customBreaks = customBreaks === VOID ? this.customBreaks : customBreaks;
  invoke = invoke === VOID ? this.invoke : invoke;
  return $super === VOID ? this.wbs(type, customBreaks, invoke) : $super.wbs.call(this, type, customBreaks, invoke);
};
protoOf(BrowserStartCustomBreakAction).toString = function () {
  return 'BrowserStartCustomBreakAction(type=' + this.ubs_1 + ', customBreaks=' + toString(this.customBreaks) + ', invoke=' + toString(this.invoke) + ')';
};
protoOf(BrowserStartCustomBreakAction).hashCode = function () {
  var result = getStringHashCode(this.ubs_1);
  result = imul(result, 31) + hashCode(this.customBreaks) | 0;
  result = imul(result, 31) + hashCode(this.invoke) | 0;
  return result;
};
protoOf(BrowserStartCustomBreakAction).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserStartCustomBreakAction))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserStartCustomBreakAction ? other : THROW_CCE();
  if (!(this.ubs_1 === tmp0_other_with_cast.ubs_1))
    return false;
  if (!equals(this.customBreaks, tmp0_other_with_cast.customBreaks))
    return false;
  if (!equals(this.invoke, tmp0_other_with_cast.invoke))
    return false;
  return true;
};
function BrowserEndBreakAction$Companion$from$o$slambda($action, resultContinuation) {
  this.fbt_1 = $action;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BrowserEndBreakAction$Companion$from$o$slambda).tbi = function ($this$promise, $completion) {
  var tmp = this.s3m($this$promise, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(BrowserEndBreakAction$Companion$from$o$slambda).h9 = function (p1, $completion) {
  return this.tbi((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(BrowserEndBreakAction$Companion$from$o$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.fbt_1.ub3(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          var TRY_RESULT;
          this.o8_1 = 2;
          TRY_RESULT = Companion_getInstance_3().wbi(result.y2t());
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof SevenThrowable) {
            var exception = this.q8_1;
            throw exception;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          return TRY_RESULT;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(BrowserEndBreakAction$Companion$from$o$slambda).s3m = function ($this$promise, completion) {
  var i = new BrowserEndBreakAction$Companion$from$o$slambda(this.fbt_1, completion);
  i.gbt_1 = $this$promise;
  return i;
};
function BrowserEndBreakAction$Companion$from$o$slambda_0($action, resultContinuation) {
  var i = new BrowserEndBreakAction$Companion$from$o$slambda($action, resultContinuation);
  var l = function ($this$promise, $completion) {
    return i.tbi($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function BrowserEndBreakAction$Companion$from$o($action) {
  return function () {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, BrowserEndBreakAction$Companion$from$o$slambda_0($action, null));
  };
}
function Companion_28() {
}
protoOf(Companion_28).ibp = function (action) {
  var invoke = BrowserEndBreakAction$Companion$from$o(action);
  return new BrowserEndBreakAction(VOID, invoke);
};
var Companion_instance_32;
function Companion_getInstance_30() {
  return Companion_instance_32;
}
function BrowserEndBreakAction(type, invoke) {
  type = type === VOID ? 'end_break' : type;
  this.hbt_1 = type;
  this.invoke = invoke;
}
protoOf(BrowserEndBreakAction).lbq = function () {
  return this.hbt_1;
};
protoOf(BrowserEndBreakAction).mbq = function () {
  return this.invoke;
};
protoOf(BrowserEndBreakAction).mf = function () {
  return this.hbt_1;
};
protoOf(BrowserEndBreakAction).nf = function () {
  return this.invoke;
};
protoOf(BrowserEndBreakAction).abr = function (type, invoke) {
  return new BrowserEndBreakAction(type, invoke);
};
protoOf(BrowserEndBreakAction).copy = function (type, invoke, $super) {
  type = type === VOID ? this.hbt_1 : type;
  invoke = invoke === VOID ? this.invoke : invoke;
  return $super === VOID ? this.abr(type, invoke) : $super.abr.call(this, type, invoke);
};
protoOf(BrowserEndBreakAction).toString = function () {
  return 'BrowserEndBreakAction(type=' + this.hbt_1 + ', invoke=' + toString(this.invoke) + ')';
};
protoOf(BrowserEndBreakAction).hashCode = function () {
  var result = getStringHashCode(this.hbt_1);
  result = imul(result, 31) + hashCode(this.invoke) | 0;
  return result;
};
protoOf(BrowserEndBreakAction).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserEndBreakAction))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserEndBreakAction ? other : THROW_CCE();
  if (!(this.hbt_1 === tmp0_other_with_cast.hbt_1))
    return false;
  if (!equals(this.invoke, tmp0_other_with_cast.invoke))
    return false;
  return true;
};
function BrowserAvailableAction() {
}
function Companion_29() {
}
protoOf(Companion_29).ibt = function (breakInfo) {
  var tmp;
  if (breakInfo instanceof Regular) {
    tmp = new BrowserBreak('regular', breakInfo.mb9_1.toString(), null, null, null);
  } else {
    if (breakInfo instanceof Custom) {
      tmp = new BrowserBreak('custom', breakInfo.nb9_1.toString(), breakInfo.ob9_1.toString(), breakInfo.pb9_1.mb0_1, breakInfo.pb9_1.nb0_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
};
var Companion_instance_33;
function Companion_getInstance_31() {
  return Companion_instance_33;
}
function BrowserBreak(type, startTime, expectedEndBreakTime, customBreakName, customBreakMinLengthInMinutes) {
  this.type = type;
  this.startTime = startTime;
  this.expectedEndBreakTime = expectedEndBreakTime;
  this.customBreakName = customBreakName;
  this.customBreakMinLengthInMinutes = customBreakMinLengthInMinutes;
}
protoOf(BrowserBreak).lbq = function () {
  return this.type;
};
protoOf(BrowserBreak).jbt = function () {
  return this.startTime;
};
protoOf(BrowserBreak).kbt = function () {
  return this.expectedEndBreakTime;
};
protoOf(BrowserBreak).lbt = function () {
  return this.customBreakName;
};
protoOf(BrowserBreak).mbt = function () {
  return this.customBreakMinLengthInMinutes;
};
protoOf(BrowserBreak).mf = function () {
  return this.type;
};
protoOf(BrowserBreak).nf = function () {
  return this.startTime;
};
protoOf(BrowserBreak).ibk = function () {
  return this.expectedEndBreakTime;
};
protoOf(BrowserBreak).jbk = function () {
  return this.customBreakName;
};
protoOf(BrowserBreak).kbk = function () {
  return this.customBreakMinLengthInMinutes;
};
protoOf(BrowserBreak).nbt = function (type, startTime, expectedEndBreakTime, customBreakName, customBreakMinLengthInMinutes) {
  return new BrowserBreak(type, startTime, expectedEndBreakTime, customBreakName, customBreakMinLengthInMinutes);
};
protoOf(BrowserBreak).copy = function (type, startTime, expectedEndBreakTime, customBreakName, customBreakMinLengthInMinutes, $super) {
  type = type === VOID ? this.type : type;
  startTime = startTime === VOID ? this.startTime : startTime;
  expectedEndBreakTime = expectedEndBreakTime === VOID ? this.expectedEndBreakTime : expectedEndBreakTime;
  customBreakName = customBreakName === VOID ? this.customBreakName : customBreakName;
  customBreakMinLengthInMinutes = customBreakMinLengthInMinutes === VOID ? this.customBreakMinLengthInMinutes : customBreakMinLengthInMinutes;
  return $super === VOID ? this.nbt(type, startTime, expectedEndBreakTime, customBreakName, customBreakMinLengthInMinutes) : $super.nbt.call(this, type, startTime, expectedEndBreakTime, customBreakName, customBreakMinLengthInMinutes);
};
protoOf(BrowserBreak).toString = function () {
  return 'BrowserBreak(type=' + this.type + ', startTime=' + this.startTime + ', expectedEndBreakTime=' + this.expectedEndBreakTime + ', customBreakName=' + this.customBreakName + ', customBreakMinLengthInMinutes=' + this.customBreakMinLengthInMinutes + ')';
};
protoOf(BrowserBreak).hashCode = function () {
  var result = getStringHashCode(this.type);
  result = imul(result, 31) + getStringHashCode(this.startTime) | 0;
  result = imul(result, 31) + (this.expectedEndBreakTime == null ? 0 : getStringHashCode(this.expectedEndBreakTime)) | 0;
  result = imul(result, 31) + (this.customBreakName == null ? 0 : getStringHashCode(this.customBreakName)) | 0;
  result = imul(result, 31) + (this.customBreakMinLengthInMinutes == null ? 0 : this.customBreakMinLengthInMinutes) | 0;
  return result;
};
protoOf(BrowserBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserBreak))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserBreak ? other : THROW_CCE();
  if (!(this.type === tmp0_other_with_cast.type))
    return false;
  if (!(this.startTime === tmp0_other_with_cast.startTime))
    return false;
  if (!(this.expectedEndBreakTime == tmp0_other_with_cast.expectedEndBreakTime))
    return false;
  if (!(this.customBreakName == tmp0_other_with_cast.customBreakName))
    return false;
  if (!(this.customBreakMinLengthInMinutes == tmp0_other_with_cast.customBreakMinLengthInMinutes))
    return false;
  return true;
};
function Companion_30() {
}
protoOf(Companion_30).nbj = function (response) {
  var tmp = Companion_instance_41.obt(response.cba_1);
  var tmp_0 = AvailableActionMapper_instance.hbp(response.dba_1);
  var tmp_1 = response.gba_1.toString();
  var tmp_2 = Companion_instance_39.pbt(response.eba_1);
  var tmp0_safe_receiver = response.fba_1;
  var tmp_3;
  if (tmp0_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = Companion_instance_40.qbt(tmp0_safe_receiver);
  }
  return new BrowserClockedIn(VOID, tmp, tmp_0, tmp_1, tmp_2, tmp_3);
};
var Companion_instance_34;
function Companion_getInstance_32() {
  return Companion_instance_34;
}
function BrowserClockedIn(status, user, availableActions, serverTime, punch, currentShift) {
  status = status === VOID ? 'clocked_in' : status;
  this.rbt_1 = status;
  this.sbt_1 = user;
  this.tbt_1 = availableActions;
  this.ubt_1 = serverTime;
  this.punch = punch;
  this.currentShift = currentShift;
}
protoOf(BrowserClockedIn).c4u = function () {
  return this.rbt_1;
};
protoOf(BrowserClockedIn).w45 = function () {
  return this.sbt_1;
};
protoOf(BrowserClockedIn).bbk = function () {
  return this.tbt_1;
};
protoOf(BrowserClockedIn).cbk = function () {
  return this.ubt_1;
};
protoOf(BrowserClockedIn).vbt = function () {
  return this.punch;
};
protoOf(BrowserClockedIn).wbt = function () {
  return this.currentShift;
};
protoOf(BrowserClockedIn).mf = function () {
  return this.rbt_1;
};
protoOf(BrowserClockedIn).nf = function () {
  return this.sbt_1;
};
protoOf(BrowserClockedIn).ibk = function () {
  return this.tbt_1;
};
protoOf(BrowserClockedIn).jbk = function () {
  return this.ubt_1;
};
protoOf(BrowserClockedIn).kbk = function () {
  return this.punch;
};
protoOf(BrowserClockedIn).xbt = function () {
  return this.currentShift;
};
protoOf(BrowserClockedIn).ybt = function (status, user, availableActions, serverTime, punch, currentShift) {
  return new BrowserClockedIn(status, user, availableActions, serverTime, punch, currentShift);
};
protoOf(BrowserClockedIn).copy = function (status, user, availableActions, serverTime, punch, currentShift, $super) {
  status = status === VOID ? this.rbt_1 : status;
  user = user === VOID ? this.sbt_1 : user;
  availableActions = availableActions === VOID ? this.tbt_1 : availableActions;
  serverTime = serverTime === VOID ? this.ubt_1 : serverTime;
  punch = punch === VOID ? this.punch : punch;
  currentShift = currentShift === VOID ? this.currentShift : currentShift;
  return $super === VOID ? this.ybt(status, user, availableActions, serverTime, punch, currentShift) : $super.ybt.call(this, status, user, availableActions, serverTime, punch, currentShift);
};
protoOf(BrowserClockedIn).toString = function () {
  return 'BrowserClockedIn(status=' + this.rbt_1 + ', user=' + this.sbt_1.toString() + ', availableActions=' + toString(this.tbt_1) + ', serverTime=' + this.ubt_1 + ', punch=' + this.punch.toString() + ', currentShift=' + toString_0(this.currentShift) + ')';
};
protoOf(BrowserClockedIn).hashCode = function () {
  var result = getStringHashCode(this.rbt_1);
  result = imul(result, 31) + this.sbt_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.tbt_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.ubt_1) | 0;
  result = imul(result, 31) + this.punch.hashCode() | 0;
  result = imul(result, 31) + (this.currentShift == null ? 0 : this.currentShift.hashCode()) | 0;
  return result;
};
protoOf(BrowserClockedIn).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserClockedIn))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserClockedIn ? other : THROW_CCE();
  if (!(this.rbt_1 === tmp0_other_with_cast.rbt_1))
    return false;
  if (!this.sbt_1.equals(tmp0_other_with_cast.sbt_1))
    return false;
  if (!equals(this.tbt_1, tmp0_other_with_cast.tbt_1))
    return false;
  if (!(this.ubt_1 === tmp0_other_with_cast.ubt_1))
    return false;
  if (!this.punch.equals(tmp0_other_with_cast.punch))
    return false;
  if (!equals(this.currentShift, tmp0_other_with_cast.currentShift))
    return false;
  return true;
};
function Companion_31() {
}
protoOf(Companion_31).obj = function (response) {
  var tmp = Companion_instance_41.obt(response.yb9_1);
  var tmp_0 = AvailableActionMapper_instance.hbp(response.zb9_1);
  var tmp_1 = response.bba_1.toString();
  var tmp0_safe_receiver = response.aba_1;
  var tmp_2;
  if (tmp0_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = Companion_instance_38.zbt(tmp0_safe_receiver);
  }
  return new BrowserClockedOut(VOID, tmp, tmp_0, tmp_1, tmp_2);
};
var Companion_instance_35;
function Companion_getInstance_33() {
  return Companion_instance_35;
}
function BrowserClockedOut(status, user, availableActions, serverTime, preferredShift) {
  status = status === VOID ? 'clocked_out' : status;
  this.abu_1 = status;
  this.bbu_1 = user;
  this.cbu_1 = availableActions;
  this.dbu_1 = serverTime;
  this.preferredShift = preferredShift;
}
protoOf(BrowserClockedOut).c4u = function () {
  return this.abu_1;
};
protoOf(BrowserClockedOut).w45 = function () {
  return this.bbu_1;
};
protoOf(BrowserClockedOut).bbk = function () {
  return this.cbu_1;
};
protoOf(BrowserClockedOut).cbk = function () {
  return this.dbu_1;
};
protoOf(BrowserClockedOut).ebu = function () {
  return this.preferredShift;
};
protoOf(BrowserClockedOut).mf = function () {
  return this.abu_1;
};
protoOf(BrowserClockedOut).nf = function () {
  return this.bbu_1;
};
protoOf(BrowserClockedOut).ibk = function () {
  return this.cbu_1;
};
protoOf(BrowserClockedOut).jbk = function () {
  return this.dbu_1;
};
protoOf(BrowserClockedOut).kbk = function () {
  return this.preferredShift;
};
protoOf(BrowserClockedOut).fbu = function (status, user, availableActions, serverTime, preferredShift) {
  return new BrowserClockedOut(status, user, availableActions, serverTime, preferredShift);
};
protoOf(BrowserClockedOut).copy = function (status, user, availableActions, serverTime, preferredShift, $super) {
  status = status === VOID ? this.abu_1 : status;
  user = user === VOID ? this.bbu_1 : user;
  availableActions = availableActions === VOID ? this.cbu_1 : availableActions;
  serverTime = serverTime === VOID ? this.dbu_1 : serverTime;
  preferredShift = preferredShift === VOID ? this.preferredShift : preferredShift;
  return $super === VOID ? this.fbu(status, user, availableActions, serverTime, preferredShift) : $super.fbu.call(this, status, user, availableActions, serverTime, preferredShift);
};
protoOf(BrowserClockedOut).toString = function () {
  return 'BrowserClockedOut(status=' + this.abu_1 + ', user=' + this.bbu_1.toString() + ', availableActions=' + toString(this.cbu_1) + ', serverTime=' + this.dbu_1 + ', preferredShift=' + toString_0(this.preferredShift) + ')';
};
protoOf(BrowserClockedOut).hashCode = function () {
  var result = getStringHashCode(this.abu_1);
  result = imul(result, 31) + this.bbu_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.cbu_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.dbu_1) | 0;
  result = imul(result, 31) + (this.preferredShift == null ? 0 : this.preferredShift.hashCode()) | 0;
  return result;
};
protoOf(BrowserClockedOut).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserClockedOut))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserClockedOut ? other : THROW_CCE();
  if (!(this.abu_1 === tmp0_other_with_cast.abu_1))
    return false;
  if (!this.bbu_1.equals(tmp0_other_with_cast.bbu_1))
    return false;
  if (!equals(this.cbu_1, tmp0_other_with_cast.cbu_1))
    return false;
  if (!(this.dbu_1 === tmp0_other_with_cast.dbu_1))
    return false;
  if (!equals(this.preferredShift, tmp0_other_with_cast.preferredShift))
    return false;
  return true;
};
function Companion_32() {
}
protoOf(Companion_32).tbs = function (customBreak) {
  return new BrowserCustomBreak(customBreak.lb0_1.d1(), customBreak.mb0_1, customBreak.nb0_1);
};
var Companion_instance_36;
function Companion_getInstance_34() {
  return Companion_instance_36;
}
function BrowserCustomBreak(id, name, minLengthInMinutes) {
  this.id = id;
  this.name = name;
  this.minLengthInMinutes = minLengthInMinutes;
}
protoOf(BrowserCustomBreak).f2t = function () {
  return this.id;
};
protoOf(BrowserCustomBreak).m1d = function () {
  return this.name;
};
protoOf(BrowserCustomBreak).gbu = function () {
  return this.minLengthInMinutes;
};
protoOf(BrowserCustomBreak).mf = function () {
  return this.id;
};
protoOf(BrowserCustomBreak).nf = function () {
  return this.name;
};
protoOf(BrowserCustomBreak).ibk = function () {
  return this.minLengthInMinutes;
};
protoOf(BrowserCustomBreak).hbu = function (id, name, minLengthInMinutes) {
  return new BrowserCustomBreak(id, name, minLengthInMinutes);
};
protoOf(BrowserCustomBreak).copy = function (id, name, minLengthInMinutes, $super) {
  id = id === VOID ? this.id : id;
  name = name === VOID ? this.name : name;
  minLengthInMinutes = minLengthInMinutes === VOID ? this.minLengthInMinutes : minLengthInMinutes;
  return $super === VOID ? this.hbu(id, name, minLengthInMinutes) : $super.hbu.call(this, id, name, minLengthInMinutes);
};
protoOf(BrowserCustomBreak).toString = function () {
  return 'BrowserCustomBreak(id=' + this.id + ', name=' + this.name + ', minLengthInMinutes=' + this.minLengthInMinutes + ')';
};
protoOf(BrowserCustomBreak).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + getStringHashCode(this.name) | 0;
  result = imul(result, 31) + this.minLengthInMinutes | 0;
  return result;
};
protoOf(BrowserCustomBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserCustomBreak))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserCustomBreak ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.name === tmp0_other_with_cast.name))
    return false;
  if (!(this.minLengthInMinutes === tmp0_other_with_cast.minLengthInMinutes))
    return false;
  return true;
};
function Companion_33() {
}
protoOf(Companion_33).mbj = function (response) {
  var tmp = Companion_instance_41.obt(response.hba_1);
  var tmp_0 = AvailableActionMapper_instance.hbp(response.iba_1);
  var tmp_1 = response.mba_1.toString();
  var tmp_2 = Companion_instance_39.pbt(response.jba_1);
  var tmp0_safe_receiver = response.kba_1;
  var tmp_3;
  if (tmp0_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = Companion_instance_40.qbt(tmp0_safe_receiver);
  }
  return new BrowserOnBreak(VOID, tmp, tmp_0, tmp_1, tmp_2, tmp_3, Companion_instance_33.ibt(response.lba_1));
};
var Companion_instance_37;
function Companion_getInstance_35() {
  return Companion_instance_37;
}
function BrowserOnBreak(status, user, availableActions, serverTime, punch, currentShift, currentBreak) {
  status = status === VOID ? 'on_break' : status;
  this.ibu_1 = status;
  this.jbu_1 = user;
  this.kbu_1 = availableActions;
  this.lbu_1 = serverTime;
  this.punch = punch;
  this.currentShift = currentShift;
  this.currentBreak = currentBreak;
}
protoOf(BrowserOnBreak).c4u = function () {
  return this.ibu_1;
};
protoOf(BrowserOnBreak).w45 = function () {
  return this.jbu_1;
};
protoOf(BrowserOnBreak).bbk = function () {
  return this.kbu_1;
};
protoOf(BrowserOnBreak).cbk = function () {
  return this.lbu_1;
};
protoOf(BrowserOnBreak).vbt = function () {
  return this.punch;
};
protoOf(BrowserOnBreak).wbt = function () {
  return this.currentShift;
};
protoOf(BrowserOnBreak).mbu = function () {
  return this.currentBreak;
};
protoOf(BrowserOnBreak).mf = function () {
  return this.ibu_1;
};
protoOf(BrowserOnBreak).nf = function () {
  return this.jbu_1;
};
protoOf(BrowserOnBreak).ibk = function () {
  return this.kbu_1;
};
protoOf(BrowserOnBreak).jbk = function () {
  return this.lbu_1;
};
protoOf(BrowserOnBreak).kbk = function () {
  return this.punch;
};
protoOf(BrowserOnBreak).xbt = function () {
  return this.currentShift;
};
protoOf(BrowserOnBreak).nbu = function () {
  return this.currentBreak;
};
protoOf(BrowserOnBreak).obu = function (status, user, availableActions, serverTime, punch, currentShift, currentBreak) {
  return new BrowserOnBreak(status, user, availableActions, serverTime, punch, currentShift, currentBreak);
};
protoOf(BrowserOnBreak).copy = function (status, user, availableActions, serverTime, punch, currentShift, currentBreak, $super) {
  status = status === VOID ? this.ibu_1 : status;
  user = user === VOID ? this.jbu_1 : user;
  availableActions = availableActions === VOID ? this.kbu_1 : availableActions;
  serverTime = serverTime === VOID ? this.lbu_1 : serverTime;
  punch = punch === VOID ? this.punch : punch;
  currentShift = currentShift === VOID ? this.currentShift : currentShift;
  currentBreak = currentBreak === VOID ? this.currentBreak : currentBreak;
  return $super === VOID ? this.obu(status, user, availableActions, serverTime, punch, currentShift, currentBreak) : $super.obu.call(this, status, user, availableActions, serverTime, punch, currentShift, currentBreak);
};
protoOf(BrowserOnBreak).toString = function () {
  return 'BrowserOnBreak(status=' + this.ibu_1 + ', user=' + this.jbu_1.toString() + ', availableActions=' + toString(this.kbu_1) + ', serverTime=' + this.lbu_1 + ', punch=' + this.punch.toString() + ', currentShift=' + toString_0(this.currentShift) + ', currentBreak=' + this.currentBreak.toString() + ')';
};
protoOf(BrowserOnBreak).hashCode = function () {
  var result = getStringHashCode(this.ibu_1);
  result = imul(result, 31) + this.jbu_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.kbu_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.lbu_1) | 0;
  result = imul(result, 31) + this.punch.hashCode() | 0;
  result = imul(result, 31) + (this.currentShift == null ? 0 : this.currentShift.hashCode()) | 0;
  result = imul(result, 31) + this.currentBreak.hashCode() | 0;
  return result;
};
protoOf(BrowserOnBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserOnBreak))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserOnBreak ? other : THROW_CCE();
  if (!(this.ibu_1 === tmp0_other_with_cast.ibu_1))
    return false;
  if (!this.jbu_1.equals(tmp0_other_with_cast.jbu_1))
    return false;
  if (!equals(this.kbu_1, tmp0_other_with_cast.kbu_1))
    return false;
  if (!(this.lbu_1 === tmp0_other_with_cast.lbu_1))
    return false;
  if (!this.punch.equals(tmp0_other_with_cast.punch))
    return false;
  if (!equals(this.currentShift, tmp0_other_with_cast.currentShift))
    return false;
  if (!this.currentBreak.equals(tmp0_other_with_cast.currentBreak))
    return false;
  return true;
};
function Companion_34() {
}
protoOf(Companion_34).zbt = function (preferredShift) {
  var tmp = Companion_instance_40.qbt(preferredShift.ib8_1);
  var tmp0_safe_receiver = preferredShift.jb8_1;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_safe_receiver, 10));
    var _iterator__ex2g4s = tmp0_safe_receiver.j();
    while (_iterator__ex2g4s.k()) {
      var item = _iterator__ex2g4s.l();
      var tmp_1 = item.a90_1.e90_1.d1();
      var tmp0_safe_receiver_0 = item.a90_1.h90_1;
      var tmp$ret$0 = new BrowserRole(tmp_1, item.a90_1.f90_1, item.a90_1.g90_1, tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d90_1);
      destination.e(tmp$ret$0);
    }
    tmp_0 = destination;
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_2 = copyToArray(tmp1_safe_receiver);
  }
  return new BrowserPreferredShift(tmp, tmp_2);
};
var Companion_instance_38;
function Companion_getInstance_36() {
  return Companion_instance_38;
}
function BrowserPreferredShift(shift, otherAssignedRoles) {
  this.shift = shift;
  this.otherAssignedRoles = otherAssignedRoles;
}
protoOf(BrowserPreferredShift).pbu = function () {
  return this.shift;
};
protoOf(BrowserPreferredShift).qbu = function () {
  return this.otherAssignedRoles;
};
protoOf(BrowserPreferredShift).mf = function () {
  return this.shift;
};
protoOf(BrowserPreferredShift).nf = function () {
  return this.otherAssignedRoles;
};
protoOf(BrowserPreferredShift).rbu = function (shift, otherAssignedRoles) {
  return new BrowserPreferredShift(shift, otherAssignedRoles);
};
protoOf(BrowserPreferredShift).copy = function (shift, otherAssignedRoles, $super) {
  shift = shift === VOID ? this.shift : shift;
  otherAssignedRoles = otherAssignedRoles === VOID ? this.otherAssignedRoles : otherAssignedRoles;
  return $super === VOID ? this.rbu(shift, otherAssignedRoles) : $super.rbu.call(this, shift, otherAssignedRoles);
};
protoOf(BrowserPreferredShift).toString = function () {
  return 'BrowserPreferredShift(shift=' + this.shift.toString() + ', otherAssignedRoles=' + toString(this.otherAssignedRoles) + ')';
};
protoOf(BrowserPreferredShift).hashCode = function () {
  var result = this.shift.hashCode();
  result = imul(result, 31) + (this.otherAssignedRoles == null ? 0 : hashCode(this.otherAssignedRoles)) | 0;
  return result;
};
protoOf(BrowserPreferredShift).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserPreferredShift))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserPreferredShift ? other : THROW_CCE();
  if (!this.shift.equals(tmp0_other_with_cast.shift))
    return false;
  if (!equals(this.otherAssignedRoles, tmp0_other_with_cast.otherAssignedRoles))
    return false;
  return true;
};
function BrowserRole(id, name, color, departmentName) {
  this.id = id;
  this.name = name;
  this.color = color;
  this.departmentName = departmentName;
}
protoOf(BrowserRole).f2t = function () {
  return this.id;
};
protoOf(BrowserRole).m1d = function () {
  return this.name;
};
protoOf(BrowserRole).fbm = function () {
  return this.color;
};
protoOf(BrowserRole).ebm = function () {
  return this.departmentName;
};
protoOf(BrowserRole).mf = function () {
  return this.id;
};
protoOf(BrowserRole).nf = function () {
  return this.name;
};
protoOf(BrowserRole).ibk = function () {
  return this.color;
};
protoOf(BrowserRole).jbk = function () {
  return this.departmentName;
};
protoOf(BrowserRole).sbu = function (id, name, color, departmentName) {
  return new BrowserRole(id, name, color, departmentName);
};
protoOf(BrowserRole).copy = function (id, name, color, departmentName, $super) {
  id = id === VOID ? this.id : id;
  name = name === VOID ? this.name : name;
  color = color === VOID ? this.color : color;
  departmentName = departmentName === VOID ? this.departmentName : departmentName;
  return $super === VOID ? this.sbu(id, name, color, departmentName) : $super.sbu.call(this, id, name, color, departmentName);
};
protoOf(BrowserRole).toString = function () {
  return 'BrowserRole(id=' + this.id + ', name=' + this.name + ', color=' + this.color + ', departmentName=' + this.departmentName + ')';
};
protoOf(BrowserRole).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + getStringHashCode(this.name) | 0;
  result = imul(result, 31) + (this.color == null ? 0 : getStringHashCode(this.color)) | 0;
  result = imul(result, 31) + (this.departmentName == null ? 0 : getStringHashCode(this.departmentName)) | 0;
  return result;
};
protoOf(BrowserRole).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserRole))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserRole ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.name === tmp0_other_with_cast.name))
    return false;
  if (!(this.color == tmp0_other_with_cast.color))
    return false;
  if (!(this.departmentName == tmp0_other_with_cast.departmentName))
    return false;
  return true;
};
function Companion_35() {
}
protoOf(Companion_35).pbt = function (punch) {
  var tmp0_subject = punch.sba_1;
  var tmp;
  if (tmp0_subject instanceof Location) {
    tmp = listOf(['location', null, null, null]);
  } else {
    if (tmp0_subject instanceof Role) {
      var tmp1_safe_receiver = punch.sba_1.a90_1.h90_1;
      tmp = listOf(['role', punch.sba_1.a90_1.f90_1, punch.sba_1.a90_1.g90_1, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.d90_1]);
    } else {
      if (tmp0_subject instanceof Department) {
        tmp = listOf(['department', null, null, punch.sba_1.b90_1.d90_1]);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  var _destruct__k2r9zo = tmp;
  // Inline function 'kotlin.collections.component1' call
  var type = _destruct__k2r9zo.o(0);
  // Inline function 'kotlin.collections.component2' call
  var roleName = _destruct__k2r9zo.o(1);
  // Inline function 'kotlin.collections.component3' call
  var roleColor = _destruct__k2r9zo.o(2);
  // Inline function 'kotlin.collections.component4' call
  var deptName = _destruct__k2r9zo.o(3);
  var tmp_0 = punch.rba_1.toString();
  return new BrowserPunch(tmp_0, type == null ? 'location' : type, roleName, roleColor, deptName, punch.tba_1);
};
var Companion_instance_39;
function Companion_getInstance_37() {
  return Companion_instance_39;
}
function BrowserPunch(clockedInAt, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, hasRoleChanged) {
  this.clockedInAt = clockedInAt;
  this.assignmentType = assignmentType;
  this.assignmentRoleName = assignmentRoleName;
  this.assignmentRoleColor = assignmentRoleColor;
  this.assignmentDepartmentName = assignmentDepartmentName;
  this.hasRoleChanged = hasRoleChanged;
}
protoOf(BrowserPunch).tbu = function () {
  return this.clockedInAt;
};
protoOf(BrowserPunch).ubu = function () {
  return this.assignmentType;
};
protoOf(BrowserPunch).vbu = function () {
  return this.assignmentRoleName;
};
protoOf(BrowserPunch).wbu = function () {
  return this.assignmentRoleColor;
};
protoOf(BrowserPunch).xbu = function () {
  return this.assignmentDepartmentName;
};
protoOf(BrowserPunch).ybu = function () {
  return this.hasRoleChanged;
};
protoOf(BrowserPunch).mf = function () {
  return this.clockedInAt;
};
protoOf(BrowserPunch).nf = function () {
  return this.assignmentType;
};
protoOf(BrowserPunch).ibk = function () {
  return this.assignmentRoleName;
};
protoOf(BrowserPunch).jbk = function () {
  return this.assignmentRoleColor;
};
protoOf(BrowserPunch).kbk = function () {
  return this.assignmentDepartmentName;
};
protoOf(BrowserPunch).xbt = function () {
  return this.hasRoleChanged;
};
protoOf(BrowserPunch).zbu = function (clockedInAt, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, hasRoleChanged) {
  return new BrowserPunch(clockedInAt, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, hasRoleChanged);
};
protoOf(BrowserPunch).copy = function (clockedInAt, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, hasRoleChanged, $super) {
  clockedInAt = clockedInAt === VOID ? this.clockedInAt : clockedInAt;
  assignmentType = assignmentType === VOID ? this.assignmentType : assignmentType;
  assignmentRoleName = assignmentRoleName === VOID ? this.assignmentRoleName : assignmentRoleName;
  assignmentRoleColor = assignmentRoleColor === VOID ? this.assignmentRoleColor : assignmentRoleColor;
  assignmentDepartmentName = assignmentDepartmentName === VOID ? this.assignmentDepartmentName : assignmentDepartmentName;
  hasRoleChanged = hasRoleChanged === VOID ? this.hasRoleChanged : hasRoleChanged;
  return $super === VOID ? this.zbu(clockedInAt, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, hasRoleChanged) : $super.zbu.call(this, clockedInAt, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, hasRoleChanged);
};
protoOf(BrowserPunch).toString = function () {
  return 'BrowserPunch(clockedInAt=' + this.clockedInAt + ', assignmentType=' + this.assignmentType + ', assignmentRoleName=' + this.assignmentRoleName + ', assignmentRoleColor=' + this.assignmentRoleColor + ', assignmentDepartmentName=' + this.assignmentDepartmentName + ', hasRoleChanged=' + this.hasRoleChanged + ')';
};
protoOf(BrowserPunch).hashCode = function () {
  var result = getStringHashCode(this.clockedInAt);
  result = imul(result, 31) + getStringHashCode(this.assignmentType) | 0;
  result = imul(result, 31) + (this.assignmentRoleName == null ? 0 : getStringHashCode(this.assignmentRoleName)) | 0;
  result = imul(result, 31) + (this.assignmentRoleColor == null ? 0 : getStringHashCode(this.assignmentRoleColor)) | 0;
  result = imul(result, 31) + (this.assignmentDepartmentName == null ? 0 : getStringHashCode(this.assignmentDepartmentName)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.hasRoleChanged) | 0;
  return result;
};
protoOf(BrowserPunch).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserPunch))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserPunch ? other : THROW_CCE();
  if (!(this.clockedInAt === tmp0_other_with_cast.clockedInAt))
    return false;
  if (!(this.assignmentType === tmp0_other_with_cast.assignmentType))
    return false;
  if (!(this.assignmentRoleName == tmp0_other_with_cast.assignmentRoleName))
    return false;
  if (!(this.assignmentRoleColor == tmp0_other_with_cast.assignmentRoleColor))
    return false;
  if (!(this.assignmentDepartmentName == tmp0_other_with_cast.assignmentDepartmentName))
    return false;
  if (!(this.hasRoleChanged === tmp0_other_with_cast.hasRoleChanged))
    return false;
  return true;
};
function Companion_36() {
}
protoOf(Companion_36).qbt = function (shift) {
  var tmp0_subject = shift.hb0_1;
  var tmp;
  if (tmp0_subject instanceof Location) {
    tmp = listOf(['location', null, null, null]);
  } else {
    if (tmp0_subject instanceof Role) {
      var tmp1_safe_receiver = shift.hb0_1.a90_1.h90_1;
      tmp = listOf(['role', shift.hb0_1.a90_1.f90_1, shift.hb0_1.a90_1.g90_1, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.d90_1]);
    } else {
      if (tmp0_subject instanceof Department) {
        tmp = listOf(['department', null, null, shift.hb0_1.b90_1.d90_1]);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  var _destruct__k2r9zo = tmp;
  // Inline function 'kotlin.collections.component1' call
  var type = _destruct__k2r9zo.o(0);
  // Inline function 'kotlin.collections.component2' call
  var roleName = _destruct__k2r9zo.o(1);
  // Inline function 'kotlin.collections.component3' call
  var roleColor = _destruct__k2r9zo.o(2);
  // Inline function 'kotlin.collections.component4' call
  var deptName = _destruct__k2r9zo.o(3);
  var tmp_0 = shift.gb0_1.d1();
  var tmp_1 = type == null ? 'location' : type;
  var tmp_2 = shift.ib0_1.toString();
  var tmp_3 = shift.jb0_1.toString();
  var tmp3_safe_receiver = shift.kb0_1;
  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.k2_1;
  var tmp_4;
  if (tmp4_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4 = tmp4_safe_receiver.toLowerCase();
  }
  return new BrowserShift(tmp_0, tmp_1, roleName, roleColor, deptName, tmp_2, tmp_3, tmp_4);
};
var Companion_instance_40;
function Companion_getInstance_38() {
  return Companion_instance_40;
}
function BrowserShift(id, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, startTime, endTime, endCriteria) {
  this.id = id;
  this.assignmentType = assignmentType;
  this.assignmentRoleName = assignmentRoleName;
  this.assignmentRoleColor = assignmentRoleColor;
  this.assignmentDepartmentName = assignmentDepartmentName;
  this.startTime = startTime;
  this.endTime = endTime;
  this.endCriteria = endCriteria;
}
protoOf(BrowserShift).f2t = function () {
  return this.id;
};
protoOf(BrowserShift).ubu = function () {
  return this.assignmentType;
};
protoOf(BrowserShift).vbu = function () {
  return this.assignmentRoleName;
};
protoOf(BrowserShift).wbu = function () {
  return this.assignmentRoleColor;
};
protoOf(BrowserShift).xbu = function () {
  return this.assignmentDepartmentName;
};
protoOf(BrowserShift).jbt = function () {
  return this.startTime;
};
protoOf(BrowserShift).abv = function () {
  return this.endTime;
};
protoOf(BrowserShift).bbv = function () {
  return this.endCriteria;
};
protoOf(BrowserShift).mf = function () {
  return this.id;
};
protoOf(BrowserShift).nf = function () {
  return this.assignmentType;
};
protoOf(BrowserShift).ibk = function () {
  return this.assignmentRoleName;
};
protoOf(BrowserShift).jbk = function () {
  return this.assignmentRoleColor;
};
protoOf(BrowserShift).kbk = function () {
  return this.assignmentDepartmentName;
};
protoOf(BrowserShift).xbt = function () {
  return this.startTime;
};
protoOf(BrowserShift).nbu = function () {
  return this.endTime;
};
protoOf(BrowserShift).cbv = function () {
  return this.endCriteria;
};
protoOf(BrowserShift).dbv = function (id, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, startTime, endTime, endCriteria) {
  return new BrowserShift(id, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, startTime, endTime, endCriteria);
};
protoOf(BrowserShift).copy = function (id, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, startTime, endTime, endCriteria, $super) {
  id = id === VOID ? this.id : id;
  assignmentType = assignmentType === VOID ? this.assignmentType : assignmentType;
  assignmentRoleName = assignmentRoleName === VOID ? this.assignmentRoleName : assignmentRoleName;
  assignmentRoleColor = assignmentRoleColor === VOID ? this.assignmentRoleColor : assignmentRoleColor;
  assignmentDepartmentName = assignmentDepartmentName === VOID ? this.assignmentDepartmentName : assignmentDepartmentName;
  startTime = startTime === VOID ? this.startTime : startTime;
  endTime = endTime === VOID ? this.endTime : endTime;
  endCriteria = endCriteria === VOID ? this.endCriteria : endCriteria;
  return $super === VOID ? this.dbv(id, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, startTime, endTime, endCriteria) : $super.dbv.call(this, id, assignmentType, assignmentRoleName, assignmentRoleColor, assignmentDepartmentName, startTime, endTime, endCriteria);
};
protoOf(BrowserShift).toString = function () {
  return 'BrowserShift(id=' + this.id + ', assignmentType=' + this.assignmentType + ', assignmentRoleName=' + this.assignmentRoleName + ', assignmentRoleColor=' + this.assignmentRoleColor + ', assignmentDepartmentName=' + this.assignmentDepartmentName + ', startTime=' + this.startTime + ', endTime=' + this.endTime + ', endCriteria=' + this.endCriteria + ')';
};
protoOf(BrowserShift).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + getStringHashCode(this.assignmentType) | 0;
  result = imul(result, 31) + (this.assignmentRoleName == null ? 0 : getStringHashCode(this.assignmentRoleName)) | 0;
  result = imul(result, 31) + (this.assignmentRoleColor == null ? 0 : getStringHashCode(this.assignmentRoleColor)) | 0;
  result = imul(result, 31) + (this.assignmentDepartmentName == null ? 0 : getStringHashCode(this.assignmentDepartmentName)) | 0;
  result = imul(result, 31) + getStringHashCode(this.startTime) | 0;
  result = imul(result, 31) + getStringHashCode(this.endTime) | 0;
  result = imul(result, 31) + (this.endCriteria == null ? 0 : getStringHashCode(this.endCriteria)) | 0;
  return result;
};
protoOf(BrowserShift).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserShift))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserShift ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.assignmentType === tmp0_other_with_cast.assignmentType))
    return false;
  if (!(this.assignmentRoleName == tmp0_other_with_cast.assignmentRoleName))
    return false;
  if (!(this.assignmentRoleColor == tmp0_other_with_cast.assignmentRoleColor))
    return false;
  if (!(this.assignmentDepartmentName == tmp0_other_with_cast.assignmentDepartmentName))
    return false;
  if (!(this.startTime === tmp0_other_with_cast.startTime))
    return false;
  if (!(this.endTime === tmp0_other_with_cast.endTime))
    return false;
  if (!(this.endCriteria == tmp0_other_with_cast.endCriteria))
    return false;
  return true;
};
function Companion_37() {
}
protoOf(Companion_37).obt = function (user) {
  return new BrowserUser(user.nba_1.d1(), user.oba_1, user.pba_1, user.qba_1);
};
var Companion_instance_41;
function Companion_getInstance_39() {
  return Companion_instance_41;
}
function BrowserUser(id, firstName, lastName, profilePictureUrl) {
  this.id = id;
  this.firstName = firstName;
  this.lastName = lastName;
  this.profilePictureUrl = profilePictureUrl;
}
protoOf(BrowserUser).f2t = function () {
  return this.id;
};
protoOf(BrowserUser).ebv = function () {
  return this.firstName;
};
protoOf(BrowserUser).fbv = function () {
  return this.lastName;
};
protoOf(BrowserUser).gbv = function () {
  return this.profilePictureUrl;
};
protoOf(BrowserUser).mf = function () {
  return this.id;
};
protoOf(BrowserUser).nf = function () {
  return this.firstName;
};
protoOf(BrowserUser).ibk = function () {
  return this.lastName;
};
protoOf(BrowserUser).jbk = function () {
  return this.profilePictureUrl;
};
protoOf(BrowserUser).hbv = function (id, firstName, lastName, profilePictureUrl) {
  return new BrowserUser(id, firstName, lastName, profilePictureUrl);
};
protoOf(BrowserUser).copy = function (id, firstName, lastName, profilePictureUrl, $super) {
  id = id === VOID ? this.id : id;
  firstName = firstName === VOID ? this.firstName : firstName;
  lastName = lastName === VOID ? this.lastName : lastName;
  profilePictureUrl = profilePictureUrl === VOID ? this.profilePictureUrl : profilePictureUrl;
  return $super === VOID ? this.hbv(id, firstName, lastName, profilePictureUrl) : $super.hbv.call(this, id, firstName, lastName, profilePictureUrl);
};
protoOf(BrowserUser).toString = function () {
  return 'BrowserUser(id=' + this.id + ', firstName=' + this.firstName + ', lastName=' + this.lastName + ', profilePictureUrl=' + this.profilePictureUrl + ')';
};
protoOf(BrowserUser).hashCode = function () {
  var result = this.id;
  result = imul(result, 31) + getStringHashCode(this.firstName) | 0;
  result = imul(result, 31) + getStringHashCode(this.lastName) | 0;
  result = imul(result, 31) + getStringHashCode(this.profilePictureUrl) | 0;
  return result;
};
protoOf(BrowserUser).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BrowserUser))
    return false;
  var tmp0_other_with_cast = other instanceof BrowserUser ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!(this.firstName === tmp0_other_with_cast.firstName))
    return false;
  if (!(this.lastName === tmp0_other_with_cast.lastName))
    return false;
  if (!(this.profilePictureUrl === tmp0_other_with_cast.profilePictureUrl))
    return false;
  return true;
};
//region block: post-declaration
protoOf(InternalDependencyContainer).e1a = getKoin;
defineProp(protoOf(JSPlatform), 'name', function () {
  return this.m1d();
});
defineProp(protoOf(APIError), 'message', function () {
  return this.g1();
});
defineProp(protoOf(BreakEnded_0), 'timePunchId', function () {
  return this.ibj();
});
defineProp(protoOf(BreakEnded_0), 'userPhotoUrl', function () {
  return this.jbj();
});
defineProp(protoOf(BreakEnded_0), 'message', function () {
  return this.g1();
});
defineProp(protoOf(BreakStarted_0), 'timePunchId', function () {
  return this.ibj();
});
defineProp(protoOf(BreakStarted_0), 'userPhotoUrl', function () {
  return this.jbj();
});
defineProp(protoOf(BreakStarted_0), 'message', function () {
  return this.g1();
});
defineProp(protoOf(ClockedIn_2), 'timePunchId', function () {
  return this.ibj();
});
defineProp(protoOf(ClockedIn_2), 'message', function () {
  return this.g1();
});
defineProp(protoOf(ClockedIn_2), 'userPhotoUrl', function () {
  return this.jbj();
});
defineProp(protoOf(ClockedOut_2), 'timePunchId', function () {
  return this.ibj();
});
defineProp(protoOf(ClockedOut_2), 'message', function () {
  return this.g1();
});
defineProp(protoOf(ClockedOut_2), 'userPhotoUrl', function () {
  return this.jbj();
});
defineProp(protoOf(BreakTooShort_0), 'message', function () {
  return this.g1();
});
defineProp(protoOf(HealthCheckFailed_0), 'message', function () {
  return this.g1();
});
defineProp(protoOf(InvalidPunchId_0), 'message', function () {
  return this.g1();
});
defineProp(protoOf(BrowserStartShiftAction), 'type', function () {
  return this.lbq();
});
defineProp(protoOf(BrowserStartUnscheduledShiftAction), 'type', function () {
  return this.lbq();
});
defineProp(protoOf(BrowserClockOutAction), 'type', function () {
  return this.lbq();
});
defineProp(protoOf(BrowserStartPaidBreakAction), 'type', function () {
  return this.lbq();
});
defineProp(protoOf(BrowserStartUnpaidBreakAction), 'type', function () {
  return this.lbq();
});
defineProp(protoOf(BrowserStartCustomBreakAction), 'type', function () {
  return this.lbq();
});
defineProp(protoOf(BrowserEndBreakAction), 'type', function () {
  return this.lbq();
});
defineProp(protoOf(BrowserClockedIn), 'status', function () {
  return this.c4u();
});
defineProp(protoOf(BrowserClockedIn), 'user', function () {
  return this.w45();
});
defineProp(protoOf(BrowserClockedIn), 'availableActions', function () {
  return this.bbk();
});
defineProp(protoOf(BrowserClockedIn), 'serverTime', function () {
  return this.cbk();
});
defineProp(protoOf(BrowserClockedOut), 'status', function () {
  return this.c4u();
});
defineProp(protoOf(BrowserClockedOut), 'user', function () {
  return this.w45();
});
defineProp(protoOf(BrowserClockedOut), 'availableActions', function () {
  return this.bbk();
});
defineProp(protoOf(BrowserClockedOut), 'serverTime', function () {
  return this.cbk();
});
defineProp(protoOf(BrowserOnBreak), 'status', function () {
  return this.c4u();
});
defineProp(protoOf(BrowserOnBreak), 'user', function () {
  return this.w45();
});
defineProp(protoOf(BrowserOnBreak), 'availableActions', function () {
  return this.bbk();
});
defineProp(protoOf(BrowserOnBreak), 'serverTime', function () {
  return this.cbk();
});
//endregion
//region block: init
Companion_instance_3 = new Companion();
SharedDependencies_instance = new SharedDependencies();
BreakTooShortStrategy_instance = new BreakTooShortStrategy();
HealthCheckFailedStrategy_instance = new HealthCheckFailedStrategy();
InvalidPunchIdStrategy_instance = new InvalidPunchIdStrategy();
PunchedInStrategy_instance = new PunchedInStrategy();
PunchedOutStrategy_instance = new PunchedOutStrategy();
Companion_instance_4 = new Companion_0();
Companion_instance_6 = new Companion_2();
Companion_instance_7 = new Companion_3();
Companion_instance_8 = new Companion_4();
Companion_instance_9 = new Companion_5();
Companion_instance_10 = new Companion_6();
Companion_instance_11 = new Companion_7();
Companion_instance_12 = new Companion_8();
Companion_instance_13 = new Companion_9();
Companion_instance_14 = new Companion_10();
Companion_instance_15 = new Companion_11();
Companion_instance_16 = new Companion_12();
Companion_instance_17 = new Companion_13();
Companion_instance_18 = new Companion_14();
Companion_instance_19 = new Companion_15();
Companion_instance_20 = new Companion_16();
Companion_instance_21 = new Companion_17();
Companion_instance_22 = new Companion_18();
Companion_instance_23 = new Companion_19();
Companion_instance_24 = new Companion_20();
Companion_instance_25 = new Companion_21();
AvailableActionMapper_instance = new AvailableActionMapper();
Companion_instance_26 = new Companion_22();
Companion_instance_27 = new Companion_23();
Companion_instance_28 = new Companion_24();
Companion_instance_29 = new Companion_25();
Companion_instance_30 = new Companion_26();
Companion_instance_31 = new Companion_27();
Companion_instance_32 = new Companion_28();
Companion_instance_33 = new Companion_29();
Companion_instance_34 = new Companion_30();
Companion_instance_35 = new Companion_31();
Companion_instance_36 = new Companion_32();
Companion_instance_37 = new Companion_33();
Companion_instance_38 = new Companion_34();
Companion_instance_39 = new Companion_35();
Companion_instance_40 = new Companion_36();
Companion_instance_41 = new Companion_37();
//endregion
//region block: exports
defineProp(APIError, 'Companion', Companion_getInstance_2);
var PunchBrowserResponse = {getInstance: Companion_getInstance_3};
defineProp(BreakEnded_0, 'Companion', Companion_getInstance_4);
defineProp(BreakStarted_0, 'Companion', Companion_getInstance_5);
defineProp(ClockedIn_2, 'Companion', Companion_getInstance_6);
defineProp(ClockedOut_2, 'Companion', Companion_getInstance_7);
defineProp(BreakTooShort_0, 'Companion', Companion_getInstance_8);
defineProp(HealthCheckFailed_0, 'Companion', Companion_getInstance_9);
defineProp(InvalidPunchId_0, 'Companion', Companion_getInstance_10);
defineProp(BrowserAttestationRequired, 'Companion', Companion_getInstance_11);
defineProp(BrowserAttestation, 'Companion', Companion_getInstance_12);
defineProp(BrowserAttestationContent, 'Companion', Companion_getInstance_13);
defineProp(BrowserAttestationResponse, 'Companion', Companion_getInstance_14);
defineProp(BrowserClockRole, 'Companion', Companion_getInstance_15);
defineProp(BrowserClockDepartment, 'Companion', Companion_getInstance_16);
defineProp(BrowserDepartmentSelectionRequired, 'Companion', Companion_getInstance_17);
defineProp(BrowserHealthCheckRequired, 'Companion', Companion_getInstance_18);
defineProp(BrowserHealthCheckQuestionnaire, 'Companion', Companion_getInstance_19);
defineProp(BrowserHealthCheckQuestion, 'Companion', Companion_getInstance_20);
defineProp(BrowserHealthCheckResponse, 'Companion', Companion_getInstance_21);
defineProp(BrowserRoleSelectionRequired, 'Companion', Companion_getInstance_22);
defineProp(TipsNeeded_0, 'Companion', Companion_getInstance_23);
defineProp(BrowserStartShiftAction, 'Companion', Companion_getInstance_24);
defineProp(BrowserStartUnscheduledShiftAction, 'Companion', Companion_getInstance_25);
defineProp(BrowserClockOutAction, 'Companion', Companion_getInstance_26);
defineProp(BrowserStartPaidBreakAction, 'Companion', Companion_getInstance_27);
defineProp(BrowserStartUnpaidBreakAction, 'Companion', Companion_getInstance_28);
defineProp(BrowserStartCustomBreakAction, 'Companion', Companion_getInstance_29);
defineProp(BrowserEndBreakAction, 'Companion', Companion_getInstance_30);
defineProp(BrowserBreak, 'Companion', Companion_getInstance_31);
defineProp(BrowserClockedIn, 'Companion', Companion_getInstance_32);
defineProp(BrowserClockedOut, 'Companion', Companion_getInstance_33);
defineProp(BrowserCustomBreak, 'Companion', Companion_getInstance_34);
defineProp(BrowserOnBreak, 'Companion', Companion_getInstance_35);
defineProp(BrowserPreferredShift, 'Companion', Companion_getInstance_36);
defineProp(BrowserPunch, 'Companion', Companion_getInstance_37);
defineProp(BrowserShift, 'Companion', Companion_getInstance_38);
defineProp(BrowserUser, 'Companion', Companion_getInstance_39);
export {
  JSPlatform as JSPlatform,
  getPlatform as getPlatform,
  PunchFlowServiceBrowserClient as PunchFlowServiceBrowserClient,
  webViewPunchFlowServiceFactory as webViewPunchFlowServiceFactory,
  shutdownPunchFlowService as shutdownPunchFlowService,
  APIError as APIError,
  PunchBrowserResponse as PunchBrowserResponse,
  BreakEnded_0 as BreakEnded,
  BreakStarted_0 as BreakStarted,
  ClockedIn_2 as ClockedIn,
  ClockedOut_2 as ClockedOut,
  BreakTooShort_0 as BreakTooShort,
  HealthCheckFailed_0 as HealthCheckFailed,
  InvalidPunchId_0 as InvalidPunchId,
  BrowserAttestationRequired as BrowserAttestationRequired,
  BrowserAttestation as BrowserAttestation,
  BrowserAttestationContent as BrowserAttestationContent,
  BrowserAttestationResponse as BrowserAttestationResponse,
  BrowserClockRole as BrowserClockRole,
  BrowserClockDepartment as BrowserClockDepartment,
  BrowserDepartmentSelectionRequired as BrowserDepartmentSelectionRequired,
  BrowserHealthCheckRequired as BrowserHealthCheckRequired,
  BrowserHealthCheckQuestionnaire as BrowserHealthCheckQuestionnaire,
  BrowserHealthCheckQuestion as BrowserHealthCheckQuestion,
  BrowserHealthCheckResponse as BrowserHealthCheckResponse,
  BrowserHealthCheckAnswer as BrowserHealthCheckAnswer,
  BrowserRoleSelectionRequired as BrowserRoleSelectionRequired,
  TipsNeeded_0 as TipsNeeded,
  BrowserStartShiftAction as BrowserStartShiftAction,
  BrowserStartUnscheduledShiftAction as BrowserStartUnscheduledShiftAction,
  BrowserClockOutAction as BrowserClockOutAction,
  BrowserStartPaidBreakAction as BrowserStartPaidBreakAction,
  BrowserStartUnpaidBreakAction as BrowserStartUnpaidBreakAction,
  BrowserStartCustomBreakAction as BrowserStartCustomBreakAction,
  BrowserEndBreakAction as BrowserEndBreakAction,
  BrowserBreak as BrowserBreak,
  BrowserClockedIn as BrowserClockedIn,
  BrowserClockedOut as BrowserClockedOut,
  BrowserCustomBreak as BrowserCustomBreak,
  BrowserOnBreak as BrowserOnBreak,
  BrowserPreferredShift as BrowserPreferredShift,
  BrowserRole as BrowserRole,
  BrowserPunch as BrowserPunch,
  BrowserShift as BrowserShift,
  BrowserUser as BrowserUser,
};
//endregion

